(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[845],{

/***/ 77075:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const ACCOUNT_CIRCLE = 'M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z';
const IconAccountCircle = lib.variant('IconAccountCircle', icon.Icon, {
    path: ACCOUNT_CIRCLE,
});

exports.$ = IconAccountCircle;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 95370:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const EDIT = 'M20.712 7.032L18.888 8.856L15.144 5.112L16.968 3.288C17.16 3.096 17.396 3 17.676 3C17.956 3 18.192 3.096 18.384 3.288L20.712 5.616C20.904 5.808 21 6.044 21 6.324C21 6.604 20.904 6.84 20.712 7.032ZM3 17.256L14.064 6.192L17.808 9.936L6.744 21H3V17.256Z';
const IconEdit = lib.variant('IconEdit', icon.Icon, {
    path: EDIT,
});

exports.y = IconEdit;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 59141:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const LIKE_OUTLINED = 'M13.7647 4L14.6471 4.86331C14.8693 5.08074 14.9804 5.35571 14.9804 5.68825V5.95683L14.1765 9.6211H19.3529C19.7974 9.6211 20.183 9.77458 20.5098 10.0815C20.8366 10.3885 21 10.7594 21 11.1942L20.9608 11.271H21V12.8058C21 13.0104 20.9608 13.2086 20.8824 13.4005L18.3922 19.0216C18.2876 19.3157 18.098 19.5524 17.8235 19.7314C17.549 19.9105 17.2418 20 16.902 20H9.54902C9.10457 20 8.71895 19.8401 8.39216 19.5204C8.06536 19.2006 7.90196 18.8233 7.90196 18.3885V10.4077C7.90196 9.9984 8.06536 9.6211 8.39216 9.27578L13.7647 4ZM6.29412 10.4077V20H3V10.4077H6.29412ZM13.3275 6.49891L9.49733 10.2592C9.43197 10.3283 9.41015 10.3623 9.40404 10.3888L9.40196 10.4077V18.3885C9.40196 18.4242 9.40452 18.439 9.42733 18.4652L9.45756 18.4965C9.49392 18.5321 9.50509 18.5418 9.52497 18.5445L9.54902 18.5455H16.902L16.9468 18.5421C16.9526 18.5409 16.9579 18.5393 16.963 18.5373L16.9823 18.5265L17.0139 18.4475L19.4879 12.8644L19.4973 12.8348L19.5 12.8058V11.6073L19.4983 11.5994C19.4682 11.4749 19.4547 11.3457 19.46 11.2148L19.4662 11.1265C19.4296 11.0919 19.4136 11.0806 19.3858 11.0771L19.3529 11.0756H14.1765C13.2591 11.0756 12.5659 10.2876 12.6904 9.42256L12.7093 9.31843L13.3275 6.49891Z';
const IconLikeOutlined = lib.variant('IconLikeOutlined', icon.Icon, {
    path: LIKE_OUTLINED,
});

exports.q = IconLikeOutlined;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 17471:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const MINUS = 'M6 12.75L6 11.25L18 11.25V12.75L6 12.75Z';
const IconMinus = lib.variant('IconMinus', icon.Icon, {
    path: MINUS,
});

exports.U = IconMinus;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 54497:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const SHOPPING_CART = 'M17.4173 17.4087C17.9065 17.4087 18.3237 17.5889 18.6691 17.9495C19.0144 18.3101 19.187 18.7356 19.187 19.226C19.187 19.7163 19.0144 20.1346 18.6691 20.4808C18.3237 20.8269 17.9065 21 17.4173 21C16.9281 21 16.5036 20.8269 16.1439 20.4808C15.7842 20.1346 15.6043 19.7163 15.6043 19.226C15.6043 18.7356 15.7842 18.3101 16.1439 17.9495C16.5036 17.5889 16.9281 17.4087 17.4173 17.4087ZM3 3H5.95683L6.79856 4.77404H20.1151C20.3597 4.77404 20.5683 4.86418 20.741 5.04447C20.9137 5.22476 21 5.44471 21 5.70433C21 5.86298 20.9568 6 20.8705 6.11538L17.6763 11.9567C17.518 12.2308 17.2986 12.4543 17.018 12.6274C16.7374 12.8005 16.4317 12.887 16.1007 12.887H9.41007L8.61151 14.3582L8.56835 14.488C8.56835 14.5457 8.58993 14.5962 8.63309 14.6394C8.67626 14.6827 8.72662 14.7043 8.78417 14.7043H19.187V16.5216H8.39568C7.90647 16.5216 7.48921 16.3413 7.14388 15.9808C6.79856 15.6202 6.6259 15.1947 6.6259 14.7043C6.6259 14.4303 6.69784 14.149 6.84173 13.8606L8.05036 11.6106L4.81295 4.77404H3V3ZM8.39568 17.4087C8.88489 17.4087 9.30935 17.5889 9.66906 17.9495C10.0288 18.3101 10.2086 18.7356 10.2086 19.226C10.2086 19.7163 10.0288 20.1346 9.66906 20.4808C9.30935 20.8269 8.88489 21 8.39568 21C7.90647 21 7.48921 20.8269 7.14388 20.4808C6.79856 20.1346 6.6259 19.7163 6.6259 19.226C6.6259 18.7356 6.79856 18.3101 7.14388 17.9495C7.48921 17.5889 7.90647 17.4087 8.39568 17.4087Z';
const IconShoppingCart = lib.variant('IconShoppingCart', icon.Icon, {
    path: SHOPPING_CART,
});

exports.w = IconShoppingCart;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 40000:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const STAR = 'M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z';
const IconStar = lib.variant('IconStar', icon.Icon, {
    path: STAR,
});

exports.G = IconStar;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 31420:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 88987:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hashClear = __webpack_require__(71519),
    hashDelete = __webpack_require__(82999),
    hashGet = __webpack_require__(76111),
    hashHas = __webpack_require__(50506),
    hashSet = __webpack_require__(80845);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 175:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var listCacheClear = __webpack_require__(2173),
    listCacheDelete = __webpack_require__(33752),
    listCacheGet = __webpack_require__(10548),
    listCacheHas = __webpack_require__(63410),
    listCacheSet = __webpack_require__(3564);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 35922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 9440:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var mapCacheClear = __webpack_require__(7140),
    mapCacheDelete = __webpack_require__(56504),
    mapCacheGet = __webpack_require__(88833),
    mapCacheHas = __webpack_require__(80953),
    mapCacheSet = __webpack_require__(70724);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 6795:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 81956:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 5929:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    stackClear = __webpack_require__(40551),
    stackDelete = __webpack_require__(4090),
    stackGet = __webpack_require__(47694),
    stackHas = __webpack_require__(86220),
    stackSet = __webpack_require__(68958);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 92210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 69477:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 93501:
/***/ ((module) => {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 79809:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseTimes = __webpack_require__(39739),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isIndex = __webpack_require__(91010),
    isTypedArray = __webpack_require__(73806);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 72340:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseAssignValue = __webpack_require__(30404),
    eq = __webpack_require__(42448);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 93719:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseAssignValue = __webpack_require__(30404),
    eq = __webpack_require__(42448);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 62718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__(42448);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 30404:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineProperty = __webpack_require__(34082);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 91348:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(36838);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 91030:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createBaseFor = __webpack_require__(29);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 84742:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 58939:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isMasked = __webpack_require__(90654),
    isObject = __webpack_require__(36838),
    toSource = __webpack_require__(51059);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 22882:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isLength = __webpack_require__(17216),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 87473:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isPrototype = __webpack_require__(92963),
    nativeKeys = __webpack_require__(14457);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 52506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(36838),
    isPrototype = __webpack_require__(92963),
    nativeKeysIn = __webpack_require__(10814);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 97254:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(5929),
    assignMergeValue = __webpack_require__(72340),
    baseFor = __webpack_require__(91030),
    baseMergeDeep = __webpack_require__(10715),
    isObject = __webpack_require__(36838),
    keysIn = __webpack_require__(37390),
    safeGet = __webpack_require__(72014);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 10715:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assignMergeValue = __webpack_require__(72340),
    cloneBuffer = __webpack_require__(39767),
    cloneTypedArray = __webpack_require__(27136),
    copyArray = __webpack_require__(47165),
    initCloneObject = __webpack_require__(36404),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isArrayLikeObject = __webpack_require__(57348),
    isBuffer = __webpack_require__(61563),
    isFunction = __webpack_require__(92042),
    isObject = __webpack_require__(36838),
    isPlainObject = __webpack_require__(69143),
    isTypedArray = __webpack_require__(73806),
    safeGet = __webpack_require__(72014),
    toPlainObject = __webpack_require__(85111);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 5125:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var identity = __webpack_require__(48148),
    overRest = __webpack_require__(20323),
    setToString = __webpack_require__(71564);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 56447:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var constant = __webpack_require__(64806),
    defineProperty = __webpack_require__(34082),
    identity = __webpack_require__(48148);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 39739:
/***/ ((module) => {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 58792:
/***/ ((module) => {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 78925:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Uint8Array = __webpack_require__(92210);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 39767:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 27136:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var cloneArrayBuffer = __webpack_require__(78925);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 47165:
/***/ ((module) => {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 92434:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assignValue = __webpack_require__(93719),
    baseAssignValue = __webpack_require__(30404);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 36633:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 77991:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseRest = __webpack_require__(5125),
    isIterateeCall = __webpack_require__(97616);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 29:
/***/ ((module) => {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 34082:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 67707:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isKeyable = __webpack_require__(3880);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 47758:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsNative = __webpack_require__(58939),
    getValue = __webpack_require__(9149);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 11389:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var overArg = __webpack_require__(75542);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 81887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DataView = __webpack_require__(31420),
    Map = __webpack_require__(35922),
    Promise = __webpack_require__(6795),
    Set = __webpack_require__(81956),
    WeakMap = __webpack_require__(69477),
    baseGetTag = __webpack_require__(80732),
    toSource = __webpack_require__(51059);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 9149:
/***/ ((module) => {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 71519:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 82999:
/***/ ((module) => {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 76111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 50506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 80845:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 36404:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseCreate = __webpack_require__(91348),
    getPrototype = __webpack_require__(11389),
    isPrototype = __webpack_require__(92963);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 91010:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 97616:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__(42448),
    isArrayLike = __webpack_require__(47428),
    isIndex = __webpack_require__(91010),
    isObject = __webpack_require__(36838);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 3880:
/***/ ((module) => {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 90654:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var coreJsData = __webpack_require__(36633);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 92963:
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 2173:
/***/ ((module) => {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 33752:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 10548:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 63410:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 3564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 7140:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Hash = __webpack_require__(88987),
    ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 56504:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 88833:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 80953:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 70724:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 37722:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 14457:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var overArg = __webpack_require__(75542);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 10814:
/***/ ((module) => {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 8478:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(96476);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 75542:
/***/ ((module) => {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 20323:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var apply = __webpack_require__(93501);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 72014:
/***/ ((module) => {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 71564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseSetToString = __webpack_require__(56447),
    shortOut = __webpack_require__(15509);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 15509:
/***/ ((module) => {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 40551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 4090:
/***/ ((module) => {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 47694:
/***/ ((module) => {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 86220:
/***/ ((module) => {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 68958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922),
    MapCache = __webpack_require__(9440);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 51059:
/***/ ((module) => {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 64806:
/***/ ((module) => {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 42448:
/***/ ((module) => {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 48148:
/***/ ((module) => {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 30353:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsArguments = __webpack_require__(84742),
    isObjectLike = __webpack_require__(55073);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 24669:
/***/ ((module) => {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 47428:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isLength = __webpack_require__(17216);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 57348:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArrayLike = __webpack_require__(47428),
    isObjectLike = __webpack_require__(55073);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 61563:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165),
    stubFalse = __webpack_require__(84193);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 82691:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseKeys = __webpack_require__(87473),
    getTag = __webpack_require__(81887),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isArrayLike = __webpack_require__(47428),
    isBuffer = __webpack_require__(61563),
    isPrototype = __webpack_require__(92963),
    isTypedArray = __webpack_require__(73806);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 92042:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObject = __webpack_require__(36838);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 17216:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 69143:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    getPrototype = __webpack_require__(11389),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 73806:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsTypedArray = __webpack_require__(22882),
    baseUnary = __webpack_require__(58792),
    nodeUtil = __webpack_require__(8478);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 37390:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayLikeKeys = __webpack_require__(79809),
    baseKeysIn = __webpack_require__(52506),
    isArrayLike = __webpack_require__(47428);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 53954:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseMerge = __webpack_require__(97254),
    createAssigner = __webpack_require__(77991);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ 84193:
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 85111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyObject = __webpack_require__(92434),
    keysIn = __webpack_require__(37390);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 89268:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25670);
/* harmony import */ var src_components_spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61061);




var SubmitButton = function(props) {
    var text = props.text, loading = props.loading, style = props.style, onClick = props.onClick, className = props.className, type = props.type, htmlType = props.htmlType;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_2__.PrimaryButton, {
        className: className,
        onClick: onClick,
        style: style,
        loading: loading,
        htmlType: type || htmlType
    }, !loading && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_2__.ButtonText, null, text), loading && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_2__.ButtonIcon, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_spinner__WEBPACK_IMPORTED_MODULE_3__/* .Spinner */ .$, {
        position: "none",
        isActive: true
    })));
};
SubmitButton.propTypes = {
    loading: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    text: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    style: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
SubmitButton.defaultProps = {
    type: "submit",
    loading: false
};
/* harmony default export */ __webpack_exports__["Z"] = (SubmitButton);


/***/ }),

/***/ 33021:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony export handleSettingsAction */
/* harmony import */ var redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38247);
/* harmony import */ var _actions_alert_settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29559);
/* harmony import */ var _components_toast_container_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40744);
/* harmony import */ var _helpers_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18419);
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




function saveAlertSetting(setting) {
    var ref, response, ref1, _code, e;
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    5
                ]);
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .call */ .RE)(_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* .updateAlertSetting */ .a, setting.setting, setting.value)
                ];
            case 1:
                response = _state.sent();
                if ((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length) {
                    ;
                    ;
                    throw new Error((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code);
                }
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_actions_alert_settings__WEBPACK_IMPORTED_MODULE_1__/* .alertSettingsChangeSuccess */ .g5)(setting))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 3:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_actions_alert_settings__WEBPACK_IMPORTED_MODULE_1__/* .alertSettingsChangeFail */ .cA)(setting))
                ];
            case 4:
                _state.sent();
                throw new Error(e);
            case 5:
                return [
                    2
                ];
        }
    });
}
function handleSettingsAction(action) {
    var _, keys, i;
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                _ = action.type;
                switch(_){
                    case _actions_alert_settings__WEBPACK_IMPORTED_MODULE_1__/* .ALERT_SETTINGS_SAVE_REQUEST */ .oD:
                        return [
                            3,
                            1
                        ];
                    case _actions_alert_settings__WEBPACK_IMPORTED_MODULE_1__/* .ALERT_SETTINGS_CHANGE_REQUEST */ .E2:
                        return [
                            3,
                            7
                        ];
                }
                return [
                    3,
                    10
                ];
            case 1:
                keys = Object.keys(action.setting);
                i = 0;
                _state.label = 2;
            case 2:
                if (!(i < keys.length)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .call */ .RE)(saveAlertSetting, {
                        setting: keys[i],
                        value: action.setting[keys[i]]
                    })
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                i += 1;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_components_toast_container_actions__WEBPACK_IMPORTED_MODULE_2__/* .promptToast */ .Lf)("success", window.APP_GLOBALS.t("account", "settings.saved")))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    11
                ];
            case 7:
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .call */ .RE)(saveAlertSetting, action.setting)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_components_toast_container_actions__WEBPACK_IMPORTED_MODULE_2__/* .promptToast */ .Lf)("success", window.APP_GLOBALS.t("account", "settings.saved")))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    11
                ];
            case 10:
                {
                    return [
                        3,
                        11
                    ];
                }
                _state.label = 11;
            case 11:
                return [
                    2
                ];
        }
    });
}
function mySaga() {
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .takeLatest */ .Fm)([
                        _actions_alert_settings__WEBPACK_IMPORTED_MODULE_1__/* .ALERT_SETTINGS_SAVE_REQUEST */ .oD
                    ], handleSettingsAction)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .takeLatest */ .Fm)([
                        _actions_alert_settings__WEBPACK_IMPORTED_MODULE_1__/* .ALERT_SETTINGS_CHANGE_REQUEST */ .E2
                    ], handleSettingsAction)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
if (true) {
    window.registerSaga(mySaga);
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (mySaga)));


/***/ }),

/***/ 32311:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

var ReviewPrompt = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "reviews";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | reviews */ 912).then(__webpack_require__.bind(__webpack_require__, 60040));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(60040);
        }
        return eval("require.resolve")("./prompt");
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (ReviewPrompt);


/***/ }),

/***/ 47239:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ report)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(32741);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(95088);
// EXTERNAL MODULE: ./src/components/modal/index.tsx
var modal = __webpack_require__(94320);
// EXTERNAL MODULE: ./src/components/modal/actions.ts
var actions = __webpack_require__(43758);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/modal/confirm.styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  h2 {\n    font-size: ",
        ";\n    font-weight: 600;\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  .pj-ui-text-input {\n    margin-bottom: 0;\n  }\n\n  p {\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: flex-end;\n  justify-content: flex-end;\n  width: 100%;\n  button {\n    white-space: nowrap;\n    margin-left: ",
        ";\n    flex: 1;\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-0"
})(_templateObject());
var Title = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal);
var Body = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Body",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Footer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Footer",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/modal/confirm.js
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var ConfirmModal = function(_param) {
    var onCancel = _param.onCancel, onConfirm = _param.onConfirm, hideModal = _param.hideModal, props = _objectWithoutProperties(_param, [
        "onCancel",
        "onConfirm",
        "hideModal"
    ]);
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(modal/* default */.Z, {
        id: props.id,
        isOpen: props.isOpen,
        width: props.width,
        onRequestClose: function() {
            return onCancel === undefined ? hideModal() : onCancel();
        }
    }, /*#__PURE__*/ react.createElement(Content, null, props.title && /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement("h2", null, props.title)), /*#__PURE__*/ react.createElement(Body, null, props.children), /*#__PURE__*/ react.createElement(Footer, null, props.showCancel && /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        color: "primary",
        variant: "outlined",
        onClick: function() {
            return onCancel === undefined ? hideModal() : onCancel();
        }
    }, props.cancelLabel || t("common", "button.cancel")), /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        color: "positive",
        onClick: function() {
            return onConfirm === undefined ? hideModal() : onConfirm();
        }
    }, props.confirmLabel || t("common", "button.ok")))));
};
var func = (prop_types_default()).func, string = (prop_types_default()).string, bool = (prop_types_default()).bool, node = (prop_types_default()).node, number = (prop_types_default()).number;
ConfirmModal.propTypes = {
    hideModal: func.isRequired,
    onConfirm: func,
    onCancel: func,
    children: node,
    width: number,
    id: string,
    isOpen: bool,
    title: string,
    showCancel: bool,
    confirmLabel: string,
    cancelLabel: string
};
ConfirmModal.defaultProps = {
    onConfirm: undefined,
    onCancel: undefined,
    children: null,
    width: 400,
    id: undefined,
    isOpen: false,
    title: undefined,
    showCancel: false,
    confirmLabel: undefined,
    cancelLabel: undefined
};
/* harmony default export */ var modal_confirm = ((0,es/* connect */.$j)(null, actions/* default */.ZP)(/*#__PURE__*/ (0,react.memo)(ConfirmModal)));

// EXTERNAL MODULE: ./src/areas/reviews/actions/index.js
var reviews_actions = __webpack_require__(1067);
// EXTERNAL MODULE: ./src/areas/account/helpers/index.ts
var helpers = __webpack_require__(19590);
;// CONCATENATED MODULE: ./src/areas/reviews/components/report/index.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}









var ReportReviewModal = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(ReportReviewModal, _PureComponent);
    var _super = _createSuper(ReportReviewModal);
    function ReportReviewModal(props) {
        _classCallCheck(this, ReportReviewModal);
        var _this;
        _this = _super.call(this, props);
        _this.state = _this.getInitialState();
        return _this;
    }
    _createClass(ReportReviewModal, [
        {
            // eslint-disable-next-line class-methods-use-this
            key: "getInitialState",
            value: function getInitialState() {
                return {
                    errors: {},
                    message: "",
                    email: ""
                };
            }
        },
        {
            key: "sendReport",
            value: function sendReport(data) {
                var reviewId = data ? data.review : null;
                var errors = {
                    message: typeof data.message !== "string" || !data.message.trim().length,
                    email: typeof data.email !== "string" || !(0,helpers/* isValidEmail */.v)(data.email)
                };
                if (errors.message || errors.email) {
                    this.setState({
                        errors: errors
                    });
                } else {
                    this.props.reportReview(reviewId, data.message, data.email);
                    this.close();
                }
            }
        },
        {
            key: "close",
            value: function close() {
                this.props.onComplete();
                this.setState(this.getInitialState());
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var t = this.context.t;
                var errors = this.state.errors;
                var account = this.props.account;
                var email = account && account.me ? account.me.email : false;
                return /*#__PURE__*/ react.createElement(modal_confirm, {
                    isOpen: !!this.props.review,
                    showCancel: true,
                    confirmLabel: t("feedback", "report-review.send-button"),
                    title: t("feedback", "report-review.title"),
                    onCancel: function() {
                        return _this.close();
                    },
                    onConfirm: function() {
                        _this.sendReport({
                            review: _this.props.review,
                            message: _this.state.message,
                            email: email !== false ? email : _this.state.email
                        });
                    }
                }, /*#__PURE__*/ react.createElement(inputs/* TextArea */.Kx, {
                    onChange: function(e) {
                        return _this.setState({
                            message: e.target.value
                        });
                    },
                    name: "message",
                    label: t("feedback", "report-review.message-label"),
                    tabIndex: "0",
                    warning: !!errors.message,
                    helper: !errors.message ? t("feedback", "report-review.message-helper") : t("feedback", "error.field-is-required")
                }), !email && /*#__PURE__*/ react.createElement(inputs/* TextInput */.oi, {
                    onChange: function(e) {
                        return _this.setState({
                            email: e.target.value
                        });
                    },
                    name: "email",
                    label: t("feedback", "report-review.email-label"),
                    type: "email",
                    tabIndex: "0",
                    warning: !!errors.email,
                    helper: errors.email ? t("feedback", "error.field-is-required") : t("feedback", "report-review.email-helper")
                }));
            }
        }
    ]);
    return ReportReviewModal;
}(react.PureComponent);
ReportReviewModal.propTypes = {
    showModal: (prop_types_default()).func.isRequired,
    hideModal: (prop_types_default()).func.isRequired,
    reportReview: (prop_types_default()).func.isRequired,
    onComplete: (prop_types_default()).func.isRequired,
    account: prop_types_default().shape({
        me: (prop_types_default()).object
    }),
    review: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).string
    ])
};
ReportReviewModal.defaultProps = {
    account: {
        me: undefined
    },
    review: undefined
};
ReportReviewModal.contextType = app_context/* AppContext */.Il;
/* harmony default export */ var report = ((0,es/* connect */.$j)(function(state) {
    return {
        account: state.areas.account
    };
}, _objectSpread({}, actions/* default */.ZP, reviews_actions/* default */.ZP))(ReportReviewModal));


/***/ }),

/***/ 66884:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ data),
  "a": () => (/* reexport */ useGraphQLQuery)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/mergeWith.js
var mergeWith = __webpack_require__(53954);
var mergeWith_default = /*#__PURE__*/__webpack_require__.n(mergeWith);
// EXTERNAL MODULE: ./src/components/fetch-context.ts
var fetch_context = __webpack_require__(4916);
;// CONCATENATED MODULE: ./src/components/data/hooks.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};


function useGraphQLQuery(options) {
    var query = options.query, variables = options.variables, refreshOnMount = options.refreshOnMount;
    var fetchContext = (0,react.useContext)(fetch_context/* default */.Z);
    var ref = _slicedToArray((0,react.useState)(false), 2), loading = ref[0], setLoading = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(null), 2), data = ref1[0], setData = ref1[1];
    var refresh = (0,react.useCallback)(/*#__PURE__*/ _asyncToGenerator(function() {
        var response, err;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    setLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        fetchContext.query(query, variables)
                    ];
                case 2:
                    response = _state.sent();
                    setData(response.data);
                    return [
                        3,
                        5
                    ];
                case 3:
                    err = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error(err);
                    return [
                        3,
                        5
                    ];
                case 4:
                    setLoading(false);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchContext,
        query,
        variables
    ]);
    (0,react.useEffect)(function() {
        if (refreshOnMount) {
            refresh();
        }
    }, []);
    return {
        loading: loading,
        data: data,
        refresh: refresh
    };
}

;// CONCATENATED MODULE: ./src/components/data/index.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function data_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function data_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                data_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                data_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var data_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};





var Data = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(Data, _Component);
    var _super = _createSuper(Data);
    function Data(props) {
        _classCallCheck(this, Data);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            fetching: true,
            showLoader: true,
            data: null,
            errors: null,
            offset: 0
        };
        return _this;
    }
    _createClass(Data, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.state.fetching) {
                    return;
                }
                if (this.props.refreshKey !== prevProps.refreshKey) {
                    this.refresh();
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.run();
            }
        },
        {
            key: "run",
            value: function run() {
                var _this = this;
                return data_asyncToGenerator(function() {
                    var _props, fetchContext, query, variables, response;
                    return data_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _props = _this.props, fetchContext = _props.fetchContext, query = _props.query, variables = _props.variables;
                                _this.setState({
                                    data: null,
                                    errors: null,
                                    fetching: true,
                                    showLoader: true
                                });
                                return [
                                    4,
                                    fetchContext.query(query, variables)
                                ];
                            case 1:
                                response = _state.sent();
                                _this.setState(_objectSpreadProps(_objectSpread({}, response), {
                                    fetching: false,
                                    showLoader: false
                                }));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this = this;
                return data_asyncToGenerator(function() {
                    var _props, fetchContext, query, variables, ref, data, errors;
                    return data_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _props = _this.props, fetchContext = _props.fetchContext, query = _props.query, variables = _props.variables;
                                _this.setState({
                                    fetching: true
                                });
                                return [
                                    4,
                                    fetchContext.query(query, variables)
                                ];
                            case 1:
                                ref = _state.sent(), data = ref.data, errors = ref.errors;
                                _this.setState({
                                    data: data,
                                    errors: errors,
                                    fetching: false
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "mutation",
            value: function mutation(query, variables) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return data_asyncToGenerator(function() {
                    var _showLoader, showLoader, _refresh, refresh, ref, data, errors;
                    return data_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _showLoader = options.showLoader, showLoader = _showLoader === void 0 ? false : _showLoader, _refresh = options.refresh, refresh = _refresh === void 0 ? true : _refresh;
                                return [
                                    4,
                                    _this.props.fetchContext.query(query, variables)
                                ];
                            case 1:
                                ref = _state.sent(), data = ref.data, errors = ref.errors;
                                _this.setState({
                                    fetching: true,
                                    showLoader: showLoader
                                });
                                if (!refresh) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.refresh()
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    {
                                        data: data,
                                        errors: errors
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchMore",
            value: function fetchMore() {
                var _this = this;
                return data_asyncToGenerator(function() {
                    var _props, fetchContext, query, variables, newOffset, ref, data, errors;
                    return data_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.props.variables.limit) {
                                    throw new Error("Need limit variables in <Data> to fetch more");
                                }
                                _this.setState({
                                    fetching: true
                                });
                                _props = _this.props, fetchContext = _props.fetchContext, query = _props.query, variables = _props.variables;
                                newOffset = _this.state.offset + variables.limit;
                                return [
                                    4,
                                    fetchContext.query(query, _objectSpreadProps(_objectSpread({}, variables), {
                                        offset: newOffset
                                    }))
                                ];
                            case 1:
                                ref = _state.sent(), data = ref.data, errors = ref.errors;
                                _this.setState(function(prevState) {
                                    return {
                                        offset: newOffset,
                                        fetching: false,
                                        data: mergeWith_default()({}, prevState.data, data, function(objValue, srcValue, key) {
                                            if ((!_this.props.nodeListKey || key === _this.props.nodeListKey) && Array.isArray(objValue)) {
                                                return objValue.concat(srcValue);
                                            }
                                            return undefined;
                                        }),
                                        errors: errors
                                    };
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                if (this.state.fetching && this.state.showLoader) {
                    return this.props.renderLoader();
                }
                if (this.state.errors) {
                    return this.props.renderError();
                }
                return this.props.render(_objectSpreadProps(_objectSpread({}, this.state), {
                    refresh: function() {
                        return _this.refresh();
                    },
                    mutation: function(q, v, o) {
                        return _this.mutation(q, v, o);
                    },
                    fetchMore: function() {
                        return _this.fetchMore();
                    }
                }));
            }
        }
    ]);
    return Data;
}(react.Component);
var func = (prop_types_default()).func, string = (prop_types_default()).string, shape = (prop_types_default()).shape, object = (prop_types_default()).object;
Data.propTypes = {
    fetchContext: shape({
        query: func
    }).isRequired,
    query: string.isRequired,
    variables: object,
    renderLoader: func,
    renderError: func,
    render: func.isRequired,
    nodeListKey: string,
    refreshKey: string
};
Data.defaultProps = {
    variables: {},
    renderLoader: function() {
        return null;
    },
    renderError: function() {
        return null;
    },
    refreshKey: undefined
};
/* harmony default export */ function data(props) {
    return /*#__PURE__*/ react.createElement(fetch_context/* default.Consumer */.Z.Consumer, null, function(fetchContext) {
        return /*#__PURE__*/ react.createElement(Data, _extends({}, props, {
            fetchContext: fetchContext
        }));
    });
};


/***/ }),

/***/ 75315:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": () => (/* binding */ EmptyState)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29261);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94141);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25349);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        " 0 ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var EmptyState = function(props) {
    var illustration = props.illustration, altText = props.altText, style = props.style;
    var market = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_4__/* .useAppContext */ .bp)().market;
    var baseIllustrationPath = "/g/rfe/illustrations/";
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_1__.Row, {
        equallySizedChildren: true,
        style: style
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IllustrationWrapper, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
        src: "".concat(market.cdn).concat(baseIllustrationPath).concat(illustration),
        alt: altText,
        style: {
            maxWidth: "310px"
        }
    })));
};
var IllustrationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    displayName: "IllustrationWrapper",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing125 */ .bK.measurements.spacing125);


/***/ }),

/***/ 92633:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ tabs)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/tabs-new/index.tsx + 1 modules
var tabs_new = __webpack_require__(6381);
;// CONCATENATED MODULE: ./src/areas/account/profile/components/tabs/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var NAV_HEIGHT = 55;
var Tabs = (0,styled_components_browser_esm["default"])(tabs_new/* Tabs */.m).withConfig({
    displayName: "Tabs",
    componentId: "sc-0-0"
})(_templateObject(), NAV_HEIGHT);

// EXTERNAL MODULE: ./src/areas/account/profile/types.ts
var types = __webpack_require__(14468);
;// CONCATENATED MODULE: ./src/areas/account/profile/components/tabs/index.tsx





var createTabPath = function(currentTab, pathTab, pathname) {
    // Append the clicked tab to URL if on the landing page
    if (!pathname.includes(currentTab)) {
        return "".concat(pathname.replace(/\/$/, ""), "/").concat(pathTab);
    }
    return pathname.replace(/\/$/, "").replace(currentTab, pathTab);
};
var ProfileTabs = function(param) {
    var isMe = param.isMe, tab = param.tab, reviewCount = param.reviewCount;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var pathname = (0,react_router_dom/* useLocation */.TH)().pathname;
    var reviewsPath = createTabPath(tab, types/* Tabs.Reviews */.m.Reviews, pathname);
    var listsPath = createTabPath(tab, types/* Tabs.Lists */.m.Lists, pathname);
    var getTabs = function() {
        var tabs = [
            {
                active: tab === types/* Tabs.Reviews */.m.Reviews,
                id: types/* Tabs.Reviews */.m.Reviews,
                title: reviewCount ? "".concat(t("account", "profile.tab-reviews"), " (").concat(reviewCount, ")") : t("account", "profile.tab-reviews"),
                to: reviewsPath
            }
        ];
        if (isMe) {
            tabs.push({
                active: tab === types/* Tabs.Settings */.m.Settings,
                id: types/* Tabs.Settings */.m.Settings,
                title: t("account", "menu.settings"),
                to: "/account/profile/settings"
            });
            tabs.push({
                active: tab === types/* Tabs.ShopPreference */.m.ShopPreference,
                id: types/* Tabs.ShopPreference */.m.ShopPreference,
                title: t("account", "shop-preference.tab-title"),
                to: "/account/profile/shop-preference"
            });
        } else {
            tabs.push({
                active: tab === types/* Tabs.Lists */.m.Lists,
                id: types/* Tabs.Lists */.m.Lists,
                title: t("lists", "lists.title"),
                to: listsPath
            });
        }
        return tabs;
    };
    return /*#__PURE__*/ react.createElement(Tabs, {
        tabs: getTabs()
    });
};
/* harmony default export */ var tabs = (ProfileTabs);


/***/ }),

/***/ 47216:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ user_info)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
;// CONCATENATED MODULE: ./src/areas/account/profile/components/icons/contributions.tsx

var ContributionIcon = function(param) {
    var className = param.className, _color = param.color, color = _color === void 0 ? "currentColor" : _color, _size = param.size, size = _size === void 0 ? 24 : _size;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(0 -4)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: color,
        fillRule: "nonzero",
        d: "M8 4c4.419 0 8 3.582 8 8a8 8 0 11-16 0 8 8 0 018-8zm0 2a5.978 5.978 0 00-3.468 1.103l-.79-.79a7.147 7.147 0 00-1.417 1.416l.789.789A5.97 5.97 0 002 12c0 1.294.41 2.492 1.107 3.473l-.786.785c.403.536.88 1.013 1.416 1.416l.785-.784A5.972 5.972 0 008 18c1.299 0 2.5-.413 3.483-1.114l.784.784a7.142 7.142 0 001.415-1.417l-.785-.785A5.973 5.973 0 0014 12a5.972 5.972 0 00-1.11-3.478l.788-.788a7.115 7.115 0 00-1.416-1.416l-.79.788A5.971 5.971 0 008 6zm0 1.784a4.217 4.217 0 11-.001 8.433A4.217 4.217 0 018 7.784zM8 10a2 2 0 10-.001 3.999A2 2 0 008 10z"
    })));
};
/* harmony default export */ var contributions = (ContributionIcon);

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/account-circle/index.js
var account_circle = __webpack_require__(77075);
;// CONCATENATED MODULE: ./src/areas/account/profile/components/user-info/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  border-bottom: 1px solid ",
        ";\n  padding-bottom: ",
        ";\n  &::after {\n    content: '';\n    top: ",
        "px;\n    left: 0;\n    right: 0;\n    bottom: calc(-1 * ",
        ");\n    background: ",
        ";\n    border-radius: 6px;\n    z-index: -1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n  height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  margin-top: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: ",
        "px;\n  width: ",
        "px;\n\n  img {\n    height: ",
        "px;\n    width: ",
        "px;\n    border-radius: 50%;\n    border: 2px solid #000;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: ",
        ";\n  right: ",
        ";\n  height: 22px;\n  width: 22px;\n  border-radius: 50%;\n  background-color: #007bff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid white;\n  cursor: pointer;\n\n  span {\n    font-size: 16px;\n    font-weight: 700;\n    color: white;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: 3px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: normal;\n  margin: 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  font-weight: 600;\n  padding-top: ",
        ";\n  flex-wrap: wrap;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  height: 18px;\n  padding-right: ",
        ";\n  svg,\n  svg path {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}



var avatarSize = 56;
var UserInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UserInfo",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.lines.secondary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, avatarSize / 2, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.bg.secondary;
});
var LogoContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LogoContainer",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var MemberInfoContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MemberInfoContainer",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Avatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Avatar",
    componentId: "sc-0-3"
})(_templateObject3(), avatarSize, avatarSize, avatarSize, avatarSize);
var AddButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AddButton",
    componentId: "sc-0-4"
})(_templateObject4(), function(props) {
    return props.bottom || "-2px";
}, function(props) {
    return props.right || "-2px";
});
var FallbackAvatar = (0,styled_components_browser_esm["default"])(account_circle/* IconAccountCircle */.$).attrs({
    color: "base600"
}).withConfig({
    displayName: "FallbackAvatar",
    componentId: "sc-0-5"
})(_templateObject5());
var DisplayName = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "DisplayName",
    componentId: "sc-0-6"
})(_templateObject6());
var MemberDate = styled_components_browser_esm["default"].span.withConfig({
    displayName: "MemberDate",
    componentId: "sc-0-7"
})(_templateObject7(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, function(p) {
    return p.theme.text.tertiary;
});
var UserAvatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UserAvatar",
    componentId: "sc-0-8"
})(_templateObject8());
var UserDetails = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UserDetails",
    componentId: "sc-0-9"
})(_templateObject9());
var Summary = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Summary",
    componentId: "sc-0-10"
})(_templateObject10(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var SummaryValue = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SummaryValue",
    componentId: "sc-0-11"
})(_templateObject11(), base/* layout.measurements.fontSizeLarge */.bK.measurements.fontSizeLarge, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var SummaryName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SummaryName",
    componentId: "sc-0-12"
})(_templateObject12(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var SummaryIcon = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SummaryIcon",
    componentId: "sc-0-13"
})(_templateObject13(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(p) {
    return p.theme.icons.callToAction;
});
var SummaryItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SummaryItem",
    componentId: "sc-0-14"
})(_templateObject14());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/eye/index.js
var eye = __webpack_require__(54630);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/like-filled/index.js
var like_filled = __webpack_require__(46304);
;// CONCATENATED MODULE: ./src/areas/account/profile/components/user-info/index.tsx






var user_info_UserInfo = function(param) {
    var avatar = param.avatar, displayName = param.displayName, reviewCount = param.reviewCount, memberSince = param.memberSince, _viewCount = param.viewCount, viewCount = _viewCount === void 0 ? 0 : _viewCount, _voteCount = param.voteCount, voteCount = _voteCount === void 0 ? 0 : _voteCount, _isMe = param.isMe, isMe = _isMe === void 0 ? false : _isMe;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var summaryItems = /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SummaryItem, null, /*#__PURE__*/ react.createElement(SummaryIcon, null, /*#__PURE__*/ react.createElement(contributions, {
        size: 16
    })), /*#__PURE__*/ react.createElement(SummaryValue, null, reviewCount !== null && reviewCount !== void 0 ? reviewCount : 0), /*#__PURE__*/ react.createElement(SummaryName, null, t("account", "statistics.contributions"))), /*#__PURE__*/ react.createElement(SummaryItem, null, /*#__PURE__*/ react.createElement(SummaryIcon, null, /*#__PURE__*/ react.createElement(like_filled/* IconLikeFilled */.G, {
        size: 18
    })), /*#__PURE__*/ react.createElement(SummaryValue, null, voteCount !== null && voteCount !== void 0 ? voteCount : 0), /*#__PURE__*/ react.createElement(SummaryName, null, t("account", "statistics.helpful-votes"))), viewCount ? /*#__PURE__*/ react.createElement(SummaryItem, null, /*#__PURE__*/ react.createElement(SummaryIcon, null, /*#__PURE__*/ react.createElement(eye.IconEye, {
        size: 18
    })), /*#__PURE__*/ react.createElement(SummaryValue, null, viewCount), /*#__PURE__*/ react.createElement(SummaryName, null, t("account", "statistics.views"))) : null, " ");
    return /*#__PURE__*/ react.createElement(UserInfo, null, /*#__PURE__*/ react.createElement(LogoContainer, null, /*#__PURE__*/ react.createElement(UserAvatar, null, avatar ? /*#__PURE__*/ react.createElement(Avatar, null, /*#__PURE__*/ react.createElement("img", {
        src: avatar,
        alt: isMe ? "Your user profile avatar" : "User profile avatar"
    })) : /*#__PURE__*/ react.createElement(FallbackAvatar, {
        size: 56
    }))), /*#__PURE__*/ react.createElement(MemberInfoContainer, null, /*#__PURE__*/ react.createElement(UserDetails, null, /*#__PURE__*/ react.createElement(DisplayName, null, displayName), memberSince && /*#__PURE__*/ react.createElement(MemberDate, null, t("account", "statistics.join-date", {
        date: memberSince
    }))), /*#__PURE__*/ react.createElement(Summary, null, summaryItems)));
};
/* harmony default export */ var user_info = (/*#__PURE__*/(0,react.memo)(user_info_UserInfo));


/***/ }),

/***/ 14468:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": () => (/* binding */ Tabs)
/* harmony export */ });
var Tabs;
(function(Tabs) {
    Tabs["Reviews"] = "reviews";
    Tabs["Alerts"] = "alerts";
    Tabs["Lists"] = "lists";
    Tabs["Settings"] = "settings";
    Tabs["ShopPreference"] = "shop-preference";
})(Tabs || (Tabs = {}));


/***/ }),

/***/ 24137:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MyProfilePageLoader": () => (/* binding */ MyProfilePageLoader),
  "default": () => (/* binding */ my_profile)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(64799);
// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(88999);
// EXTERNAL MODULE: ./src/components/number-pagination/index.tsx + 3 modules
var number_pagination = __webpack_require__(49192);
// EXTERNAL MODULE: ./src/areas/sidebar/views/alerts/index.tsx
var alerts = __webpack_require__(61082);
// EXTERNAL MODULE: ./src/areas/sidebar/views/lists/index.tsx
var lists = __webpack_require__(29865);
// EXTERNAL MODULE: ./src/areas/sidebar/views/list/index.tsx
var list = __webpack_require__(11024);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(79393);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/clickable/index.js
var clickable = __webpack_require__(42007);
// EXTERNAL MODULE: ./packages/frontend-admin-ui/dist/module.js + 1 modules
var dist_module = __webpack_require__(53254);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/outgoing-link/index.js
var outgoing_link = __webpack_require__(89975);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/hooks/use-account.ts + 1 modules
var use_account = __webpack_require__(53082);
// EXTERNAL MODULE: ./src/areas/account/settings/actions/settings.js
var actions_settings = __webpack_require__(17686);
// EXTERNAL MODULE: ./src/areas/account/settings/actions/display-name.js
var display_name = __webpack_require__(25526);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(32741);
;// CONCATENATED MODULE: ./src/areas/account/settings/components/setting/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: ",
        ";\n  padding-top: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  float: right;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  color: ",
        ";\n  text-align: center;\n  line-height: 1.5;\n  &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Setting = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Setting",
    componentId: "sc-0-0"
})(_templateObject());
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var EditButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EditButton",
    componentId: "sc-0-2"
})(_templateObject2());
var Input = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Input",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Link = styled_components_browser_esm["default"].button.withConfig({
    displayName: "Link",
    componentId: "sc-0-4"
})(_templateObject4(), function(p) {
    return p.theme.text.linkExternal;
}, function(p) {
    return p.theme.text.linkExternalHover;
});
var Value = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Value",
    componentId: "sc-0-5"
})(_templateObject5());


// EXTERNAL MODULE: ./src/areas/account/components/submit-button/index.js
var submit_button = __webpack_require__(89268);
;// CONCATENATED MODULE: ./src/areas/account/settings/components/cancel-or-save/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  cursor: pointer;\n  text-align: center;\n  line-height: 1.5;\n  margin: 0;\n  color: ",
        ";\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        ";\n  margin-bottom: ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  color: ",
        ";\n  text-align: center;\n  line-height: 1.5;\n  &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Cancel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Cancel",
    componentId: "sc-0-0"
})(styles_templateObject(), function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.theme.colors.maybeBlue500;
});
var Save = (0,styled_components_browser_esm["default"])(submit_button/* default */.Z).withConfig({
    displayName: "Save",
    componentId: "sc-0-1"
})(styles_templateObject1(), function(p) {
    return p.theme.colors.maybeBlue700;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return p.theme.colors.maybeBlue500;
});
var styles_Link = styled_components_browser_esm["default"].button.withConfig({
    displayName: "Link",
    componentId: "sc-0-2"
})(styles_templateObject2(), function(p) {
    return p.theme.text.linkExternal;
}, function(p) {
    return p.theme.text.linkExternalHover;
});

;// CONCATENATED MODULE: ./src/areas/account/settings/components/cancel-or-save/index.tsx


var SaveButton = function(props) {
    return /*#__PURE__*/ react.createElement(Save, {
        loading: props.showLoader,
        onClick: props.onSave,
        disabled: props.saveButtonDisabled,
        text: props.saveButtonText
    });
};
var CancelButton = function(props) {
    return /*#__PURE__*/ react.createElement(Cancel, null, /*#__PURE__*/ react.createElement(styles_Link, {
        type: "button",
        onClick: props.onCancel
    }, props.cancelButtonText));
};

;// CONCATENATED MODULE: ./src/areas/account/settings/components/setting/index.tsx




var setting_Setting = function(props) {
    var renderDefault = function renderDefault() {
        return /*#__PURE__*/ react.createElement("div", null, props.label, /*#__PURE__*/ react.createElement(EditButton, null, props.editable && /*#__PURE__*/ react.createElement(Link, {
            type: "button",
            onClick: function() {
                return props.onStartEditing();
            }
        }, t("common", "button.edit"))), /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(Value, null, props.value)));
    };
    var renderEditing = function renderEditing() {
        return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(Input, null, props.render(props.label, props.value)), /*#__PURE__*/ react.createElement(SaveButton, {
            showLoader: props.saving,
            onSave: function() {
                return props.onSave();
            },
            saveButtonDisabled: props.saveButtonDisabled,
            saveButtonText: t("common", "button.save")
        }));
    };
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(Setting, {
        "data-test": props["data-test"]
    }, props.editing ? renderEditing() : renderDefault());
};
/* harmony default export */ var setting = (setting_Setting);

;// CONCATENATED MODULE: ./src/areas/account/settings/components/input-value-setting/index.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var InputValueSetting = function(props) {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)(props.value || ""), 2), editingValue = ref[0], setEditingValue = ref[1];
    var handleChange = function(evt) {
        setEditingValue(evt.target.value);
    };
    var cancelChange = function() {
        setEditingValue(props.value);
        if (props.onStopEditing) props.onStopEditing();
    };
    var submitChange = function() {
        if (editingValue === props.value) {
            return;
        }
        if (props.value !== editingValue) {
            props.onChange(editingValue);
        }
    };
    var handleKeyUp = function(evt) {
        if (evt.key === "Enter") {
            submitChange();
        }
        if (evt.key === "Escape") {
            cancelChange();
        }
    };
    var renderEditing = function() {
        var label = props.label, inputType = props.inputType, variant = props.variant;
        return /*#__PURE__*/ react.createElement(inputs/* TextInput */.oi, {
            name: "input-setting",
            label: label,
            type: inputType,
            value: editingValue,
            onChange: handleChange,
            onKeyUp: handleKeyUp,
            tabIndex: 0,
            autoFocus: true,
            variant: variant,
            cancelButton: /*#__PURE__*/ react.createElement(CancelButton, {
                onCancel: cancelChange,
                cancelButtonText: t("common", "button.cancel")
            }),
            helper: props.error,
            warning: Boolean(props.error),
            maxLength: props.maxLength,
            // Do not send this element to CUX (cux.io)
            "data-cux-exclude": true
        });
    };
    var label = props.label, value = props.value, editable = props.editable, editing = props.editing, saving = props.saving, onStartEditing = props.onStartEditing, showLoader = props.showLoader;
    return /*#__PURE__*/ react.createElement(setting, {
        label: label,
        loading: Boolean(showLoader),
        value: value,
        editable: editable,
        editing: editing,
        saving: saving,
        saveButtonDisabled: editingValue === value,
        onStartEditing: onStartEditing,
        onSave: submitChange,
        render: function() {
            return renderEditing();
        }
    });
};
/* harmony default export */ var input_value_setting = (InputValueSetting);

;// CONCATENATED MODULE: ./src/areas/account/settings/components/profile-settings/styles.ts
function profile_settings_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function profile_settings_styles_templateObject() {
    var data = profile_settings_styles_taggedTemplateLiteral([
        "\n  > * {\n    padding: ",
        " 0;\n  }\n"
    ]);
    profile_settings_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var styles_Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(profile_settings_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/account/settings/components/profile-settings/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function profile_settings_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function profile_settings_templateObject() {
    var data = profile_settings_taggedTemplateLiteral([
        "\n  align-self: end;\n  margin-left: ",
        ";\n"
    ]);
    profile_settings_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function profile_settings_templateObject1() {
    var data = profile_settings_taggedTemplateLiteral([
        "\n  gap: 0;\n  margin-bottom: ",
        ";\n"
    ]);
    profile_settings_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var StyledIconOutgoingLink = (0,styled_components_browser_esm["default"])(outgoing_link/* IconOutgoingLink */.v).withConfig({
    displayName: "StyledIconOutgoingLink",
    componentId: "sc-0-0"
})(profile_settings_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledPanel = (0,styled_components_browser_esm["default"])(panel/* Panel */.s_).withConfig({
    displayName: "StyledPanel",
    componentId: "sc-0-1"
})(profile_settings_templateObject1(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200);
var ProfileSettings = function() {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var me = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.account.me;
    });
    var settings = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.account.settings;
    });
    var profilePageUrl = (0,use_account/* useAccount */.m)().profilePageUrl;
    var prisjaktAccountEnabled = (0,dist_module.useFeatureFlag)("pj-account");
    var getProfilePageHref = (0,react.useCallback)(function() {
        if (!prisjaktAccountEnabled) {
            return profilePageUrl();
        }
        var searchParams = new URLSearchParams();
        var returnUri = window.location.origin;
        if (returnUri) {
            searchParams.set("return_uri", returnUri);
        }
        return "/profile?".concat(searchParams.toString());
    }, [
        prisjaktAccountEnabled,
        profilePageUrl
    ]);
    var errors = settings === null || settings === void 0 ? void 0 : settings.errors;
    var displayName = me.displayName, email = me.email;
    var ref = settings || {}, _saving = ref.saving, saving = _saving === void 0 ? false : _saving, _editing = ref.editing, editing = _editing === void 0 ? undefined : _editing;
    (0,react.useEffect)(function() {
        return function() {
            // Resets editing mode
            (0,actions_settings/* startEditing */.Ud)();
        };
    }, []);
    var onStartEditing = function(type) {
        return dispatch((0,actions_settings/* startEditing */.Ud)(type));
    };
    var onChangeDisplayName = (0,react.useCallback)(function(data) {
        return dispatch((0,display_name/* displayNameChange */.Be)({
            displayName: data
        }));
    }, [
        dispatch
    ]);
    var inputEmailProps = {
        label: t("account", "input.email"),
        value: email,
        editable: false,
        editing: false,
        error: undefined,
        saving: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onStartEditing: function() {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onStopEditing: function() {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange: function() {}
    };
    return /*#__PURE__*/ react.createElement(StyledPanel, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("account", "settings.account-header")), /*#__PURE__*/ react.createElement(styles_Wrapper, null, /*#__PURE__*/ react.createElement(input_value_setting, {
        label: t("account", "input.display-name"),
        editable: !editing,
        editing: editing === "displayName",
        value: displayName,
        error: (errors === null || errors === void 0 ? void 0 : errors.displayName) ? t("errors", errors.displayName) : undefined,
        saving: saving,
        onStartEditing: function() {
            return onStartEditing("displayName");
        },
        onStopEditing: onStartEditing,
        onChange: onChangeDisplayName,
        minLength: 3,
        maxLength: 50,
        variant: "rounded"
    })), /*#__PURE__*/ react.createElement(styles_Wrapper, null, /*#__PURE__*/ react.createElement(input_value_setting, _extends({}, inputEmailProps, {
        variant: "rounded"
    }))), /*#__PURE__*/ react.createElement(styles_Wrapper, null, /*#__PURE__*/ react.createElement(clickable.Clickable, {
        container: "a",
        containerProps: {
            href: getProfilePageHref(),
            target: "_blank"
        }
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        flex: false
    }, t("account", "settings.profile-settings")), /*#__PURE__*/ react.createElement(StyledIconOutgoingLink, {
        size: 18
    }))));
};
/* harmony default export */ var profile_settings = (ProfileSettings);

// EXTERNAL MODULE: ./src/areas/account/settings/sagas/index.js
var sagas = __webpack_require__(73081);
// EXTERNAL MODULE: ./src/areas/account/settings/sagas/alerts.js
var sagas_alerts = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(57111);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(93345);
;// CONCATENATED MODULE: ./src/areas/account/settings/styles.ts
function settings_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function settings_styles_templateObject() {
    var data = settings_styles_taggedTemplateLiteral([
        "\n    padding-right: ",
        ";\n    padding-left: ",
        ";\n\n  "
    ]);
    settings_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function settings_styles_templateObject1() {
    var data = settings_styles_taggedTemplateLiteral([
        "\n    padding-left: ",
        ";\n    width: 50%;\n  "
    ]);
    settings_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function settings_styles_templateObject2() {
    var data = settings_styles_taggedTemplateLiteral([
        "\n  border-top: none;\n  padding-top: ",
        ";\n  ",
        ";\n  ",
        ";\n\n  a {\n    text-decoration: underline;\n  }\n"
    ]);
    settings_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = settings_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    align-self: right;\n    flex-direction: column;\n  "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = settings_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n  h2 {\n    font-weight: 600;\n    font-size: ",
        ";\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = settings_styles_taggedTemplateLiteral([
        "\n  padding-bottom: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = settings_styles_taggedTemplateLiteral([
        "\n  min-width: 100%;\n  &:hover {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = settings_styles_taggedTemplateLiteral([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var Settings = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Settings",
    componentId: "sc-0-0"
})(settings_styles_templateObject2(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* media.smallOnly */.BC.smallOnly(settings_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050), base/* media.mediumUp */.BC.mediumUp(settings_styles_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Container",
    componentId: "sc-0-1"
})(styles_templateObject4(), base/* media.mediumUp */.BC.mediumUp(styles_templateObject3()), base/* layout.measurements.fontSizeLarge */.bK.measurements.fontSizeLarge);
var PanelHeader = (0,styled_components_browser_esm["default"])(panel/* PanelTitle */.pY).withConfig({
    displayName: "PanelHeader",
    componentId: "sc-0-2"
})(styles_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var DrillDownButton = (0,styled_components_browser_esm["default"])(ui_text.Text).withConfig({
    displayName: "DrillDownButton",
    componentId: "sc-0-3"
})(_templateObject6());
var ChevronRightIcon = (0,styled_components_browser_esm["default"])(chevron_right.IconChevronRight).withConfig({
    displayName: "ChevronRightIcon",
    componentId: "sc-0-4"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/areas/account/settings/components/subscription-settings/styles.ts
function subscription_settings_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function subscription_settings_styles_templateObject() {
    var data = subscription_settings_styles_taggedTemplateLiteral([
        "\n  padding: ",
        " 0;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    subscription_settings_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function subscription_settings_styles_templateObject1() {
    var data = subscription_settings_styles_taggedTemplateLiteral([
        ""
    ]);
    subscription_settings_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function subscription_settings_styles_templateObject2() {
    var data = subscription_settings_styles_taggedTemplateLiteral([
        ""
    ]);
    subscription_settings_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function subscription_settings_styles_templateObject3() {
    var data = subscription_settings_styles_taggedTemplateLiteral([
        "\n  > div:not(:first-of-type) {\n    margin-top: ",
        ";\n  }\n"
    ]);
    subscription_settings_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var SettingWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SettingWrapper",
    componentId: "sc-0-0"
})(subscription_settings_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return p.theme.lines.secondary;
});
var SettingTitle = (0,styled_components_browser_esm["default"])(variants.TitleMediumText).withConfig({
    displayName: "SettingTitle",
    componentId: "sc-0-1"
})(subscription_settings_styles_templateObject1());
var SettingDescription = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "SettingDescription",
    componentId: "sc-0-2"
})(subscription_settings_styles_templateObject2());
var CheckboxWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CheckboxWrapper",
    componentId: "sc-0-3"
})(subscription_settings_styles_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(37456);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./src/areas/account/settings/components/subscription-settings/subscription-settings.graphql
var subscription_settings_graphql = __webpack_require__(12155);
var subscription_settings_graphql_default = /*#__PURE__*/__webpack_require__.n(subscription_settings_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(48458);
;// CONCATENATED MODULE: ./src/areas/account/settings/components/subscription-settings/queries/useSubscriptionSettings.ts


function useSubscriptionSettings() {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (subscription_settings_graphql_default()),
        routeName: "subscription-settings"
    });
}

;// CONCATENATED MODULE: ./src/areas/account/settings/components/subscription-settings/index.tsx
function subscription_settings_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function subscription_settings_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function subscription_settings_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function subscription_settings_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function subscription_settings_slicedToArray(arr, i) {
    return subscription_settings_arrayWithHoles(arr) || subscription_settings_iterableToArrayLimit(arr, i) || subscription_settings_unsupportedIterableToArray(arr, i) || subscription_settings_nonIterableRest();
}
function subscription_settings_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return subscription_settings_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return subscription_settings_arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};











var SubscriptionSettings = function(param) {
    var onGoBack = param.onGoBack;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = subscription_settings_slicedToArray((0,react.useState)([]), 2), subscriptionGroups = ref[0], setSubscriptionGroups = ref[1];
    var ref1 = useSubscriptionSettings(), isSuccess = ref1.isSuccess, subscriptionSettingsData = ref1.data;
    (0,react.useEffect)(function() {
        if (isSuccess && subscriptionSettingsData) {
            var mappedGroups = mapQueryToSubscriptiopnGroups(subscriptionSettingsData);
            setSubscriptionGroups(mappedGroups);
        }
    }, [
        subscriptionSettingsData,
        isSuccess
    ]);
    var handleSubscriptionChange = function() {
        var _ref = _asyncToGenerator(function(id, value, mail) {
            var updatedGroups;
            return __generator(this, function(_state) {
                dispatch((0,actions_settings/* updateSubscriptionSettingRequest */.Vi)(id, value));
                updatedGroups = subscriptionGroups.map(function(group) {
                    if (mail && group.mail === id) {
                        return _objectSpreadProps(_objectSpread({}, group), {
                            mailSubscribed: value
                        });
                    }
                    if (!mail && group.push === id) {
                        return _objectSpreadProps(_objectSpread({}, group), {
                            pushSubscribed: value
                        });
                    }
                    return group;
                });
                setSubscriptionGroups(updatedGroups);
                return [
                    2
                ];
            });
        });
        return function handleSubscriptionChange(id, value, mail) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleGoBack = function() {
        return onGoBack();
    };
    var renderCheckboxes = function(group) {
        var mailCheckbox = null;
        var pushCheckbox = null;
        var mailId = group.mail;
        if (mailId) {
            mailCheckbox = /*#__PURE__*/ react.createElement(inputs/* Checkbox */.XZ, {
                name: String(mailId),
                onChange: function(event) {
                    return handleSubscriptionChange(mailId, event.target.checked, true);
                },
                checked: group.mailSubscribed
            }, t("alerts", "settings.notify-by-email"));
        }
        var pushId = group.push;
        if (pushId) {
            pushCheckbox = /*#__PURE__*/ react.createElement(inputs/* Checkbox */.XZ, {
                name: String(pushId),
                onChange: function(event) {
                    return handleSubscriptionChange(pushId, event.target.checked, false);
                },
                checked: group.pushSubscribed
            }, t("alerts", "settings.notify-by-push"));
        }
        return /*#__PURE__*/ react.createElement(CheckboxWrapper, null, mailCheckbox, pushCheckbox);
    };
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(button_variants.OutlinedButton, {
        onClick: handleGoBack
    }, /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(chevron_left.IconChevronLeft, {
        size: 16
    })), /*#__PURE__*/ react.createElement(ui_button.ButtonText, null, /*#__PURE__*/ react.createElement(variants.TitleSmallText, null, t("account", "settings.back-to-settings")))), subscriptionGroups.map(function(group) {
        return /*#__PURE__*/ react.createElement(SettingWrapper, {
            key: group.title
        }, /*#__PURE__*/ react.createElement(SettingTitle, null, group.title), /*#__PURE__*/ react.createElement(SettingDescription, {
            container: "p"
        }, group.description), renderCheckboxes(group));
    }));
};
/* harmony default export */ var subscription_settings = (SubscriptionSettings);
var mapQueryToSubscriptiopnGroups = function(data) {
    return data.me.subscriptionSettings.map(function(setting) {
        var mailId = setting.channels.mail && Number(setting.channels.mail.id) || null;
        var pushId = setting.channels.push && Number(setting.channels.push.id) || null;
        var ref;
        var mailSubscribed = (ref = setting.channels.mail && setting.channels.mail.subscribed) !== null && ref !== void 0 ? ref : false;
        var ref1;
        var pushSubscribed = (ref1 = setting.channels.push && setting.channels.push.subscribed) !== null && ref1 !== void 0 ? ref1 : false;
        return {
            title: setting.title,
            description: setting.description,
            mail: mailId,
            mailSubscribed: mailSubscribed,
            push: pushId,
            pushSubscribed: pushSubscribed
        };
    });
};

;// CONCATENATED MODULE: ./src/areas/account/settings/index.tsx
function settings_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function settings_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function settings_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function settings_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function settings_slicedToArray(arr, i) {
    return settings_arrayWithHoles(arr) || settings_iterableToArrayLimit(arr, i) || settings_unsupportedIterableToArray(arr, i) || settings_nonIterableRest();
}
function settings_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return settings_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return settings_arrayLikeToArray(o, minLen);
}









var settings_Settings = function() {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = settings_slicedToArray((0,react.useState)(false), 2), showSubscriptionSettings = ref[0], setShowSubscriptionSettings = ref[1];
    return /*#__PURE__*/ react.createElement(Settings, null, /*#__PURE__*/ react.createElement(Container, null, showSubscriptionSettings ? /*#__PURE__*/ react.createElement(subscription_settings, {
        onGoBack: function() {
            return setShowSubscriptionSettings(false);
        }
    }) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(profile_settings, null), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(PanelHeader, null, t("account", "settings.notifications")), /*#__PURE__*/ react.createElement(DrillDownButton, {
        container: clickable.Clickable,
        containerProps: {
            onClick: function() {
                return setShowSubscriptionSettings(true);
            }
        }
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("account", "settings.notification-settings")), /*#__PURE__*/ react.createElement(ChevronRightIcon, null))))));
};
/* harmony default export */ var settings = (settings_Settings);

// EXTERNAL MODULE: ./src/areas/account/profile/components/user-info/index.tsx + 2 modules
var user_info = __webpack_require__(47216);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/shop.tsx
var shop = __webpack_require__(86370);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/product.tsx + 2 modules
var product = __webpack_require__(30979);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./src/areas/account/profile/components/tabs/index.tsx + 1 modules
var tabs = __webpack_require__(92633);
// EXTERNAL MODULE: ./src/components/recently-visited/index.ts
var recently_visited = __webpack_require__(24068);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(37702);
// EXTERNAL MODULE: ./src/areas/account/profile/components/empty-state/index.tsx
var empty_state = __webpack_require__(75315);
// EXTERNAL MODULE: ./src/ui/icons/index.ts + 4 modules
var icons = __webpack_require__(13686);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/star/index.js
var star = __webpack_require__(40000);
;// CONCATENATED MODULE: ./src/areas/account/profile/components/empty-reviews/placeholder.tsx



var ReviewCardPlaceholder = function(param) {
    var className = param.className, _type = param.type, type = _type === void 0 ? "product" : _type;
    return /*#__PURE__*/ react.createElement(Card, {
        className: className
    }, /*#__PURE__*/ react.createElement(Rating, null, type === "product" && /*#__PURE__*/ react.createElement(star/* IconStar */.G, {
        color: "staticBase200",
        size: 40
    }), type === "store" && /*#__PURE__*/ react.createElement(Smiley, {
        size: 40,
        ariaLabel: ""
    })), /*#__PURE__*/ react.createElement(Text, {
        width: 30
    }), /*#__PURE__*/ react.createElement(Text, {
        width: 100
    }), /*#__PURE__*/ react.createElement(Text, {
        width: 90
    }), /*#__PURE__*/ react.createElement(Text, {
        width: 70
    }));
};
/* harmony default export */ var placeholder = (ReviewCardPlaceholder);

;// CONCATENATED MODULE: ./src/areas/account/profile/components/empty-reviews/styles.ts
function empty_reviews_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function empty_reviews_styles_templateObject() {
    var data = empty_reviews_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    empty_reviews_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function empty_reviews_styles_templateObject1() {
    var data = empty_reviews_styles_taggedTemplateLiteral([
        "\n  padding: ",
        "  0;\n  font-size: ",
        ";\n  "
    ]);
    empty_reviews_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function empty_reviews_styles_templateObject2() {
    var data = empty_reviews_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-weight: 400;\n  ",
        ";\n"
    ]);
    empty_reviews_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function empty_reviews_styles_templateObject3() {
    var data = empty_reviews_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 600px;\n"
    ]);
    empty_reviews_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function empty_reviews_styles_templateObject4() {
    var data = empty_reviews_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  padding: ",
        ";\n\n  &:not(:last-of-type) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    empty_reviews_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function empty_reviews_styles_templateObject5() {
    var data = empty_reviews_styles_taggedTemplateLiteral([
        "\n  width: ",
        "%;\n  height: 16px;\n  margin-bottom: 6px;\n  background: ",
        ";\n  border-radius: 4px;\n"
    ]);
    empty_reviews_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = empty_reviews_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = empty_reviews_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  border-radius: 8px;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var EmptyReviews = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EmptyReviews",
    componentId: "sc-0-0"
})(empty_reviews_styles_templateObject());
var Title = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(empty_reviews_styles_templateObject2(), function(p) {
    return p.theme.text.quaternary;
}, base/* media.smallOnly */.BC.smallOnly(empty_reviews_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium));
var Placeholder = (0,styled_components_browser_esm["default"])(placeholder).withConfig({
    displayName: "Placeholder",
    componentId: "sc-0-2"
})(empty_reviews_styles_templateObject3());
var Card = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Card",
    componentId: "sc-0-3"
})(empty_reviews_styles_templateObject4(), function(p) {
    return p.theme.bg.secondary;
}, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Text = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Text",
    componentId: "sc-0-4"
})(empty_reviews_styles_templateObject5(), function(p) {
    return p.width;
}, function(p) {
    return p.theme.colors.staticBase200;
});
var Rating = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Rating",
    componentId: "sc-0-5"
})(styles_templateObject6(), function(p) {
    return p.theme.colors.staticBase200;
});
var Smiley = (0,styled_components_browser_esm["default"])(icons/* EmoticonNeutral */.sS).attrs(function(p) {
    return {
        color: p.theme.colors.staticBase400
    };
}).withConfig({
    displayName: "Smiley",
    componentId: "sc-0-6"
})(styles_templateObject7(), function(p) {
    return p.theme.colors.staticBase200;
});

;// CONCATENATED MODULE: ./src/areas/account/profile/components/empty-reviews/index.tsx




var empty_reviews_EmptyReviews = function(param) {
    var isMe = param.isMe;
    return /*#__PURE__*/ react.createElement(EmptyReviews, null, isMe ? /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "account"
    }, "profile.empty-reviews-title")) : null, /*#__PURE__*/ react.createElement(empty_state/* EmptyState */.u, {
        illustration: "no-product-reviews-illustration-400x218px.png",
        altText: "empty review illustration"
    }));
};
/* harmony default export */ var empty_reviews = (empty_reviews_EmptyReviews);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(29261);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(56853);
// EXTERNAL MODULE: ./src/ui/list-layouts/index.ts
var list_layouts = __webpack_require__(47252);
// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(27019);
// EXTERNAL MODULE: ./src/components/list-item/index.tsx
var list_item = __webpack_require__(91441);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(46256);
// EXTERNAL MODULE: ./src/components/entity-search/search-box/index.tsx + 10 modules
var search_box = __webpack_require__(98473);
// EXTERNAL MODULE: ./src/components/toast-container/actions/index.ts
var actions = __webpack_require__(40744);
// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(61061);
// EXTERNAL MODULE: ./src/areas/account/profile/components/shop-preference/query.graphql
var query_graphql = __webpack_require__(50132);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/areas/account/actions/index.js
var account_actions = __webpack_require__(42692);
// EXTERNAL MODULE: ./src/components/entity-search/container.tsx + 1 modules
var container = __webpack_require__(72418);
;// CONCATENATED MODULE: ./src/areas/account/profile/components/shop-preference/shop-preference.tsx
function shop_preference_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function shop_preference_templateObject() {
    var data = shop_preference_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    shop_preference_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function shop_preference_templateObject1() {
    var data = shop_preference_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: ",
        ";\n  box-shadow: none;\n\n  &:hover {\n    box-shadow: none;\n  }\n"
    ]);
    shop_preference_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function shop_preference_templateObject2() {
    var data = shop_preference_taggedTemplateLiteral([
        "\n  position: relative;\n  text-align: center;\n  padding: ",
        ";\n  color: ",
        ";\n"
    ]);
    shop_preference_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



















var ListItem = (0,styled_components_browser_esm["default"])(list_item/* ListItem */.H).withConfig({
    displayName: "ListItem",
    componentId: "sc-0-0"
})(shop_preference_templateObject());
var OutlinedButton = (0,styled_components_browser_esm["default"])(button_variants.OutlinedButton).withConfig({
    displayName: "OutlinedButton",
    componentId: "sc-0-1"
})(shop_preference_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var EmptyListText = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "EmptyListText",
    componentId: "sc-0-2"
})(shop_preference_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.colors.base600;
});
var ShopPreferenceList = function(param) {
    var shopIds = param.shopIds, onShopDelete = param.onShopDelete, isLoading = param.isLoading;
    var ref, ref1;
    var shopData = (0,use_gql_query/* useGqlQuery */.n)({
        queryKey: [
            "shop-preference"
        ],
        query: (query_graphql_default()),
        variables: {
            shopIds: shopIds.map(function(id) {
                return parseInt(id, 10);
            })
        }
    });
    return /*#__PURE__*/ react.createElement(list_variants.Column, {
        gap: 0.25,
        style: {
            position: "relative"
        }
    }, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        isActive: isLoading
    }), (ref = shopData.data) === null || ref === void 0 ? void 0 : (ref1 = ref.stores) === null || ref1 === void 0 ? void 0 : ref1.map(function(shop) {
        return /*#__PURE__*/ react.createElement(ListItem, {
            disabled: isLoading,
            key: shop.id,
            name: !shop.logo ? shop.name : "",
            link: shop.pathName,
            image: shop.logo && /*#__PURE__*/ react.createElement(store_logo/* StoreLogo */.Xv, {
                storeId: shop.id,
                name: shop.name,
                hasImage: true,
                featured: true
            })
        }, /*#__PURE__*/ react.createElement(OutlinedButton, {
            disabled: isLoading,
            onClick: onShopDelete("".concat(shop.id))
        }, /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(icon_close.IconClose, null))));
    }));
};
var UserShopPreference = function() {
    var ref, ref1;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var me = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.account.me;
    });
    var shopPreferenceState = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.account.shopPreference;
    });
    var likedShopIds = (me === null || me === void 0 ? void 0 : (ref = me.likes) === null || ref === void 0 ? void 0 : ref.shops) || [];
    var dislikedShopIds = (me === null || me === void 0 ? void 0 : (ref1 = me.dislikes) === null || ref1 === void 0 ? void 0 : ref1.shops) || [];
    var dispatch = (0,es/* useDispatch */.I0)();
    var createOnShopDeleteHandler = function(type) {
        return function(shopId) {
            return function(e) {
                e.stopPropagation();
                e.preventDefault();
                if (type === "likes") {
                    dispatch((0,account_actions/* likeShop */.m)(shopId));
                } else {
                    dispatch((0,account_actions/* dislikeShop */.XW)(shopId));
                }
            };
        };
    };
    var handleLikeSearchSelect = function(shop) {
        if (likedShopIds.includes("".concat(shop.id))) {
            dispatch((0,actions/* promptToast */.Lf)("success", t("account", "shop-preference.likes-exists", {
                shopName: shop.name
            }), {
                toastId: "likeShop".concat(shop.id)
            }));
            return;
        }
        dispatch((0,account_actions/* likeShop */.m)(shop.id));
    };
    var handleDislikeSearchSelect = function(shop) {
        if (dislikedShopIds.includes("".concat(shop.id))) {
            dispatch((0,actions/* promptToast */.Lf)("success", t("account", "shop-preference.dislikes-exists", {
                shopName: shop.name
            }), {
                toastId: "dislikeShop".concat(shop.id)
            }));
            return;
        }
        dispatch((0,account_actions/* dislikeShop */.XW)(shop.id));
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(list_variants.Row, null, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        flex: false
    }, t("account", "shop-preference.tab-ingress"))), /*#__PURE__*/ react.createElement(list_layouts/* ListMobileColumnElseRow */.N, {
        gap: 2
    }, /*#__PURE__*/ react.createElement(list_variants.Column, null, /*#__PURE__*/ react.createElement(variants.H3Text, {
        flex: false
    }, t("account", "shop-preference.likes-list-title")), /*#__PURE__*/ react.createElement(search_box/* SearchBox */.R, {
        onSelect: handleLikeSearchSelect,
        searchMode: container/* SearchMode.SHOPS */.N.SHOPS,
        placeholder: t("search", "search-shops.placeholder")
    }), likedShopIds.length === 0 ? /*#__PURE__*/ react.createElement(EmptyListText, null, shopPreferenceState.fetchingLikes && /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        isActive: true
    }), !shopPreferenceState.fetchingLikes && t("account", "shop-preference.likes-list-empty")) : /*#__PURE__*/ react.createElement(ShopPreferenceList, {
        shopIds: likedShopIds,
        isLoading: shopPreferenceState.fetchingLikes,
        onShopDelete: createOnShopDeleteHandler("likes")
    })), /*#__PURE__*/ react.createElement(list_variants.Column, null, /*#__PURE__*/ react.createElement(variants.H3Text, {
        flex: false
    }, t("account", "shop-preference.dislikes-list-title")), /*#__PURE__*/ react.createElement(search_box/* SearchBox */.R, {
        onSelect: handleDislikeSearchSelect,
        searchMode: container/* SearchMode.SHOPS */.N.SHOPS,
        placeholder: t("search", "search-shops.placeholder")
    }), dislikedShopIds.length === 0 ? /*#__PURE__*/ react.createElement(EmptyListText, null, shopPreferenceState.fetchingDislikes && /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        isActive: true
    }), !shopPreferenceState.fetchingDislikes && t("account", "shop-preference.dislikes-list-empty")) : /*#__PURE__*/ react.createElement(ShopPreferenceList, {
        shopIds: dislikedShopIds,
        isLoading: shopPreferenceState.fetchingDislikes,
        onShopDelete: createOnShopDeleteHandler("dislikes")
    }))));
};


// EXTERNAL MODULE: ./src/areas/account/profile/types.ts
var types = __webpack_require__(14468);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(62619);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(42281);
// EXTERNAL MODULE: ./src/areas/account/profile/me.graphql
var me_graphql = __webpack_require__(60591);
var me_graphql_default = /*#__PURE__*/__webpack_require__.n(me_graphql);
;// CONCATENATED MODULE: ./src/areas/account/profile/queries/useMyProfilePageQuery.ts


function useMyProfilePageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (me_graphql_default()),
        routeName: "profile",
        variables: variables
    });
}

// EXTERNAL MODULE: ./src/areas/account/profile/views/styles.ts
var styles = __webpack_require__(27102);
;// CONCATENATED MODULE: ./src/areas/account/profile/views/my-profile.tsx
function my_profile_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function my_profile_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function my_profile_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function my_profile_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function my_profile_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function my_profile_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            my_profile_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function my_profile_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function my_profile_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        my_profile_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function my_profile_slicedToArray(arr, i) {
    return my_profile_arrayWithHoles(arr) || my_profile_iterableToArrayLimit(arr, i) || my_profile_unsupportedIterableToArray(arr, i) || my_profile_nonIterableRest();
}
function my_profile_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return my_profile_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return my_profile_arrayLikeToArray(o, minLen);
}
























var MyProfilePageLoader = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref = useMyProfilePageQuery(route.variables), data = ref.data, isLoading = ref.isLoading, isSuccess = ref.isSuccess;
    if (!isLoading && !isSuccess) {
        return null;
    }
    var section = route.match.params.section;
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        "data-test": "MyProfilePage"
    }, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data ? /*#__PURE__*/ react.createElement(MyProfilePage, {
        data: data,
        routeSection: section
    }) : null);
};
var MyProfile = function(param) {
    var me = param.me, isAuthenticated = param.isAuthenticated, data = param.data, _routeSection = param.routeSection, routeSection = _routeSection === void 0 ? types/* Tabs.Reviews */.m.Reviews : _routeSection, updatedSummary = param.updatedSummary;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var reviews = (ref = data.me.reviews) === null || ref === void 0 ? void 0 : ref.nodes;
    var ref5 = my_profile_slicedToArray((0,react.useState)(), 2), selectedProfileList = ref5[0], setSelectedProfileList = ref5[1];
    var ref6 = my_profile_slicedToArray((0,react.useState)(false), 2), draggableList = ref6[0], setDraggableList = ref6[1];
    var search = (0,react_router/* useLocation */.TH)().search;
    var reviewCount = (ref1 = data.me.reviews) === null || ref1 === void 0 ? void 0 : ref1.totalItems;
    var scrollToTop = (0,react.useCallback)(function() {
        if (true) {
            window.scrollTo({
                top: 0
            });
        }
    }, []);
    var pageInfo = (ref2 = data.me.reviews) === null || ref2 === void 0 ? void 0 : ref2.pageInfo;
    var currentPage = pageInfo && typeof pageInfo.offset === "number" && typeof pageInfo.limit === "number" ? Math.floor(pageInfo.offset / pageInfo.limit) + 1 : 1;
    var generatePaginationUrl = (0,react.useCallback)(function(pageNumber) {
        return "?".concat(dist_default().stringify(my_profile_objectSpreadProps(my_profile_objectSpread({}, dist_default().parse(search.substring(1))), {
            offset: (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.limit) && pageNumber > 1 ? (pageNumber - 1) * pageInfo.limit : undefined
        })));
    }, [
        search,
        pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.limit
    ]);
    if (!isAuthenticated || !me || !data) return null;
    var breadcrumbPaths = [
        {
            id: "1",
            name: t("account", "profile.title"),
            pathName: "/account/profile"
        },
        routeSection === types/* Tabs.Settings */.m.Settings && {
            id: "2",
            name: t("account", "settings.title"),
            pathName: "/account/profile/settings"
        },
        routeSection === types/* Tabs.Lists */.m.Lists && {
            id: "3",
            name: t("lists", "lists.title"),
            pathName: "/account/profile/lists"
        }
    ].filter(function(x) {
        return x;
    });
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles/* BreadCrumbWrapper */.q9, {
        "data-test": "Breadcrumbs"
    }, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: breadcrumbPaths.map(function(param, index) {
            var name = param.name, pathName = param.pathName;
            return {
                href: breadcrumbPaths.length - 1 !== index ? pathName : undefined,
                title: name
            };
        })
    })), /*#__PURE__*/ react.createElement(styles/* Profile */.NZ, null, /*#__PURE__*/ react.createElement(user_info/* default */.Z, {
        isMe: true,
        displayName: me.displayName,
        reviewCount: reviewCount,
        voteCount: (ref3 = me.statistics) === null || ref3 === void 0 ? void 0 : ref3.helpfulScore,
        memberSince: me.memberSince,
        avatar: (ref4 = me.schibstedProfile) === null || ref4 === void 0 ? void 0 : ref4.avatar
    }), /*#__PURE__*/ react.createElement(tabs/* default */.Z, {
        isMe: true,
        reviewCount: reviewCount,
        tab: routeSection
    }), routeSection === types/* Tabs.Alerts */.m.Alerts && /*#__PURE__*/ react.createElement(alerts/* default */.Z, null), routeSection === types/* Tabs.Lists */.m.Lists && !selectedProfileList && /*#__PURE__*/ react.createElement(styles/* ListsWrapper */.$_, null, /*#__PURE__*/ react.createElement(lists/* default */.Z, {
        onItemClick: function(id) {
            return setSelectedProfileList(id);
        },
        showBackArrow: false
    })), routeSection === types/* Tabs.Lists */.m.Lists && selectedProfileList && /*#__PURE__*/ react.createElement(styles/* ListsWrapper */.$_, null, /*#__PURE__*/ react.createElement(list/* default */.Z, {
        id: selectedProfileList,
        onOpenView: function() {
            return setSelectedProfileList(undefined);
        },
        toggleMobileDraggable: function() {
            return setDraggableList(!draggableList);
        }
    })), routeSection === types/* Tabs.Settings */.m.Settings && /*#__PURE__*/ react.createElement(settings, null), routeSection === types/* Tabs.Reviews */.m.Reviews && /*#__PURE__*/ react.createElement(react.Fragment, null, (!reviews || reviews.length === 0) && /*#__PURE__*/ react.createElement(empty_reviews, {
        isMe: true
    }), /*#__PURE__*/ react.createElement(styles/* Reviews */.Zv, null, /*#__PURE__*/ react.createElement(styles/* ReviewList */.PY, null, reviews === null || reviews === void 0 ? void 0 : reviews.map(function(review) {
        var ref, ref1;
        if (!review || !review.store && !review.product) {
            return null;
        }
        var updatedProduct;
        var type = "product";
        if (review.store) type = "store";
        if (review.product && updatedSummary && review.product.id === updatedSummary.belongsToId) {
            updatedProduct = my_profile_objectSpreadProps(my_profile_objectSpread({}, review.product), {
                userReviewSummary: updatedSummary
            });
        }
        var belongsTo = {
            id: (ref = review[type]) === null || ref === void 0 ? void 0 : ref.id,
            name: (ref1 = review[type]) === null || ref1 === void 0 ? void 0 : ref1.name,
            type: type
        };
        if (type === "product") {
            var ref2;
            return /*#__PURE__*/ react.createElement(product/* default */.Z, {
                key: review.id,
                id: review.id,
                text: review.reviewText,
                rating: review.convertedRating,
                purchaseDate: review.purchaseDate,
                createdAt: review.createdAt,
                updatedAt: review.updatedAt,
                createdAtFromNow: review.createdAtFromNow,
                updatedAtFromNow: review.updatedAtFromNow,
                isMyReview: true,
                likes: review.likeScore,
                product: updatedProduct || review.product,
                showProduct: true,
                belongsTo: belongsTo,
                originMarket: review.originMarket,
                userDisplayName: me.displayName,
                userId: me.id,
                userReviewCount: reviewCount,
                userAvatar: (ref2 = me.schibstedProfile) === null || ref2 === void 0 ? void 0 : ref2.avatar
            });
        }
        if (type === "store") {
            var ref3;
            return /*#__PURE__*/ react.createElement(shop/* default */.Z, {
                key: review.id,
                id: review.id,
                text: review.reviewText,
                rating: review.convertedRating,
                createdAt: review.createdAt,
                updatedAt: review.updatedAt,
                createdAtFromNow: review.createdAtFromNow,
                updatedAtFromNow: review.updatedAtFromNow,
                isMyReview: true,
                likes: review.likeScore,
                store: review.store,
                showStore: true,
                belongsTo: belongsTo,
                originMarket: review.originMarket,
                userDisplayName: me.displayName,
                userId: me.id,
                userReviewCount: reviewCount,
                userAvatar: (ref3 = me.schibstedProfile) === null || ref3 === void 0 ? void 0 : ref3.avatar
            });
        }
        return null;
    }))), /*#__PURE__*/ react.createElement(number_pagination/* NumberPagination */.O, {
        currentPage: currentPage,
        totalPages: (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.limit) ? Math.ceil(reviewCount / pageInfo.limit) : 1,
        linkToPage: generatePaginationUrl,
        onClick: scrollToTop
    })), routeSection === types/* Tabs.ShopPreference */.m.ShopPreference && /*#__PURE__*/ react.createElement(UserShopPreference, null)), routeSection !== types/* Tabs.Settings */.m.Settings && /*#__PURE__*/ react.createElement(styles/* ProfileFooter */.c3, null, /*#__PURE__*/ react.createElement(recently_visited/* default */.Z, null)));
};
var mapStateToProps = function(state) {
    return {
        isAuthenticated: state.areas.account.isAuthenticated,
        me: state.areas.account.me,
        pendingRequest: state.areas.review.pendingRequest,
        updatedSummary: state.areas.review.updatedSummary
    };
};
var dispatchActions = {};
var MyProfilePage = (0,es/* connect */.$j)(mapStateToProps, dispatchActions)(/*#__PURE__*/ (0,react.memo)(MyProfile));
/* harmony default export */ var my_profile = (MyProfilePageLoader);


/***/ }),

/***/ 27102:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": () => (/* binding */ ListsWrapper),
/* harmony export */   "NZ": () => (/* binding */ Profile),
/* harmony export */   "PY": () => (/* binding */ ReviewList),
/* harmony export */   "Zv": () => (/* binding */ Reviews),
/* harmony export */   "ac": () => (/* binding */ EmptyListsHeader),
/* harmony export */   "c3": () => (/* binding */ ProfileFooter),
/* harmony export */   "q9": () => (/* binding */ BreadCrumbWrapper),
/* harmony export */   "xP": () => (/* binding */ EmptyListsBody)
/* harmony export */ });
/* unused harmony exports TopReview, ChangeAvatarOverlay, ChangeAvatarContainer */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  display: flex;\n  flex-direction: column;\n  > :not(:last-child) {\n    &:first-child {\n      margin-bottom: 0;\n    }\n    margin-bottom: ",
        ";\n  }\n  max-width: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    grid-gap: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto;\n  grid-gap: ",
        ";\n  width: 100%;\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    min-height: 100px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 250px;\n  padding: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  & > div {\n    max-width: 600px;\n    width: 100%;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-top: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "top: 56px; background-color: ",
        ";"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  left: 0;\n  background-color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    grid-gap: ",
        ";\n    padding: ",
        ";\n    width: 100%;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n  display: flex;\n  flex-direction: column;\n  height: 50%;\n  width: 70%;\n\n  ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}


var Profile = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Profile",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeNormal */ .bK.measurements.fontSizeNormal, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeNormal */ .bK.measurements.fontSizeNormal, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.siteWidth.rem */ .bK.siteWidth.rem);
var Reviews = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Reviews",
    componentId: "sc-0-1"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var TopReview = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "TopReview",
    componentId: "sc-0-2"
})(_templateObject2());
var ReviewList = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ReviewList",
    componentId: "sc-0-3"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeNormal */ .bK.measurements.fontSizeNormal, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall));
var ProfileFooter = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ProfileFooter",
    componentId: "sc-0-4"
})(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeNormal */ .bK.measurements.fontSizeNormal, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject5()));
var ListsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ListsWrapper",
    componentId: "sc-0-5"
})(_templateObject7());
var EmptyListsHeader = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({
    displayName: "EmptyListsHeader",
    componentId: "sc-0-6"
})(_templateObject8(), function(p) {
    return p.theme.text.secondary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeXl */ .bK.measurements.fontSizeXl);
var EmptyListsBody = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({
    displayName: "EmptyListsBody",
    componentId: "sc-0-7"
})(_templateObject9(), function(p) {
    return p.theme.text.secondary;
});
var BreadCrumbWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-8"
})(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var ChangeAvatarOverlay = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ChangeAvatarOverlay",
    componentId: "sc-0-9"
})(_templateObject12(), function(p) {
    return !p.$visible ? "display: none;" : "";
}, function(p) {
    return p.theme.bg.overlay;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject11(), function(p) {
    return p.theme.colors.base0;
}));
var ChangeAvatarContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ChangeAvatarContainer",
    componentId: "sc-0-10"
})(_templateObject14(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject13(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100));


/***/ }),

/***/ 81701:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UserProfilePageLoader": () => (/* binding */ UserProfilePageLoader),
  "default": () => (/* binding */ user_profile)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(82691);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(64799);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/number-pagination/index.tsx + 3 modules
var number_pagination = __webpack_require__(49192);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./src/components/data/index.js + 1 modules
var components_data = __webpack_require__(66884);
// EXTERNAL MODULE: ./src/components/toast-container/actions/index.ts
var actions = __webpack_require__(40744);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/shop.tsx
var shop = __webpack_require__(86370);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/product.tsx + 2 modules
var product = __webpack_require__(30979);
// EXTERNAL MODULE: ./src/globals/api/requests.js
var requests = __webpack_require__(15287);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/lists.js
var lists = __webpack_require__(96805);
// EXTERNAL MODULE: ./src/areas/sidebar/components/item-list/index.tsx
var item_list = __webpack_require__(65674);
// EXTERNAL MODULE: ./src/areas/account/profile/components/empty-state/index.tsx
var empty_state = __webpack_require__(75315);
// EXTERNAL MODULE: ./src/areas/account/profile/components/tabs/index.tsx + 1 modules
var tabs = __webpack_require__(92633);
// EXTERNAL MODULE: ./src/areas/account/profile/components/user-info/index.tsx + 2 modules
var user_info = __webpack_require__(47216);
// EXTERNAL MODULE: ./src/areas/account/profile/user-lists-query.graphql
var user_lists_query_graphql = __webpack_require__(66627);
var user_lists_query_graphql_default = /*#__PURE__*/__webpack_require__.n(user_lists_query_graphql);
// EXTERNAL MODULE: ./src/areas/account/profile/views/styles.ts
var styles = __webpack_require__(27102);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(73426);
// EXTERNAL MODULE: ./src/areas/account/profile/types.ts
var types = __webpack_require__(14468);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(42281);
// EXTERNAL MODULE: ./src/areas/account/profile/user.graphql
var user_graphql = __webpack_require__(97731);
var user_graphql_default = /*#__PURE__*/__webpack_require__.n(user_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(48458);
;// CONCATENATED MODULE: ./src/areas/account/profile/queries/useUserProfileQuery.ts


function useUserProfilePageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (user_graphql_default()),
        routeName: "user",
        variables: variables
    });
}

// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(62619);
;// CONCATENATED MODULE: ./src/areas/account/profile/views/user-profile.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




















// types





var UserProfilePageLoader = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var section = route.match.params.section;
    var ref = useUserProfilePageQuery(route.variables), data = ref.data, isLoading = ref.isLoading, isSuccess = ref.isSuccess;
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        "data-test": "UserProfilePage"
    }, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data ? /*#__PURE__*/ react.createElement(UserProfilePage, {
        data: data,
        routeSection: section
    }) : null);
};
var selectMyId = function(state) {
    var ref;
    return (ref = state.areas.account.me) === null || ref === void 0 ? void 0 : ref.id;
};
var UserProfilePage = function(param) {
    var data = param.data, _routeSection = param.routeSection, routeSection = _routeSection === void 0 ? types/* Tabs.Reviews */.m.Reviews : _routeSection;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var myId = (0,es/* useSelector */.v9)(selectMyId);
    var dispatch = (0,es/* useDispatch */.I0)();
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var search = (0,react_router/* useLocation */.TH)().search;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var user = data.user;
    var pageInfo = (ref = user.reviews) === null || ref === void 0 ? void 0 : ref.pageInfo;
    var scrollToTop = (0,react.useCallback)(function() {
        if (true) {
            window.scrollTo({
                top: 0
            });
        }
    }, []);
    var currentPage = pageInfo && typeof pageInfo.offset === "number" && typeof pageInfo.limit === "number" ? Math.floor(pageInfo.offset / pageInfo.limit) + 1 : 1;
    var generatePaginationUrl = (0,react.useCallback)(function(pageNumber) {
        return "?".concat(dist_default().stringify(_objectSpreadProps(_objectSpread({}, dist_default().parse(search.substring(1))), {
            offset: (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.limit) && pageNumber > 1 ? (pageNumber - 1) * pageInfo.limit : undefined
        })));
    }, [
        search,
        pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.limit
    ]);
    var handleCopy = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(function(id) {
            var ref, ref1, response, listId;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,requests/* graphql */.BX)("\n          mutation ($listId: Int!) {\n            copyList(listId: $listId) {\n              id\n            }\n          }\n        ", {
                                listId: id
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        listId = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.copyList) === null || ref1 === void 0 ? void 0 : ref1.id;
                        if (listId) {
                            dispatch((0,actions/* promptToast */.Lf)("success", t("lists", "confirm.list-copied")));
                            dispatch((0,lists/* createListSuccess */.re)());
                            dispatch((0,lists/* selectList */.Fz)(listId));
                            dispatch((0,lists/* openLists */.pu)());
                        } else {
                            dispatch((0,actions/* promptToast */.Lf)("error", t("reviews", "dialog.unknown-error")));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(), [
        dispatch,
        t
    ]);
    var renderLists = function() {
        var ref;
        if (routeSection !== types/* Tabs.Lists */.m.Lists) {
            return null;
        }
        if (isEmpty_default()(user === null || user === void 0 ? void 0 : (ref = user.lists) === null || ref === void 0 ? void 0 : ref.nodes)) {
            return /*#__PURE__*/ react.createElement(styles/* ListsWrapper */.$_, null, /*#__PURE__*/ react.createElement(styles/* EmptyListsHeader */.ac, null, t("account", "user-profile.empty-lists-title")), /*#__PURE__*/ react.createElement(styles/* EmptyListsBody */.xP, null, t("account", "user-profile.empty-lists-body")), /*#__PURE__*/ react.createElement(empty_state/* EmptyState */.u, {
                illustration: "illo-lists-your-products-web@2x.png",
                altText: "empty list illustration",
                style: {
                    textAlign: "center"
                }
            }));
        }
        var ref1;
        return /*#__PURE__*/ react.createElement(components_data/* default */.Z, {
            query: (user_lists_query_graphql_default()),
            renderLoader: function() {
                var ref;
                /*#__PURE__*/ return react.createElement(styles/* ListsWrapper */.$_, null, /*#__PURE__*/ react.createElement(item_list/* default */.Z, {
                    nodes: (ref1 = user === null || user === void 0 ? void 0 : (ref = user.lists) === null || ref === void 0 ? void 0 : ref.nodes) !== null && ref1 !== void 0 ? ref1 : [],
                    isPublicProfile: true
                }));
            },
            variables: {
                limit: 30,
                userId: Number(user.id),
                sort: "published"
            },
            render: function(dataProps) {
                var ref, ref1, ref2, ref3, ref4, ref5;
                var listsData = dataProps.data, fetchMore = dataProps.fetchMore, fetching = dataProps.fetching;
                if (!((ref = listsData.user) === null || ref === void 0 ? void 0 : (ref1 = ref.lists) === null || ref1 === void 0 ? void 0 : ref1.nodes)) return null;
                return /*#__PURE__*/ react.createElement(styles/* ListsWrapper */.$_, null, /*#__PURE__*/ react.createElement(item_list/* default */.Z, {
                    nodes: (ref2 = listsData.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.lists) === null || ref3 === void 0 ? void 0 : ref3.nodes,
                    isPublicProfile: true,
                    onCopy: isAuthenticated ? handleCopy : undefined,
                    onFetchMore: function() {
                        return fetchMore();
                    },
                    fetching: fetching,
                    pageInfo: (ref4 = listsData.user) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.lists) === null || ref5 === void 0 ? void 0 : ref5.pageInfo
                }));
            }
        });
    };
    return /*#__PURE__*/ react.createElement(styles/* Profile */.NZ, null, /*#__PURE__*/ react.createElement(user_info/* default */.Z, {
        avatar: (ref1 = user.schibstedProfile) === null || ref1 === void 0 ? void 0 : ref1.avatar,
        displayName: user.displayName,
        reviewCount: user.reviewCount,
        memberSince: user.memberSince,
        voteCount: (ref2 = user.statistics) === null || ref2 === void 0 ? void 0 : ref2.helpfulScore
    }), /*#__PURE__*/ react.createElement(tabs/* default */.Z, {
        reviewCount: user.reviewCount,
        tab: routeSection
    }), routeSection === types/* Tabs.Reviews */.m.Reviews && /*#__PURE__*/ react.createElement(react.Fragment, null, (!user.reviews || ((ref3 = user.reviews.nodes) === null || ref3 === void 0 ? void 0 : ref3.length) === 0) && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles/* EmptyListsHeader */.ac, {
        style: {
            textAlign: "center"
        }
    }, t("reviews", "info.no-reviews")), /*#__PURE__*/ react.createElement(empty_state/* EmptyState */.u, {
        illustration: "no-product-reviews-illustration-400x218px.png",
        altText: "empty review illustration",
        style: {
            textAlign: "center"
        }
    })), /*#__PURE__*/ react.createElement(styles/* Reviews */.Zv, null, /*#__PURE__*/ react.createElement(styles/* ReviewList */.PY, null, (ref4 = user.reviews) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.nodes) === null || ref5 === void 0 ? void 0 : ref5.map(function(review) {
        var ref, ref1;
        if (!review || !review.store && !review.product) {
            return null;
        }
        var type = "product";
        if (review.store) type = "store";
        var belongsTo = {
            id: (ref = review[type]) === null || ref === void 0 ? void 0 : ref.id,
            name: (ref1 = review[type]) === null || ref1 === void 0 ? void 0 : ref1.name,
            type: type
        };
        if (type === "product") {
            var ref2;
            return /*#__PURE__*/ react.createElement(product/* default */.Z, {
                key: review.id,
                id: review.id,
                text: review.reviewText,
                rating: review.convertedRating,
                purchaseDate: review.purchaseDate,
                createdAt: review.createdAt,
                updatedAt: review.updatedAt,
                createdAtFromNow: review.createdAtFromNow,
                updatedAtFromNow: review.updatedAtFromNow,
                likes: review.likeScore,
                product: review.product,
                showProduct: true,
                belongsTo: belongsTo,
                originMarket: review.originMarket,
                isMyReview: (user === null || user === void 0 ? void 0 : user.id) === myId,
                userDisplayName: user.displayName,
                userId: user === null || user === void 0 ? void 0 : user.id,
                userReviewCount: user.reviewCount,
                userAvatar: (ref2 = user.schibstedProfile) === null || ref2 === void 0 ? void 0 : ref2.avatar
            });
        }
        if (type === "store") {
            return /*#__PURE__*/ react.createElement(shop/* default */.Z, {
                key: review.id,
                id: review.id,
                text: review.reviewText,
                rating: review.convertedRating,
                createdAt: review.createdAt,
                updatedAt: review.updatedAt,
                createdAtFromNow: review.createdAtFromNow,
                updatedAtFromNow: review.updatedAtFromNow,
                likes: review.likeScore,
                store: review.store,
                showStore: true,
                belongsTo: belongsTo,
                originMarket: review.originMarket,
                isMyReview: (user === null || user === void 0 ? void 0 : user.id) === myId,
                userDisplayName: user.displayName,
                userId: user === null || user === void 0 ? void 0 : user.id,
                userReviewCount: user.reviewCount
            });
        }
        return null;
    }))), /*#__PURE__*/ react.createElement(number_pagination/* NumberPagination */.O, {
        currentPage: currentPage,
        totalPages: (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.limit) && user.reviewCount ? Math.ceil(user.reviewCount / pageInfo.limit) : 1,
        linkToPage: generatePaginationUrl,
        onClick: scrollToTop
    })), renderLists());
};
/* harmony default export */ var user_profile = (UserProfilePageLoader);


/***/ }),

/***/ 96820:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UnsubscribeLandingPageLoader": () => (/* binding */ UnsubscribeLandingPageLoader),
  "default": () => (/* binding */ unsubscribe_landing_page)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(62619);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(42281);
// EXTERNAL MODULE: ./src/hooks/use-page-meta-tags.ts
var use_page_meta_tags = __webpack_require__(24567);
// EXTERNAL MODULE: ./src/hooks/use-route-loaded.ts
var use_route_loaded = __webpack_require__(65560);
// EXTERNAL MODULE: ./src/hooks/use-gql-mutation.ts
var use_gql_mutation = __webpack_require__(659);
// EXTERNAL MODULE: ./src/areas/account/settings/components/subscription-settings/unsubscribe-landing-page/unsubscribe-landing-page-query.graphql
var unsubscribe_landing_page_query_graphql = __webpack_require__(68386);
var unsubscribe_landing_page_query_graphql_default = /*#__PURE__*/__webpack_require__.n(unsubscribe_landing_page_query_graphql);
;// CONCATENATED MODULE: ./src/areas/account/settings/components/subscription-settings/queries/useUnsubscribeLandingPageMutation.ts


function useUnsubscribeLandingPageMutation(variables) {
    return (0,use_gql_mutation/* useGqlMutation */.c)({
        mutation: (unsubscribe_landing_page_query_graphql_default()),
        variables: variables
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
;// CONCATENATED MODULE: ./src/areas/account/settings/components/subscription-settings/unsubscribe-landing-page/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        " ",
        " ",
        " ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var _measurements = base/* layout.measurements */.bK.measurements, spacing050 = _measurements.spacing050, spacing150 = _measurements.spacing150, spacing400 = _measurements.spacing400;
var Content = (0,styled_components_browser_esm["default"])(page/* PageContent */.JH).withConfig({
    displayName: "Content",
    componentId: "sc-0-0"
})(_templateObject(), spacing150, spacing050, spacing400, spacing050);
var Title = (0,styled_components_browser_esm["default"])(text_variants.H1Text).withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);

;// CONCATENATED MODULE: ./src/areas/account/settings/components/subscription-settings/unsubscribe-landing-page/unsubscribe-landing-page.tsx










var UnsubscribeLandingPageLoader = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref = useUnsubscribeLandingPageMutation(route.variables), data = ref.data, isLoading = ref.isLoading, isSuccess = ref.isSuccess, mutate = ref.mutate;
    (0,react.useEffect)(function() {
        mutate();
    }, []);
    (0,use_route_loaded/* useRouteLoaded */.N)(data);
    (0,use_page_meta_tags/* usePageMetaTags */.p)(data);
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(Content, null, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data ? /*#__PURE__*/ react.createElement(UnsubscribeLandingPage, {
        data: data
    }) : null);
};
var UnsubscribeLandingPage = function(param) {
    var data = param.data;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Title, null, t("account", "unsubscribe.landing-title")), /*#__PURE__*/ react.createElement("p", null, t("account", "unsubscribe.landing-text"), " ", /*#__PURE__*/ react.createElement("strong", null, data.updateSubscriptionSetting.title)), /*#__PURE__*/ react.createElement(variants.PrimaryButton, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: "/"
        }
    }, t("common", "button.go-home")));
};
/* harmony default export */ var unsubscribe_landing_page = (UnsubscribeLandingPageLoader);


/***/ }),

/***/ 60039:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ useReviewContext),
/* harmony export */   "b": () => (/* binding */ ReviewContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var initialValue = {
    onReviewExpansion: undefined
};
var ReviewContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialValue);
var useReviewContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ReviewContext);
};
var ReviewContextContainer = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ReviewContext.Provider, {
        value: props
    }, props.children);
};


/***/ }),

/***/ 15794:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var DragIndicatorIcon = function(param) {
    var size = param.size, title = param.title;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        style: {
            flexShrink: 0
        }
    }, title && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M15.133 22.467c0 1.136-.93 2.066-2.066 2.066A2.073 2.073 0 0 1 11 22.467c0-1.137.93-2.067 2.067-2.067 1.136 0 2.066.93 2.066 2.067zM13.067 14.2c-1.137 0-2.067.93-2.067 2.067 0 1.136.93 2.066 2.067 2.066 1.136 0 2.066-.93 2.066-2.066 0-1.137-.93-2.067-2.066-2.067zm0-6.2C11.93 8 11 8.93 11 10.067c0 1.136.93 2.066 2.067 2.066 1.136 0 2.066-.93 2.066-2.066 0-1.137-.93-2.067-2.066-2.067zm6.2 4.133c1.136 0 2.066-.93 2.066-2.066 0-1.137-.93-2.067-2.066-2.067-1.137 0-2.067.93-2.067 2.067 0 1.136.93 2.066 2.067 2.066zm0 2.067c-1.137 0-2.067.93-2.067 2.067 0 1.136.93 2.066 2.067 2.066 1.136 0 2.066-.93 2.066-2.066 0-1.137-.93-2.067-2.066-2.067zm0 6.2c-1.137 0-2.067.93-2.067 2.067 0 1.136.93 2.066 2.067 2.066 1.136 0 2.066-.93 2.066-2.066 0-1.137-.93-2.067-2.066-2.067z",
        fill: "#D7D7D7"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: size,
        height: size
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (DragIndicatorIcon);


/***/ }),

/***/ 65674:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_translate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37702);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66292);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_components_spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61061);
/* harmony import */ var _list_item__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95935);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24279);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25670);
/* harmony import */ var _prisjakt_ui_icon_chevron_down__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34783);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}









var _PureComponent;
var ItemList = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(ItemList, _superClass);
    var _super = _createSuper(ItemList);
    function ItemList(props) {
        _classCallCheck(this, ItemList);
        var _this;
        _this = _super.call(this, props);
        _this.flushQuantity = lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default()(function() {
            _this.commitQuantity();
        }, 1500);
        _this.updateQuantity = function(id, quantity) {
            _this.setState({
                optimisticQuantity: _objectSpreadProps(_objectSpread({}, _this.state.optimisticQuantity), _defineProperty({}, id, quantity)),
                queue: _objectSpreadProps(_objectSpread({}, _this.state.queue), _defineProperty({}, id, true))
            });
            _this.flushQuantity();
        };
        _this.state = {
            optimisticQuantity: {},
            queue: {}
        };
        return _this;
    }
    var _proto = ItemList.prototype;
    _proto.commitQuantity = function commitQuantity() {
        var _this = this;
        var _props = this.props, refresh = _props.refresh, mutation = _props.mutation;
        var ids = Object.keys(this.state.queue);
        this.setState({
            queue: {}
        });
        Promise.all(ids.map(function(id) {
            return mutation && mutation("mutation listItemQuantity($listId: Int!, $id: ID!, $quantity: Int!) {\n              listItemQuantity(listId: $listId, id: $id, quantity: $quantity) {\n                success\n              }\n            }", {
                quantity: _this.state.optimisticQuantity[id],
                id: id,
                listId: _this.props.listId
            }, {
                refresh: false
            });
        }));
        if (refresh) refresh();
    };
    _proto.renderFooter = function renderFooter() {
        if (!this.props.pageInfo.hasNext) {
            return null;
        }
        if (!this.props.onFetchMore) {
            return null;
        }
        if (this.props.onFetchMore && this.props.pageInfo.hasNext) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .LoadMore */ .fr, null, !this.props.fetching ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_7__.TextButton, {
                onClick: this.props.onFetchMore
            }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_translate__WEBPACK_IMPORTED_MODULE_1__/* .Translate */ .v, {
                domain: "common"
            }, "button.show-more"), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_chevron_down__WEBPACK_IMPORTED_MODULE_8__/* .IconChevronDown */ .C, {
                color: "maybeBlue700"
            })) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_spinner__WEBPACK_IMPORTED_MODULE_4__/* .Spinner */ .$, {
                position: "none",
                isActive: true
            }));
        }
        return null;
    };
    _proto.render = function render() {
        var _this = this;
        var props = this.props;
        if (props.nodes.length === 0) {
            return props.renderEmpty;
        }
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, props.nodes.map(function(originalItem) {
            var optimisticQuantity = _this.state.optimisticQuantity[originalItem.id];
            // Create a new item with optimistic updates
            var item = _objectSpreadProps(_objectSpread({}, originalItem), {
                quantity: optimisticQuantity === undefined && (originalItem.__typename === "ListSearch" || originalItem.__typename === "ListProduct") ? originalItem.quantity : optimisticQuantity
            });
            var listItemProps = _objectSpread({
                item: item,
                updateQuantity: _this.updateQuantity
            }, props);
            return _this.props.render ? _this.props.render(listItemProps) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_list_item__WEBPACK_IMPORTED_MODULE_5__/* .ListItem */ .H, _extends({
                key: item.id
            }, listItemProps));
        }), this.renderFooter());
    };
    return ItemList;
}(_PureComponent = react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);
ItemList.defaultProps = {
    renderEmpty: "",
    pageInfo: {},
    fetching: false
};
ItemList.contextType = src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il;
/* harmony default export */ __webpack_exports__["Z"] = (ItemList);


/***/ }),

/***/ 95935:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": () => (/* binding */ ListItem)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(37702);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/areas/sidebar/components/item-row/styles.ts
var styles = __webpack_require__(31651);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/item-row/index.tsx


var ItemRow = function(param) {
    var name = param.name, type = param.type, icon = param.icon, subtitle = param.subtitle;
    var alternativeIcon = function() {
        switch(type){
            case "AlertSearch":
                return /*#__PURE__*/ react.createElement(styles/* SearchIcon */.W1, null);
            default:
                return null;
        }
    };
    return /*#__PURE__*/ react.createElement(styles/* ItemRow */.FD, null, /*#__PURE__*/ react.createElement(styles/* Icon */.JO, {
        border: type === "AlertSearch"
    }, alternativeIcon()), /*#__PURE__*/ react.createElement(styles/* Info */.kI, null, /*#__PURE__*/ react.createElement(styles/* Name */.VG, {
        truncate: type === "ListCategory",
        bold: type === "ListCategory"
    }, name), /*#__PURE__*/ react.createElement(styles/* Count */.XF, null, subtitle)));
};
/* harmony default export */ var item_row = (ItemRow);

// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(75695);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/list-price/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 3px;\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: normal;\n  align-self: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ListPrice = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListPrice",
    componentId: "sc-0-0"
})(_templateObject());
var CurrentPrice = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CurrentPrice",
    componentId: "sc-0-1"
})(_templateObject1());
var Quantity = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Quantity",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.text.quaternary;
}, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);

;// CONCATENATED MODULE: ./src/areas/sidebar/components/list-price/index.tsx



var list_price_ListPrice = function(param) {
    var price = param.price, quantity = param.quantity;
    if (!price) return null;
    return /*#__PURE__*/ react.createElement(ListPrice, null, /*#__PURE__*/ react.createElement(CurrentPrice, null, /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: price
    })), quantity !== 1 && /*#__PURE__*/ react.createElement(Quantity, null, "x", quantity));
};
/* harmony default export */ var list_price = (list_price_ListPrice);

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/alert-price/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin: 0;\n  flex: 1;\n  justify-content: space-between;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-weight: normal;\n  color: ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  font-size: ",
        ";\n  font-style: italic;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-right: 5px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var AlertPrice = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AlertPrice",
    componentId: "sc-0-0"
})(styles_templateObject());
var LightText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "LightText",
    componentId: "sc-0-1"
})(styles_templateObject1(), function(p) {
    return p.theme.colors.base500;
});
var AlertTimeText = (0,styled_components_browser_esm["default"])(LightText).withConfig({
    displayName: "AlertTimeText",
    componentId: "sc-0-2"
})(styles_templateObject2(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var PriceChange = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "PriceChange",
    componentId: "sc-0-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/areas/sidebar/components/alert-price/index.tsx






var alert_price_AlertPrice = function(param) {
    var price = param.price, latestPriceChange = param.latestPriceChange;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var rawPriceChange = latestPriceChange && latestPriceChange.amount;
    var rawPrice = price.regular;
    var hasRegularPrice = !!rawPrice;
    var priceUp = rawPriceChange && rawPriceChange > 0;
    var priceDown = rawPriceChange && rawPriceChange < 0;
    var showPriceChange = hasRegularPrice && latestPriceChange && (priceUp || priceDown);
    return /*#__PURE__*/ react.createElement(AlertPrice, null, latestPriceChange && /*#__PURE__*/ react.createElement(AlertTimeText, {
        key: "label"
    }, latestPriceChange.time), /*#__PURE__*/ react.createElement("div", null, latestPriceChange && Boolean(showPriceChange) && /*#__PURE__*/ react.createElement(PriceChange, {
        key: "price",
        color: priceUp ? variants.FontColor.DARK : variants.FontColor.NEGATIVE,
        weight: variants.FontWeight.HEAVIER,
        scale: variants.FontScale.XS
    }, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        asDiff: true,
        price: latestPriceChange.amount
    })), price.regular && hasRegularPrice ? /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: price.regular
    }) : /*#__PURE__*/ react.createElement(LightText, null, t("alerts", "list.no-price-found"))));
};
alert_price_AlertPrice.defaultProps = {
    latestPriceChange: null
};
/* harmony default export */ var alert_price = (/*#__PURE__*/(0,react.memo)(alert_price_AlertPrice));

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(25670);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/edit-control/styles.ts
function edit_control_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function edit_control_styles_templateObject() {
    var data = edit_control_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-end;\n  flex-flow: column;\n  transition: opacity ease 0.25s;\n"
    ]);
    edit_control_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function edit_control_styles_templateObject1() {
    var data = edit_control_styles_taggedTemplateLiteral([
        "\n  width: 28px;\n  height: 28px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #000;\n"
    ]);
    edit_control_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function edit_control_styles_templateObject2() {
    var data = edit_control_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  white-space: nowrap;\n  cursor: pointer;\n  padding: ",
        ";\n  color: #000;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    edit_control_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = edit_control_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-left: ",
        ";\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = edit_control_styles_taggedTemplateLiteral([
        "\n  border-radius: 3px;\n  background: ",
        ";\n  width: 24px;\n  height: 24px;\n\n  svg {\n    width: 15px;\n    color: rgb(106, 124, 129);\n  }\n\n  &:not(:last-of-type) {\n    margin-right: 3px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var Edit = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Edit",
    componentId: "sc-0-0"
})(edit_control_styles_templateObject());
var EditButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "EditButton",
    componentId: "sc-0-1"
})(edit_control_styles_templateObject1());
var EditOption = styled_components_browser_esm["default"].button.withConfig({
    displayName: "EditOption",
    componentId: "sc-0-2"
})(edit_control_styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var QuantityControls = styled_components_browser_esm["default"].div.withConfig({
    displayName: "QuantityControls",
    componentId: "sc-0-3"
})(styles_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var QuantityButton = (0,styled_components_browser_esm["default"])(button_variants.TonalButton).withConfig({
    displayName: "QuantityButton",
    componentId: "sc-0-4"
})(_templateObject4(), function(p) {
    return p.theme.bg.secondary;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/minus/index.js
var minus = __webpack_require__(17471);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/plus/index.js
var plus = __webpack_require__(31903);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/edit-control/quantity.tsx





var quantity_QuantityControls = function(param) {
    var item = param.item, updateQuantity = param.updateQuantity;
    var increaseQuantity = (0,react.useCallback)(function(e) {
        if (item.__typename !== "ListProduct") return;
        e.preventDefault();
        e.stopPropagation();
        updateQuantity(item.id, item.quantity + 1);
    }, [
        item,
        updateQuantity
    ]);
    var decreaseQuantity = (0,react.useCallback)(function(e) {
        if (item.__typename !== "ListProduct") return;
        e.preventDefault();
        e.stopPropagation();
        updateQuantity(item.id, item.quantity - 1);
    }, [
        item,
        updateQuantity
    ]);
    return item.__typename === "ListProduct" && item.quantity >= 0 ? /*#__PURE__*/ react.createElement(QuantityControls, null, /*#__PURE__*/ react.createElement(QuantityButton, {
        onlyIcon: true,
        disabled: item.quantity <= 0,
        onClick: decreaseQuantity
    }, /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(minus/* IconMinus */.U, null))), /*#__PURE__*/ react.createElement(QuantityButton, {
        onlyIcon: true,
        onClick: increaseQuantity
    }, /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(plus/* IconPlus */.S, null)))) : null;
};
/* harmony default export */ var quantity = (quantity_QuantityControls);

// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(95242);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(34990);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/product-row/styles.ts
function product_row_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_row_styles_templateObject() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        ";\n"
    ]);
    product_row_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_row_styles_templateObject1() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  max-width: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    product_row_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_row_styles_templateObject2() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  overflow: hidden;\n"
    ]);
    product_row_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_row_styles_templateObject3() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n"
    ]);
    product_row_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  color: ",
        ";\n  margin-right: 30px; /* Dont overlap edit button */\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-right: 30px; /* Dont overlap edit button */\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: space-between;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  margin-right: auto;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var imageSize = "40px";
var padding = base/* layout.measurements.spacing050 */.bK.measurements.spacing050;
var ProductRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductRow",
    componentId: "sc-0-0"
})(product_row_styles_templateObject(), padding);
var ProductImage = (0,styled_components_browser_esm["default"])(product_image/* ProductImage */.q).withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-1"
})(product_row_styles_templateObject1(), imageSize, padding);
var Info = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Info",
    componentId: "sc-0-2"
})(product_row_styles_templateObject2());
var EditControls = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EditControls",
    componentId: "sc-0-3"
})(product_row_styles_templateObject3(), padding, padding);
var Name = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Name",
    componentId: "sc-0-4"
})(styles_templateObject4(), function(p) {
    return p.theme.text.primary;
});
var Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-5"
})(_templateObject5(), function(p) {
    return p.theme.text.secondary;
}, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var BottomRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BottomRow",
    componentId: "sc-0-6"
})(_templateObject6(), function(p) {
    return p.row ? "row" : "column";
});
var PriceRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceRow",
    componentId: "sc-0-7"
})(_templateObject7());
var Price = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Price",
    componentId: "sc-0-8"
})(_templateObject8(), function(p) {
    return !p.rating && p.type === "ListProduct" ? "auto" : 0;
});
var Rating = (0,styled_components_browser_esm["default"])(components_rating/* default */.Z).withConfig({
    displayName: "Rating",
    componentId: "sc-0-9"
})(_templateObject9());

;// CONCATENATED MODULE: ./src/areas/sidebar/components/product-row/index.tsx





var product_row_ProductRow = function(props) {
    var ref;
    var item = props.item, updateQuantity = props.updateQuantity;
    var rating = item.product && (((ref = item.product.aggregatedRating) === null || ref === void 0 ? void 0 : ref.score) || item.product.userReviewSummary.rating);
    var renderPrice = function() {
        switch(item.__typename){
            case "AlertProduct":
                return /*#__PURE__*/ react.createElement(alert_price, {
                    price: item.product.priceSummary,
                    latestPriceChange: item.product.latestPriceChange
                });
            case "ListProduct":
                return (item.product.priceSummary.regular || item.product.priceSummary.alternative) && /*#__PURE__*/ react.createElement(list_price, {
                    price: item.product.priceSummary.regular || item.product.priceSummary.alternative,
                    quantity: item.quantity
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ react.createElement(ProductRow, null, item.product.media.first && /*#__PURE__*/ react.createElement(ProductImage, {
        name: item.product.name,
        src: item.product.media.first
    }), /*#__PURE__*/ react.createElement(Info, null, /*#__PURE__*/ react.createElement(Name, null, item.product.name), item.product.category && /*#__PURE__*/ react.createElement(Subtitle, null, item.product.category.name), /*#__PURE__*/ react.createElement(BottomRow, {
        row: item.__typename === "ListProduct"
    }, rating ? /*#__PURE__*/ react.createElement(Rating, {
        hide: rating === null,
        rate: rating,
        showRate: true,
        size: "small",
        singleStar: item.__typename === "ListProduct"
    }) : null, /*#__PURE__*/ react.createElement(PriceRow, null, /*#__PURE__*/ react.createElement(Price, {
        type: item.__typename,
        rating: Boolean(rating)
    }, renderPrice()), updateQuantity && /*#__PURE__*/ react.createElement(quantity, {
        item: item,
        updateQuantity: updateQuantity
    })))));
};
product_row_ProductRow.defaultProps = {
    canEdit: false
};
/* harmony default export */ var product_row = (product_row_ProductRow);

// EXTERNAL MODULE: ./src/components/dropdown-new/index.ts + 2 modules
var dropdown_new = __webpack_require__(13961);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/menu-kebab/index.js
var menu_kebab = __webpack_require__(77356);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/edit-control/index.tsx





var Options;
(function(Options) {
    Options["LIST_REMOVE"] = "LIST_REMOVE";
    Options["CREATE_ALERT"] = "CREATE_ALERT";
    Options["LIST_EDIT"] = "LIST_EDIT";
    Options["LIST_COPY"] = "LIST_COPY";
})(Options || (Options = {}));
var EditControl = function(param) {
    var item = param.item, createAlert = param.createAlert, onDelete = param.onDelete, onEdit = param.onEdit, canEdit = param.canEdit, onCopy = param.onCopy, isPublicProfile = param.isPublicProfile;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var options = [
        {
            name: t("alerts", "list.remove"),
            value: Options.LIST_REMOVE
        },
        {
            name: t("product", "alert.create-button"),
            value: Options.CREATE_ALERT
        },
        {
            name: t("common", "button.edit"),
            value: Options.LIST_EDIT
        },
        {
            name: t("lists", "button.copy-list"),
            value: Options.LIST_COPY
        }
    ];
    var deleteItem = (0,react.useCallback)(function() {
        if (!onDelete) {
            return;
        }
        switch(item.__typename){
            case "AlertProduct":
                onDelete(item.id, item.product ? item.product.id : undefined);
                return;
            case "ListProduct":
                onDelete(item.id, item.product ? item.product.id : undefined);
                return;
            case "ListSearch":
                onDelete(item.id, undefined);
                return;
            case "AlertSearch":
                onDelete(item.id, undefined);
                return;
            default:
                onDelete(item.id, undefined);
        }
    }, [
        item,
        onDelete
    ]);
    return /*#__PURE__*/ react.createElement(Edit, null, /*#__PURE__*/ react.createElement(dropdown_new/* DropdownNew */.cw, {
        variant: "secondary",
        showArrow: false,
        toggleElement: /*#__PURE__*/ react.createElement(EditButton, null, /*#__PURE__*/ react.createElement(menu_kebab/* IconMenuKebab */.Q, null)),
        grow: "left"
    }, options.filter(function(x) {
        return x;
    }).map(function(option) {
        switch(option.value){
            case Options.LIST_REMOVE:
                {
                    if (onDelete) {
                        return /*#__PURE__*/ react.createElement(EditOption, {
                            key: option.value,
                            type: "button",
                            onClick: deleteItem
                        }, option.name);
                    }
                    break;
                }
            case Options.LIST_EDIT:
                {
                    if ((item.__typename === "ListProduct" || item.__typename === "ListSearch" || item.__typename === "AlertProduct") && onEdit && canEdit) {
                        return /*#__PURE__*/ react.createElement(EditOption, {
                            key: option.value,
                            type: "button",
                            onClick: function() {
                                onEdit(item);
                            }
                        }, option.name);
                    }
                    break;
                }
            case Options.CREATE_ALERT:
                {
                    if (item.__typename === "ListProduct" && createAlert) {
                        return /*#__PURE__*/ react.createElement(EditOption, {
                            key: option.value,
                            type: "button",
                            onClick: function() {
                                createAlert(item.product);
                            }
                        }, option.name);
                    }
                    break;
                }
            case Options.LIST_COPY:
                {
                    if (item.__typename === "ListCategory" && isPublicProfile && onCopy) {
                        return /*#__PURE__*/ react.createElement(EditOption, {
                            key: option.value,
                            type: "button",
                            onClick: function() {
                                return onCopy(item.id);
                            }
                        }, option.name);
                    }
                    break;
                }
            default:
                return null;
        }
        return null;
    })));
};
EditControl.defaultProps = {
    canEdit: false
};
/* harmony default export */ var edit_control = (EditControl);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/areas/reviews/components/prompt/index.js
var components_prompt = __webpack_require__(32311);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/clickable/index.js
var clickable = __webpack_require__(42007);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/my-products-row/styles.tsx
function my_products_row_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function my_products_row_styles_templateObject() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n  background: ",
        ";\n  border-radius: ",
        ";\n\n  .pj-ui-product-image {\n    display: block;\n    max-width: 40px;\n    max-height: 40px;\n    width: auto;\n    height: auto;\n  }\n"
    ]);
    my_products_row_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function my_products_row_styles_templateObject1() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  margin-right: 30px; /* Dont overlap edit button */\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    my_products_row_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function my_products_row_styles_templateObject2() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-right: 30px; /* Dont overlap edit button */\n"
    ]);
    my_products_row_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function my_products_row_styles_templateObject3() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  row-gap: ",
        ";\n  margin-bottom: ",
        ";\n  width: 100%;\n  overflow: hidden;\n"
    ]);
    my_products_row_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function my_products_row_styles_templateObject4() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  padding: ",
        ";\n  display: flex;\n  flex-direction: row;\n"
    ]);
    my_products_row_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  && {\n    margin-left: ",
        ";\n    font-size: 12px;\n    font-weight: 600;\n    transition: color 150ms ease;\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var ProductImageLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductImageLink",
    componentId: "sc-0-0"
})(my_products_row_styles_templateObject(), function(p) {
    return p.theme.colors.base200;
}, base/* layout.borderRadius */.bK.borderRadius);
var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-1"
})(my_products_row_styles_templateObject1(), function(p) {
    return p.theme.text.callToActionHover;
});
var styles_Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-2"
})(my_products_row_styles_templateObject2(), function(p) {
    return p.theme.text.secondary;
}, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var ProductInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductInfo",
    componentId: "sc-0-3"
})(my_products_row_styles_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var MyProductsRowWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MyProductsRowWrapper",
    componentId: "sc-0-4"
})(my_products_row_styles_templateObject4(), function(p) {
    return p.theme.colors.base200;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var RatingWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingWrapper",
    componentId: "sc-0-5"
})(styles_templateObject5());
var CreateReviewButton = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "CreateReviewButton",
    componentId: "sc-0-6"
})(styles_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var styles_PriceRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceRow",
    componentId: "sc-0-7"
})(styles_templateObject7());

;// CONCATENATED MODULE: ./src/areas/sidebar/components/my-products-row/my-products-row.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var reviewedProductsSelector = function(state) {
    return state.areas.account.me.reviewedProducts;
};
var MyProductsRow = /*#__PURE__*/ (0,react.memo)(function(param) {
    var item = param.item, updateQuantity = param.updateQuantity;
    var ref;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var reviewedProducts = (0,es/* useSelector */.v9)(reviewedProductsSelector);
    var rating = (ref = reviewedProducts === null || reviewedProducts === void 0 ? void 0 : reviewedProducts.find(function(review) {
        var ref;
        return review.productId === ((ref = item.product) === null || ref === void 0 ? void 0 : ref.id);
    })) === null || ref === void 0 ? void 0 : ref.rating;
    var product = item.product;
    var _pathName, ref1;
    return /*#__PURE__*/ react.createElement(MyProductsRowWrapper, null, (product === null || product === void 0 ? void 0 : product.media.first) && /*#__PURE__*/ react.createElement(ProductImageLink, {
        to: (_pathName = product.pathName) !== null && _pathName !== void 0 ? _pathName : ""
    }, /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
        name: product.name,
        src: product.media.first
    })), /*#__PURE__*/ react.createElement(ProductInfo, null, /*#__PURE__*/ react.createElement(ProductLink, {
        to: (ref1 = product === null || product === void 0 ? void 0 : product.pathName) !== null && ref1 !== void 0 ? ref1 : ""
    }, product === null || product === void 0 ? void 0 : product.name), (product === null || product === void 0 ? void 0 : product.category) && /*#__PURE__*/ react.createElement(styles_Subtitle, null, product === null || product === void 0 ? void 0 : product.category.name), /*#__PURE__*/ react.createElement(RatingWrapper, null, /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating,
        size: "small"
    }), !rating && product && /*#__PURE__*/ react.createElement(components_prompt/* default */.Z, {
        belongsTo: _objectSpreadProps(_objectSpread({}, product), {
            type: "product"
        }),
        control: /*#__PURE__*/ react.createElement(clickable.Clickable, null, /*#__PURE__*/ react.createElement(CreateReviewButton, null, t("reviews", "button.write-review")))
    })), /*#__PURE__*/ react.createElement(styles_PriceRow, null, ((product === null || product === void 0 ? void 0 : product.priceSummary.regular) || (product === null || product === void 0 ? void 0 : product.priceSummary.alternative)) && /*#__PURE__*/ react.createElement(list_price, {
        price: product.priceSummary.regular || product.priceSummary.alternative,
        quantity: item === null || item === void 0 ? void 0 : item.quantity
    }), updateQuantity && /*#__PURE__*/ react.createElement(quantity, {
        item: item,
        updateQuantity: updateQuantity
    }))));
});


// EXTERNAL MODULE: ./src/areas/sidebar/components/item-list/styles.ts
var item_list_styles = __webpack_require__(24279);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/item-list/list-item.tsx









var withLink = function(to, component) {
    return to ? /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: to
    }, component) : component;
};
var ListItem = function(props) {
    var _draggable = props.draggable, draggable = _draggable === void 0 ? false : _draggable, item = props.item, deleted = props.deleted, onClick = props.onClick, createAlert = props.createAlert, onEdit = props.onEdit, onDelete = props.onDelete, onCopy = props.onCopy, updateQuantity = props.updateQuantity, hasDragHandle = props.hasDragHandle, isMyProducts = props.isMyProducts, isPublicProfile = props.isPublicProfile;
    var canEdit = item.__typename !== "AlertSearch";
    var editControl = (0,react.useRef)(null);
    var showEditControl = onEdit || onDelete || createAlert || onCopy;
    var editControlElement = showEditControl ? /*#__PURE__*/ react.createElement("div", {
        ref: editControl
    }, /*#__PURE__*/ react.createElement(edit_control, {
        canEdit: canEdit,
        item: item,
        onDelete: onDelete,
        createAlert: createAlert,
        onEdit: onEdit,
        onCopy: onCopy,
        isPublicProfile: isPublicProfile
    })) : null;
    var renderListItem = function() {
        switch(item.__typename){
            case "AlertProduct":
                if (!item.product) {
                    return /*#__PURE__*/ react.createElement(item_list_styles/* NotFound */.ar, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                        domain: "alerts"
                    }, "list.no-product-found"));
                }
                return withLink(item.product.pathName, /*#__PURE__*/ react.createElement(product_row, {
                    item: item
                }));
            case "AlertSearch":
                if (!item.search) {
                    return /*#__PURE__*/ react.createElement(item_list_styles/* NotFound */.ar, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                        domain: "alerts"
                    }, "list.no-search-found"));
                }
                return withLink(item.search.pathName, /*#__PURE__*/ react.createElement(item_row, {
                    name: item.search.name,
                    type: item.__typename,
                    subtitle: /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                        domain: "alerts",
                        n: item.search.productsCount
                    }, "list.n-products-found")
                }));
            case "ListProduct":
                if (isMyProducts && item.product) {
                    return /*#__PURE__*/ react.createElement(MyProductsRow, {
                        item: item,
                        updateQuantity: updateQuantity
                    });
                }
                return item.product ? withLink(item.product.pathName, /*#__PURE__*/ react.createElement(product_row, {
                    item: item,
                    updateQuantity: updateQuantity
                })) : /*#__PURE__*/ react.createElement(item_list_styles/* NotFound */.ar, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                    domain: "alerts"
                }, "list.no-product-found"));
            case "ListSearch":
                if (!item.search) {
                    return /*#__PURE__*/ react.createElement(item_list_styles/* NotFound */.ar, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                        domain: "alerts"
                    }, "list.no-search-found"));
                }
                return withLink(item.search.pathName, /*#__PURE__*/ react.createElement(item_row, {
                    name: item.search.name,
                    type: item.__typename,
                    subtitle: /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                        domain: "lists",
                        n: item.search.productsCount
                    }, "list.n-products")
                }));
            case "ListCategory":
                {
                    var listItemRow = /*#__PURE__*/ react.createElement(item_row, {
                        name: item.name,
                        icon: item.icon,
                        type: item.__typename,
                        subtitle: /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                            domain: "lists",
                            n: item.itemsCount
                        }, "list.n-items")
                    });
                    if (!isPublicProfile) {
                        return listItemRow;
                    }
                    return withLink(item.pathName, listItemRow);
                }
            default:
                return null;
        }
    };
    var handleClick = (0,react.useCallback)(function(e) {
        if (!onClick) {
            return;
        }
        // Dont nagivate to list/alert if clicking the edit button
        if (editControl.current && editControl.current.contains(e.target)) return;
        onClick(item.id);
    }, [
        item.id,
        onClick
    ]);
    var listItemStyling = [
        "ListCategory"
    ].includes(item.__typename) ? "background" : "lines";
    return /*#__PURE__*/ react.createElement(item_list_styles/* ListItem */.HC, {
        key: item.id,
        styling: listItemStyling,
        deleting: deleted ? Boolean(deleted[item.id]) : false,
        onClick: handleClick,
        draggable: draggable,
        hasDragHandle: hasDragHandle
    }, draggable && !hasDragHandle && /*#__PURE__*/ react.createElement(item_list_styles/* DragIcon */.Vn, {
        size: base/* layout.dragAndDropHandleSize.desktop.value */.bK.dragAndDropHandleSize.desktop.value
    }), /*#__PURE__*/ react.createElement(item_list_styles/* Content */.VY, null, renderListItem()), /*#__PURE__*/ react.createElement(item_list_styles/* EditControl */.$P, {
        absolutePositioned: item.__typename !== "ListCategory"
    }, editControlElement));
};


/***/ }),

/***/ 24279:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": () => (/* binding */ EditControl),
/* harmony export */   "HC": () => (/* binding */ ListItem),
/* harmony export */   "TX": () => (/* binding */ LoginButton),
/* harmony export */   "VY": () => (/* binding */ Content),
/* harmony export */   "Vn": () => (/* binding */ DragIcon),
/* harmony export */   "Zg": () => (/* binding */ ButtonsWrapper),
/* harmony export */   "ar": () => (/* binding */ NotFound),
/* harmony export */   "fr": () => (/* binding */ LoadMore),
/* harmony export */   "zF": () => (/* binding */ Unauthenticated)
/* harmony export */ });
/* unused harmony exports QuantityControls, PlaceholderListItem, CreateAccountButton, PromoText */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _icons_drag_indicator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15794);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25670);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90081);
/* harmony import */ var _item_row_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31651);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        max-width: calc(100% - ",
        ");\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      border-radius: ",
        ";\n      background: ",
        ";\n      transition: background 150ms ease;\n\n      &:hover {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        padding-left: ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n\n      ",
        " {\n        position: absolute;\n        left: -",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      transition:\n        max-height ",
        "ms ease,\n        opacity ",
        "ms ease;\n      opacity: 0;\n      max-height: 0;\n      overflow: hidden;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  opacity: 1;\n  position: relative;\n  margin-bottom: ",
        ";\n\n  ",
        ";\n\n  ",
        ";\n\n  ",
        ";\n\n  ",
        "\n\n  .list-dropdown {\n    .ui-dropdown--header {\n      padding: 0;\n    }\n    .ui-dropdown--list-expanded {\n      z-index: 2;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  overflow: hidden;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n\n  button {\n    width: 25px;\n    height: 25px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  height: 60px;\n  padding-left: 10px;\n  display: flex;\n  align-items: center;\n  font-style: italic;\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 65px; /* Stops content from jumping when the spinner appears */\n\n  > button {\n    display: flex;\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  pointer-events: none;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n     max-width: 267px;\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n     max-width: 100%;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  &:not(:last-of-type) {\n    margin-bottom: ",
        ";\n    text-align: center;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n     max-width: 267px;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n     max-width: 100%;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  &:not(:last-of-type) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin: ",
        " ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n      margin-right: 0;\n      position: absolute;\n      top: ",
        ";\n      right: ",
        ";\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 0;\n  "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 ",
        " 0\n    ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}






var padding = src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050;
var DragIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_icons_drag_indicator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "DragIcon",
    componentId: "sc-0-0"
})(_templateObject());
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-1"
})(_templateObject6(), function(p) {
    return p.draggable ? 0 : src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050;
}, function(p) {
    return p.draggable && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.dragAndDropHandleSize.mobile.rem */ .bK.dragAndDropHandleSize.mobile.rem));
}, function(p) {
    return p.styling === "background" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.borderRadius */ .bK.borderRadius, p.theme.bg.secondary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.shadeColor */ .$n.shadeColor(p.theme.bg.secondary, -5), _item_row_styles__WEBPACK_IMPORTED_MODULE_5__/* .ItemRow */ .FD, p.draggable && !p.hasDragHandle ? 0 : padding);
}, function(p) {
    return p.styling === "lines" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), p.theme.lines.primary, DragIcon, padding);
}, function(props) {
    return props.deleting && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject5(), _constants__WEBPACK_IMPORTED_MODULE_4__/* .LIST_DELETE_TRANSITION_TIME */ .E8, _constants__WEBPACK_IMPORTED_MODULE_4__/* .LIST_DELETE_TRANSITION_TIME */ .E8);
});
ListItem.defaultProps = {
    styling: "lines"
};
var Content = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-2"
})(_templateObject7());
var QuantityControls = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "QuantityControls",
    componentId: "sc-0-3"
})(_templateObject8());
var NotFound = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "NotFound",
    componentId: "sc-0-4"
})(_templateObject9(), function(p) {
    return p.theme.text.tertiary;
});
var LoadMore = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "LoadMore",
    componentId: "sc-0-5"
})(_templateObject10());
var PlaceholderListItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(ListItem).withConfig({
    displayName: "PlaceholderListItem",
    componentId: "sc-0-6"
})(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var LoginButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.PrimaryButton).withConfig({
    displayName: "LoginButton",
    componentId: "sc-0-7"
})(_templateObject14(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject12()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallDown */ .BC.smallDown(_templateObject13()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var CreateAccountButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.OutlinedButton).withConfig({
    displayName: "CreateAccountButton",
    componentId: "sc-0-8"
})(_templateObject17(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject15()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallDown */ .BC.smallDown(_templateObject16()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var PromoText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({
    displayName: "PromoText",
    componentId: "sc-0-9"
})(_templateObject18(), function(param) {
    var theme = param.theme;
    return theme.text.tertiary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var EditControl = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "EditControl",
    componentId: "sc-0-10"
})(_templateObject20(), padding, function(p) {
    return p.absolutePositioned && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject19(), padding, padding);
});
var Unauthenticated = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Unauthenticated",
    componentId: "sc-0-11"
})(_templateObject21(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var ButtonsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ButtonsWrapper",
    componentId: "sc-0-12"
})(_templateObject23(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallDown */ .BC.smallDown(_templateObject22()));


/***/ }),

/***/ 31651:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": () => (/* binding */ ItemRow),
/* harmony export */   "JO": () => (/* binding */ Icon),
/* harmony export */   "VG": () => (/* binding */ Name),
/* harmony export */   "W1": () => (/* binding */ SearchIcon),
/* harmony export */   "XF": () => (/* binding */ Count),
/* harmony export */   "kI": () => (/* binding */ Info)
/* harmony export */ });
/* unused harmony exports Image, PlaceholderInfo, MoreMenu, PlaceHolderLineOfText, PlaceHolderPriceChange, CreateListIcon */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_icon_magnifier__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83830);
/* harmony import */ var _prisjakt_ui_icon_heart_outlined__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72183);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 100%;\n  flex-direction: column;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: ",
        ";\n  text-align: left;\n  width: 100%;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  background: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 40px;\n  max-height: 40px;\n  mix-blend-mode: multiply;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: 100%;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 2px;\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  margin: 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: ",
        ";\n  top: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  border-radius: 1px;\n  height: 1em;\n  opacity: 0.25;\n  :not(:first-child) {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  float: right;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}




var padding = src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050;
var sharedInfoStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
var ItemRow = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ItemRow",
    componentId: "sc-0-0"
})(_templateObject1(), padding);
var Icon = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Icon",
    componentId: "sc-0-1"
})(_templateObject2(), padding, function(p) {
    return p.border ? p.theme.bg.secondary : "transparent";
}, function(p) {
    return p.border ? "".concat(padding) : 0;
}, function(p) {
    return p.border ? "50%" : 0;
});
var SearchIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_magnifier__WEBPACK_IMPORTED_MODULE_2__/* .IconMagnifier */ .j).attrs({
    color: "base500"
}).withConfig({
    displayName: "SearchIcon",
    componentId: "sc-0-2"
})(_templateObject3());
var Image = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-3"
})(_templateObject4());
var Info = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Info",
    componentId: "sc-0-4"
})(_templateObject5(), sharedInfoStyling);
var PlaceholderInfo = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "PlaceholderInfo",
    componentId: "sc-0-5"
})(_templateObject6(), sharedInfoStyling);
var Name = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({
    displayName: "Name",
    componentId: "sc-0-6"
})(_templateObject8(), function(p) {
    return p.bold ? "600" : "normal";
}, function(p) {
    return p.theme.text.primary;
}, function(p) {
    return(// Truncate list name if its too long
    p.truncate && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7()));
});
var Count = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({
    displayName: "Count",
    componentId: "sc-0-7"
})(_templateObject9(), function(p) {
    return p.theme.colors.base500;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall);
var MoreMenu = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MoreMenu",
    componentId: "sc-0-8"
})(_templateObject10(), padding, padding);
var PlaceHolderLineOfText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "PlaceHolderLineOfText",
    componentId: "sc-0-9"
})(_templateObject11(), function(p) {
    return p.theme.colors.base300;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var PlaceHolderPriceChange = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(PlaceHolderLineOfText).withConfig({
    displayName: "PlaceHolderPriceChange",
    componentId: "sc-0-10"
})(_templateObject12(), function(param) {
    var isPositive = param.isPositive, theme = param.theme;
    return isPositive ? theme.colors.positive500 : theme.colors.negative700;
});
var CreateListIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_heart_outlined__WEBPACK_IMPORTED_MODULE_3__/* .IconHeartOutlined */ .G).attrs({
    color: "base300"
}).withConfig({
    displayName: "CreateListIcon",
    componentId: "sc-0-11"
})(_templateObject13());


/***/ }),

/***/ 72418:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": () => (/* binding */ SearchMode),
  "Z": () => (/* binding */ container)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(66292);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(27019);
// EXTERNAL MODULE: ./src/components/entity-search/qeuries/query.graphql
var query_graphql = __webpack_require__(40877);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/components/entity-search/qeuries/use-entity-search-query.ts


var useEntitySearchQuery = function(searchQuery, stores, products) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (query_graphql_default()),
        queryKey: [
            "entity-search"
        ],
        variables: {
            query: searchQuery,
            stores: stores,
            products: products
        }
    });
};

;// CONCATENATED MODULE: ./src/components/entity-search/container.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var SearchMode;
(function(SearchMode) {
    SearchMode["PRODUCTS"] = "products";
    SearchMode["SHOPS"] = "shops";
})(SearchMode || (SearchMode = {}));
var SearchContainer = function(param) {
    var query = param.query, onSearchResultFound = param.onSearchResultFound, disableScrollToTop = param.disableScrollToTop, render = param.render, searchMode = param.searchMode;
    var ref, ref1;
    var ref2 = _slicedToArray((0,react.useState)(""), 2), searchQuery = ref2[0], setSearchQuery = ref2[1];
    var mounted = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        debounce_default()(function() {
            setSearchQuery(query);
        }, 300);
    }, [
        query
    ]);
    var ref3 = useEntitySearchQuery(searchQuery, Boolean(searchMode === "shops"), Boolean(searchMode === "products")), data = ref3.data, isLoading = ref3.isLoading;
    (0,react.useEffect)(function() {
        if (!disableScrollToTop) {
            // Reset scroll position for small devices
            if ( true && window.innerWidth <= 620) {
                window.scrollTo(0, 0);
            }
        }
    }, [
        disableScrollToTop
    ]);
    (0,react.useEffect)(function() {
        setSearchQuery(query);
    }, [
        query
    ]);
    (0,react.useEffect)(function() {
        var ref;
        onSearchResultFound === null || onSearchResultFound === void 0 ? void 0 : onSearchResultFound(data === null || data === void 0 ? void 0 : (ref = data.newSearch) === null || ref === void 0 ? void 0 : ref.results);
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.newSearch) === null || ref === void 0 ? void 0 : ref.results,
        onSearchResultFound
    ]);
    (0,react.useEffect)(function() {
        mounted.current = true;
    }, []);
    return render(data === null || data === void 0 ? void 0 : (ref1 = data.newSearch) === null || ref1 === void 0 ? void 0 : ref1.results, isLoading);
};
/* harmony default export */ var container = (SearchContainer);


/***/ }),

/***/ 98473:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": () => (/* binding */ SearchBox)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/entity-search/container.tsx + 1 modules
var container = __webpack_require__(72418);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(79393);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/entity-search/components/selectable/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n      border-radius: 5px;\n\n      > a {\n        background: none;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SearchSelectable = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchSelectable",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.selected && (0,styled_components_browser_esm.css)(_templateObject(), base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.colors.maybeBlue700, 0.2));
}, function(p) {
    return p.theme.colors.base100;
});

;// CONCATENATED MODULE: ./src/components/entity-search/components/selectable/selectable.tsx


var Selectable = function(props) {
    var isSelected = String(props.selected) === String(props.id);
    return /*#__PURE__*/ react.createElement(SearchSelectable, {
        selected: isSelected,
        role: "option",
        "aria-selected": isSelected,
        "data-selected": isSelected,
        "data-query": props.query,
        "data-selection-id": props.id,
        id: "selection".concat(props.id)
    }, props.children);
};
/* harmony default export */ var selectable = (Selectable);

// EXTERNAL MODULE: ./src/components/product-row/index.tsx + 1 modules
var product_row = __webpack_require__(24562);
// EXTERNAL MODULE: ./src/components/list-item/index.tsx
var list_item = __webpack_require__(91441);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(95242);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(46256);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/outgoing-link/index.js
var outgoing_link = __webpack_require__(89975);
;// CONCATENATED MODULE: ./src/components/entity-search/components/item/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  height: 24px;\n  img {\n    height: 16px;\n    width: auto;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  .pj-ui-product-list-item--grid:hover &,\n  .pj-ui-product-row:hover & {\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-left: 5px;\n  vertical-align: -2px;\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledListItem = (0,styled_components_browser_esm["default"])(list_item/* ListItem */.H).withConfig({
    displayName: "StyledListItem",
    componentId: "sc-0-0"
})({
    "&&": {
        img: {
            marginRight: "10px"
        }
    }
});
var StoreLogo = (0,styled_components_browser_esm["default"])(store_logo/* StoreLogo */.Xv).withConfig({
    displayName: "StoreLogo",
    componentId: "sc-0-1"
})(styles_templateObject());
var OutlinkCallToAction = styled_components_browser_esm["default"].span.withConfig({
    displayName: "OutlinkCallToAction",
    componentId: "sc-0-2"
})(styles_templateObject1(), function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.theme.colors.maybeBlue500;
});
var OutlinkIcon = (0,styled_components_browser_esm["default"])(outgoing_link/* IconOutgoingLink */.v).withConfig({
    displayName: "OutlinkIcon",
    componentId: "sc-0-3"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/components/entity-search/components/item/item.tsx






var SearchItem = function(param) {
    var item = param.item, onSelect = param.onSelect;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var onClickHandler = function(e) {
        if (onSelect) {
            e.preventDefault();
            onSelect(item);
        }
    };
    switch(item.__typename){
        case "Product":
            var ref, ref1, ref2, ref3;
            return /*#__PURE__*/ react.createElement(product_row/* default */.Z, {
                onClick: onClickHandler,
                name: item.name,
                link: item.pathName,
                price: item.priceSummary.regular,
                subtitle: (ref = item.category) === null || ref === void 0 ? void 0 : ref.name,
                image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                    name: item.name,
                    src: item.media.first
                }),
                rating: (ref1 = item.aggregatedRating) === null || ref1 === void 0 ? void 0 : ref1.score,
                ratingCount: (ref2 = item.aggregatedRating) === null || ref2 === void 0 ? void 0 : ref2.count,
                storesCount: item.priceSummary.count || undefined,
                storesCountText: t("campaigns", "item.sold-by-n-stores", {
                    n: ((ref3 = item.priceSummary.count) === null || ref3 === void 0 ? void 0 : ref3.toString()) || ""
                }),
                showDivider: true
            });
        case "Store":
            {
                return /*#__PURE__*/ react.createElement(list_item/* ListItem */.H, {
                    name: item.name,
                    link: item.pathName,
                    onClick: onClickHandler,
                    image: item.hasLogo && item.logo && /*#__PURE__*/ react.createElement(StoreLogo, {
                        storeId: item.id,
                        name: item.name,
                        hasImage: item.hasLogo,
                        featured: true
                    }),
                    showArrow: true
                });
            }
        default:
            return null;
    }
};
/* harmony default export */ var item = (/*#__PURE__*/(0,react.memo)(SearchItem));

// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(61061);
;// CONCATENATED MODULE: ./src/components/entity-search/styles.ts
function entity_search_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function entity_search_styles_templateObject() {
    var data = entity_search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  padding: ",
        " 10px;\n"
    ]);
    entity_search_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function entity_search_styles_templateObject1() {
    var data = entity_search_styles_taggedTemplateLiteral([
        "\n  padding-top: 10px;\n"
    ]);
    entity_search_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = entity_search_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = entity_search_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n  background: white;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = entity_search_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = entity_search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  padding: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var NoResults = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NoResults",
    componentId: "sc-0-0"
})(entity_search_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ShowAllSelectable = (0,styled_components_browser_esm["default"])(selectable).withConfig({
    displayName: "ShowAllSelectable",
    componentId: "sc-0-1"
})(entity_search_styles_templateObject1());
var ProductListBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductListBox",
    componentId: "sc-0-2"
})(styles_templateObject2(), function(p) {
    return p.simple ? "0" : "10px";
});
var CategoryListBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryListBox",
    componentId: "sc-0-3"
})(_templateObject3(), function(p) {
    return p.simple ? "0" : "10px";
});
var NoResultContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NoResultContainer",
    componentId: "sc-0-4"
})(_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var SpinnerContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SpinnerContainer",
    componentId: "sc-0-5"
})(_templateObject5(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);

;// CONCATENATED MODULE: ./src/components/entity-search/render.tsx







var Style;
(function(Style) {
    Style["SIMPLE"] = "simple";
    Style["RICH"] = "rich";
    Style["NONE"] = "none";
})(Style || (Style = {}));
var SearchPage = function(props) {
    var ref;
    var query = props.query, onEnterSearchMenu = props.onEnterSearchMenu, onExitSearchMenu = props.onExitSearchMenu, onSelect = props.onSelect, results = props.results, styling = props.styling, isLoading = props.isLoading;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement("div", {
        className: "pj-ui-search" // Shop search has dependency on this className
        ,
        onMouseEnter: onEnterSearchMenu,
        onMouseLeave: onExitSearchMenu,
        onTouchStart: onEnterSearchMenu,
        onTouchEnd: onExitSearchMenu
    }, isLoading && /*#__PURE__*/ react.createElement(SpinnerContainer, null, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        isActive: true,
        position: "none",
        size: 24
    })), (results === null || results === void 0 ? void 0 : results.products) && results.products.nodes && ((ref = results.products.nodes) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(ProductListBox, {
        className: "pj-ui-search--products",
        simple: styling === "simple",
        role: "listbox"
    }, results.products.nodes.map(function(product) {
        return /*#__PURE__*/ react.createElement(selectable, {
            key: product.id,
            id: product.id
        }, /*#__PURE__*/ react.createElement(item, {
            item: product,
            onSelect: onSelect
        }));
    }))), (results === null || results === void 0 ? void 0 : results.shops) && results.shops.nodes && results.shops.nodes.length > 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(ProductListBox, {
        className: "pj-ui-search--products",
        simple: styling === "simple",
        role: "listbox"
    }, results.shops.nodes.map(function(store) {
        return /*#__PURE__*/ react.createElement(selectable, {
            key: store.id,
            id: store.id
        }, /*#__PURE__*/ react.createElement(item, {
            item: store,
            onSelect: onSelect
        }));
    }))), Boolean((results === null || results === void 0 ? void 0 : results.products) && results.products.nodes && results.products.nodes.length <= 0 || (results === null || results === void 0 ? void 0 : results.shops) && (results === null || results === void 0 ? void 0 : results.shops.nodes) && (results === null || results === void 0 ? void 0 : results.shops.nodes.length) <= 0) && /*#__PURE__*/ react.createElement(NoResults, null, /*#__PURE__*/ react.createElement("span", null, t("search", "no-search-results.title", {
        query: query
    }))));
};
/* harmony default export */ var render = (SearchPage);

;// CONCATENATED MODULE: ./src/components/entity-search/search.tsx



var Search = function(param) {
    var query = param.query, showAllResults = param.showAllResults, onSelect = param.onSelect, styling = param.styling, onItemClick = param.onItemClick, onEnter = param.onEnter, onExit = param.onExit, onSearchResultFound = param.onSearchResultFound, _disableScrollToTop = param.disableScrollToTop, disableScrollToTop = _disableScrollToTop === void 0 ? false : _disableScrollToTop, _inputMinLength = param.inputMinLength, inputMinLength = _inputMinLength === void 0 ? 2 : _inputMinLength, searchMode = param.searchMode;
    if (query.length < inputMinLength) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(container/* default */.Z, {
        query: query,
        disableScrollToTop: disableScrollToTop,
        onSearchResultFound: onSearchResultFound,
        searchMode: searchMode,
        render: function(results, isLoading) {
            return /*#__PURE__*/ react.createElement(render, {
                showAllResults: showAllResults,
                results: results,
                query: query,
                onSelect: onSelect,
                styling: styling,
                onItemClick: onItemClick,
                onEnterSearchMenu: onEnter,
                onExitSearchMenu: onExit,
                isLoading: isLoading
            });
        }
    });
};
/* harmony default export */ var entity_search_search = (Search);

// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(32741);
;// CONCATENATED MODULE: ./src/components/entity-search/search-box/components/related-products/styles.ts
function related_products_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function related_products_styles_templateObject() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 4;\n  box-shadow: ",
        ";\n"
    ]);
    related_products_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function related_products_styles_templateObject1() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: 0;\n"
    ]);
    related_products_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function related_products_styles_templateObject2() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    related_products_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n          top: 37px;\n        "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n      ",
        ";\n      top: 47px;\n\n      ",
        ", ",
        " {\n        padding: 0 ",
        ";\n      }\n\n      ",
        "\n    "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n    background: ",
        ";\n    border-radius: 4px;\n    width: 100%;\n\n    ",
        "\n  "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n          padding: 0 ",
        ";\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n    min-height: auto;\n\n    ",
        "\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var relatedProductsTitleFontSize = (0,base/* remCalc */.vR)(15);
var boxShadowStyle = "0px 6px 10px 0px rgba(0, 0, 0, 0.2)";
var relatedProductsOverlayStyles = (0,styled_components_browser_esm.css)(related_products_styles_templateObject(), boxShadowStyle);
var RelatedProductsTitle = styled_components_browser_esm["default"].h5.withConfig({
    displayName: "RelatedProductsTitle",
    componentId: "sc-0-0"
})(related_products_styles_templateObject1(), relatedProductsTitleFontSize, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var RelatedProductsSubTitle = styled_components_browser_esm["default"].p.withConfig({
    displayName: "RelatedProductsSubTitle",
    componentId: "sc-0-1"
})(related_products_styles_templateObject2(), function(p) {
    return p.theme.text.quaternary;
});
var RelatedProducts = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelatedProducts",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject5(), props.theme.colors.base0, props.relatedProductsAsOverlay && (0,styled_components_browser_esm.css)(styles_templateObject4(), relatedProductsOverlayStyles, RelatedProductsTitle, RelatedProductsSubTitle, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(styles_templateObject3())));
});
var ProductRow = (0,styled_components_browser_esm["default"])(product_row/* default */.Z).withConfig({
    displayName: "ProductRow",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject8(), props.showNewComparePageLayout && (0,styled_components_browser_esm.css)(_templateObject7(), base/* media.mediumDown */.BC.mediumDown(_templateObject6(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100)));
});

;// CONCATENATED MODULE: ./src/components/entity-search/search-box/components/related-products/index.tsx




var related_products_RelatedProducts = function(param) {
    var relatedProducts = param.relatedProducts, relatedProductsAsOverlay = param.relatedProductsAsOverlay, onSelect = param.onSelect, showNewComparePageLayout = param.showNewComparePageLayout;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(RelatedProducts, {
        relatedProductsAsOverlay: relatedProductsAsOverlay
    }, /*#__PURE__*/ react.createElement(RelatedProductsTitle, null, t("product", "recommendations.similar-products")), /*#__PURE__*/ react.createElement(RelatedProductsSubTitle, null, t("compare", "related-products.add")), relatedProducts.map(function(relatedProduct) {
        var onClickHandler = function(e) {
            e.preventDefault();
            onSelect(relatedProduct);
        };
        return /*#__PURE__*/ react.createElement(ProductRow, {
            key: "related-product-".concat(relatedProduct.id),
            onClick: onClickHandler,
            name: relatedProduct.name,
            price: relatedProduct.price,
            image: relatedProduct.imageUrl && /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                name: relatedProduct.name,
                src: relatedProduct.imageUrl
            }),
            showDivider: true,
            showNewComparePageLayout: showNewComparePageLayout
        });
    }));
};
/* harmony default export */ var related_products = (related_products_RelatedProducts);

;// CONCATENATED MODULE: ./src/components/entity-search/search-box/styles.ts
function search_box_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function search_box_styles_templateObject() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n      border-bottom: none;\n      border-radius: 5px 5px 0px 0px;\n      * {\n        border-radius: 5px 5px 0px 0px;\n      }\n    "
    ]);
    search_box_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function search_box_styles_templateObject1() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    border: ",
        "px solid\n      ",
        ";\n    overflow: hidden;\n    border-bottom: ",
        "px solid\n      ",
        ";\n    border-radius: 5px;\n\n    ",
        "\n  "
    ]);
    search_box_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function search_box_styles_templateObject2() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n      position: absolute;\n    "
    ]);
    search_box_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function search_box_styles_templateObject3() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n        border: 1px solid ",
        ";\n        border-top: none;\n      "
    ]);
    search_box_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function search_box_styles_templateObject4() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n          top: ",
        ";\n        "
    ]);
    search_box_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function search_box_styles_templateObject5() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n          top: ",
        "px;\n        "
    ]);
    search_box_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n          top: {searchHeight}px;\n        "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n      left: 0;\n      right: 0;\n      border: none;\n      border-top: none;\n      z-index: 10;\n      box-shadow: ",
        ";\n\n      ",
        "\n\n      ",
        ";\n\n      ",
        ";\n\n      ",
        ";\n    "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n      padding: 0 ",
        ";\n    "
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n    ",
        "\n    background: ",
        ";\n    border-radius: 0px 0px 5px 5px;\n    overflow: hidden;\n    text-align: left;\n    box-shadow: ",
        ";\n\n    ",
        ";\n\n    .pj-ui-search--products {\n      padding-top: 0;\n    }\n\n    ",
        ";\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n          padding: 0 ",
        ";\n\n          ",
        " {\n            border-bottom: 1px solid ",
        ";\n            \n          }\n\n          ",
        " {\n            border: none;\n            box-shadow: none;\n          }\n        "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n\n    ",
        "\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var searchHeight = base/* layout.searchBar.height.desktop.value */.bK.searchBar.height.desktop.value;
var searchHeightMobile = base/* layout.searchBar.height.mobile.value */.bK.searchBar.height.mobile.value;
var searchBorderWidth = base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth;
var styles_boxShadowStyle = "0px 6px 10px 0px rgba(0, 0, 0, 0.2)";
var SearchInput = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchInput",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(search_box_styles_templateObject1(), base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth, function(p) {
        return p.theme.colors.maybeBlue700;
    }, base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth, function(p) {
        return p.theme.colors.maybeBlue700;
    }, props.searchIsOpen && (0,styled_components_browser_esm.css)(search_box_styles_templateObject()));
});
var SearchResult = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchResult",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject9(), props.useAbsolute && (0,styled_components_browser_esm.css)(search_box_styles_templateObject2()), props.theme.colors.base0, styles_boxShadowStyle, props.showFloatingResult && (0,styled_components_browser_esm.css)(styles_templateObject7(), styles_boxShadowStyle, props.searchIsOpen && (0,styled_components_browser_esm.css)(search_box_styles_templateObject3(), props.theme.colors.maybeBlue700), base/* media.smallOnly */.BC.smallOnly(search_box_styles_templateObject4(), props.showNewComparePageLayout ? "".concat(searchHeightMobile + searchBorderWidth * 2, "px") : "".concat(searchHeightMobile, "px")), base/* media.mediumOnly */.BC.mediumOnly(search_box_styles_templateObject5(), searchHeight + searchBorderWidth * 2), base/* media.largeUp */.BC.largeUp(styles_templateObject6())), base/* media.mediumDown */.BC.mediumDown(styles_templateObject8(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
});
var SearchWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchWrapper",
    componentId: "sc-0-2"
})(_templateObject10());
var styles_Search = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Search",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject13(), props.showNewComparePageLayout && (0,styled_components_browser_esm.css)(_templateObject12(), base/* media.mediumDown */.BC.mediumDown(_templateObject11(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, SearchInput, props.theme.colors.maybeBlue700, SearchResult)));
});

;// CONCATENATED MODULE: ./src/components/entity-search/search-box/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var INPUT_MIN_LENGTH = 2;
var SearchBox = function(param) {
    var _showNewComparePageLayout = param.showNewComparePageLayout, showNewComparePageLayout = _showNewComparePageLayout === void 0 ? false : _showNewComparePageLayout, _relatedProductsAsOverlay = param.relatedProductsAsOverlay, relatedProductsAsOverlay = _relatedProductsAsOverlay === void 0 ? false : _relatedProductsAsOverlay, _showFloatingResult = param.showFloatingResult, showFloatingResult = _showFloatingResult === void 0 ? true : _showFloatingResult, focusOnMount = param.focusOnMount, placeholder = param.placeholder, onSelect = param.onSelect, relatedProducts = param.relatedProducts, searchMode = param.searchMode, _useAbsolute = param.useAbsolute, useAbsolute = _useAbsolute === void 0 ? false : _useAbsolute;
    var searchRef = (0,react.useRef)(null);
    var searchInputRef = (0,react.useRef)(null);
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)(""), 2), inputValue = ref[0], setInputValueState = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(""), 2), search = ref1[0], setSearchState = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(false), 2), hasResultsState = ref2[0], setHasResultsState = ref2[1];
    var ref3 = _slicedToArray((0,react.useState)([]), 2), results = ref3[0], setResultsState = ref3[1];
    var resetSearch = function() {
        setSearchState("");
        setHasResultsState(false);
    };
    var handleOnChange = (0,react.useCallback)(function(searchTerm) {
        setSearchState(searchTerm);
        setHasResultsState(false);
    }, []);
    var handleOnFocus = (0,react.useCallback)(function(searchTerm) {
        if (searchTerm.length >= INPUT_MIN_LENGTH) {
            setSearchState(searchTerm);
            setHasResultsState(true);
        }
    }, []);
    var setInputValue = (0,react.useCallback)(function(input) {
        setInputValueState(input);
    }, []);
    var handleOnSelect = (0,react.useCallback)(function(product) {
        setInputValueState("");
        resetSearch();
        return onSelect(product);
    }, [
        onSelect
    ]);
    var handleSearchResultFound = (0,react.useCallback)(function() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        var ref;
        setHasResultsState(true);
        var ref1;
        setResultsState((ref1 = (ref = items[0]) === null || ref === void 0 ? void 0 : ref.hits) !== null && ref1 !== void 0 ? ref1 : []);
    }, []);
    var handleKeyDown = (0,react.useCallback)(function(e) {
        if (e.key === "Escape") {
            resetSearch();
        }
    }, []);
    var handleClickOutside = (0,react.useCallback)(function(e) {
        if (e.target && searchRef.current && !searchRef.current.contains(e.target)) {
            resetSearch();
        }
    }, []);
    (0,react.useEffect)(function() {
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("click", handleClickOutside);
        if (focusOnMount && searchInputRef.current) {
            var inputElement = searchInputRef.current.querySelector("input[type=text]");
            if (inputElement) {
                inputElement.focus();
            }
        }
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("click", handleClickOutside);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var searchIsOpen = inputValue.length >= INPUT_MIN_LENGTH && search !== "";
    var hasResults = hasResultsState && search !== "" && results && results.length > 0;
    return /*#__PURE__*/ react.createElement(SearchWrapper, {
        ref: searchRef
    }, /*#__PURE__*/ react.createElement(styles_Search, {
        showNewComparePageLayout: showNewComparePageLayout
    }, /*#__PURE__*/ react.createElement(SearchInput, {
        ref: searchInputRef,
        searchIsOpen: searchIsOpen
    }, /*#__PURE__*/ react.createElement(inputs/* Search */.ol, {
        key: "search",
        placeholder: placeholder || t("search", "search-products.placeholder"),
        hasResults: hasResults,
        onChange: handleOnChange,
        onFocus: handleOnFocus,
        inputValue: inputValue,
        setInputValue: setInputValue
    })), /*#__PURE__*/ react.createElement(SearchResult, {
        searchIsOpen: searchIsOpen,
        showFloatingResult: showFloatingResult,
        showNewComparePageLayout: showNewComparePageLayout,
        useAbsolute: useAbsolute
    }, /*#__PURE__*/ react.createElement(entity_search_search, {
        query: search,
        onSelect: handleOnSelect,
        showAllResults: false,
        styling: Style.NONE,
        disableScrollToTop: true,
        onSearchResultFound: handleSearchResultFound,
        inputMinLength: INPUT_MIN_LENGTH,
        searchMode: searchMode
    }))), relatedProducts && Boolean(relatedProducts.length) && !hasResults && Boolean(!searchIsOpen) && /*#__PURE__*/ react.createElement(related_products, {
        relatedProducts: relatedProducts,
        relatedProductsAsOverlay: relatedProductsAsOverlay,
        onSelect: handleOnSelect,
        showNewComparePageLayout: showNewComparePageLayout
    }));
};


/***/ }),

/***/ 64873:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ like_button)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/modal/login-promo.js + 1 modules
var login_promo = __webpack_require__(60428);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/components/like-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: nowrap;\n  color: ",
        ";\n  align-items: center;\n\n  &:hover {\n    color: ",
        ";\n    cursor: pointer;\n\n    path {\n      fill: ",
        ";\n    }\n  }\n\n  gap: ",
        ";\n  transition: gap 150ms ease;\n\n  ",
        " {\n    overflow: hidden;\n    transition: max-width 150ms ease;\n    max-width: ",
        ";\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var LikeText = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "LikeText",
    componentId: "sc-0-0"
})(_templateObject());
var StyledLikeButton = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "StyledLikeButton",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.theme.buttons.link.text;
}, function(p) {
    return p.theme.buttons.link.textHover;
}, function(p) {
    return p.theme.buttons.link.textHover;
}, function(p) {
    return p.liked ? 0 : base/* layout.measurements.spacing050 */.bK.measurements.spacing050;
}, LikeText, function(p) {
    return p.liked ? 0 : "999px";
});
var LikesWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "LikesWrapper",
    componentId: "sc-0-2"
})(_templateObject2());
var LikeIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LikeIconWrapper",
    componentId: "sc-0-3"
})(_templateObject3());

// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(73426);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/like-filled/index.js
var like_filled = __webpack_require__(46304);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/like-outlined/index.js
var like_outlined = __webpack_require__(59141);
;// CONCATENATED MODULE: ./src/components/like-button/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var LikeButton = function(param) {
    var className = param.className, onClick = param.onClick, liked = param.liked, likes = param.likes, _size = param.size, size = _size === void 0 ? 20 : _size, text = param.text;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var ref1 = _slicedToArray((0,react.useState)(likes), 2), likeScore = ref1[0], setLikeScore = ref1[1];
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var ref2 = _slicedToArray((0,react.useState)(false), 2), showLoginPromo = ref2[0], setShowLoginPromo = ref2[1];
    var handler = (0,react.useCallback)(function() {
        if (!isAuthenticated) {
            setShowLoginPromo(true);
            return;
        }
        onClick();
        // Fake a +1 in like score as the real data is not updated in real time
        if (!liked) {
            setLikeScore((likes || 0) + 1);
        }
    }, [
        onClick,
        likes,
        liked,
        isAuthenticated
    ]);
    var hideLoginPromo = (0,react.useCallback)(function() {
        setShowLoginPromo(false);
    }, []);
    if (!market.login.enabled) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, showLoginPromo ? /*#__PURE__*/ react.createElement(login_promo/* default */.Z, {
        isOpen: true,
        onRequestClose: hideLoginPromo
    }) : null, /*#__PURE__*/ react.createElement(StyledLikeButton, {
        onClick: handler,
        liked: liked,
        className: className
    }, /*#__PURE__*/ react.createElement(LikeText, null, text || t("reviews", "button.helpful")), /*#__PURE__*/ react.createElement(LikeIconWrapper, null, liked ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(like_filled/* IconLikeFilled */.G, {
        size: size,
        color: "maybeBlue700"
    }), /*#__PURE__*/ react.createElement(LikesWrapper, null, likeScore || 1)) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(like_outlined/* IconLikeOutlined */.q, {
        size: size,
        color: "maybeBlue700"
    }), /*#__PURE__*/ react.createElement(LikesWrapper, null, likes || null)))));
};
/* harmony default export */ var like_button = (LikeButton);


/***/ }),

/***/ 91441:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ ListItem)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40889);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var ListItem = function(param) {
    var children = param.children, name = param.name, link = param.link, image = param.image, callToActionText = param.callToActionText, showArrow = param.showArrow, showBackArrow = param.showBackArrow, _onClick = param.onClick, onClick = _onClick === void 0 ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT : _onClick, className = param.className, isExternal = param.isExternal, linkAttributes = param.linkAttributes, dataTest = param["data-test"], disabled = param.disabled;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ListItem */ .HC, _extends({
        onClick: onClick,
        className: className,
        to: link,
        isExternal: isExternal
    }, linkAttributes || {}, {
        "data-test": dataTest,
        disabled: disabled
    }), showBackArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .LeftArrow */ .IT, null), image && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, null, image), children, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Name */ .VG, null, name), callToActionText && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .CallToAction */ .Jd, null, callToActionText), showArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RightArrow */ .UV, null));
};


/***/ }),

/***/ 40889:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": () => (/* binding */ Image),
/* harmony export */   "HC": () => (/* binding */ ListItem),
/* harmony export */   "IT": () => (/* binding */ LeftArrow),
/* harmony export */   "Jd": () => (/* binding */ CallToAction),
/* harmony export */   "UV": () => (/* binding */ RightArrow),
/* harmony export */   "VG": () => (/* binding */ Name)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37456);
/* harmony import */ var _prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93345);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89218);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21541);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      cursor: default;\n      opacity: 0.5;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  min-height: 48px;\n  padding: ",
        " ",
        ";\n  text-align: left;\n  display: flex;\n  align-items: center;\n\n  /* Set the width and box-sizing to account for inconsistencies between <button> and <a> */\n  box-sizing: border-box;\n  width: 100%;\n\n  &:hover,\n  &.focus-visible {\n    background-color: ",
        ";\n    outline: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  flex: 0 1 50%;\n  margin-left: ",
        ";\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-left: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-right: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var padding = src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050;
var ListItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_3__/* .Clickable */ .P).withConfig({
    displayName: "ListItem",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.theme.text.primary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, padding, function(props) {
    return props.theme.bg.secondary;
}, function(props) {
    return props.disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
});
var Image = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(_templateObject2(), padding);
var Name = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.TitleSmallText).withConfig({
    displayName: "Name",
    componentId: "sc-0-2"
})(_templateObject3());
var CallToAction = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "CallToAction",
    componentId: "sc-0-3"
})(_templateObject4(), function(props) {
    return props.theme.text.callToAction;
}, padding);
var RightArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__.IconChevronRight).attrs({
    size: 20
}).withConfig({
    displayName: "RightArrow",
    componentId: "sc-0-4"
})(_templateObject5(), padding);
var LeftArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__.IconChevronLeft).attrs({
    size: 20
}).withConfig({
    displayName: "LeftArrow",
    componentId: "sc-0-5"
})(_templateObject6(), padding);


/***/ }),

/***/ 49192:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": () => (/* binding */ NumberPagination)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/components/number-pagination/pagination-items.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function notNull(item) {
    return item !== null;
}
function getPrevPageItem(currentPage, alwaysShowStepButtons) {
    if (currentPage === 1 && !alwaysShowStepButtons) {
        return null;
    }
    return {
        type: "prev",
        pageNumber: currentPage - 1,
        disabled: currentPage === 1
    };
}
function getFirstPageItem(nearbyPages) {
    var _Math;
    var firstNearbyPage = (_Math = Math).min.apply(_Math, _toConsumableArray(nearbyPages));
    if (firstNearbyPage === 1) {
        return null;
    }
    return {
        type: "first",
        pageNumber: 1,
        indicateOmittedPages: firstNearbyPage > 2 ? "after" : undefined
    };
}
function getNearbyPages(currentPage, totalPages) {
    var from = Math.max(1, Math.min(totalPages - 4, currentPage - 2));
    var to = Math.min(totalPages, Math.max(5, currentPage + 2));
    var pages = [];
    for(var i = from; i <= to; i += 1){
        var page = {
            type: "nearby-page",
            pageNumber: i,
            isCurrent: currentPage === i
        };
        if ([
            from,
            to
        ].includes(i) && !page.isCurrent) {
            page.omitOnSmallDevices = true;
        }
        pages.push(page);
    }
    return pages;
}
var getMidrangePage = function(position, nearbyPages, totalPages) {
    var _Math, _Math1;
    var threshold = 5;
    var firstNearbyPage = (_Math = Math).min.apply(_Math, _toConsumableArray(nearbyPages));
    var lastNearByPage = (_Math1 = Math).max.apply(_Math1, _toConsumableArray(nearbyPages));
    switch(position){
        case "before":
            if (firstNearbyPage < threshold) {
                return null;
            }
            return {
                type: "midrange",
                pageNumber: Math.ceil(firstNearbyPage / 2),
                indicateOmittedPages: "after"
            };
        case "after":
            if (lastNearByPage + threshold > totalPages) {
                return null;
            }
            return {
                type: "midrange",
                pageNumber: Math.floor((totalPages - lastNearByPage) / 2) + lastNearByPage,
                indicateOmittedPages: "before"
            };
        default:
            return null;
    }
};
function getLastPageItem(nearbyPages, totalPages) {
    var _Math;
    var lastNearbyPage = (_Math = Math).max.apply(_Math, _toConsumableArray(nearbyPages));
    if (lastNearbyPage === totalPages) {
        return null;
    }
    return {
        type: "last",
        pageNumber: totalPages,
        indicateOmittedPages: lastNearbyPage < totalPages - 1 ? "before" : undefined
    };
}
function getNextPageItem(currentPage, totalPages, alwaysShowStepButtons) {
    if (currentPage === totalPages && !alwaysShowStepButtons) {
        return null;
    }
    return {
        type: "next",
        pageNumber: currentPage + 1,
        disabled: currentPage === totalPages
    };
}
function getPaginationItems(currentPage, totalPages) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _alwaysShowStepButtons = ref.alwaysShowStepButtons, alwaysShowStepButtons = _alwaysShowStepButtons === void 0 ? false : _alwaysShowStepButtons;
    if (totalPages <= 1) {
        return [];
    }
    var clampedCurrentPage = Math.max(1, Math.min(totalPages, currentPage));
    var nearbyPages = getNearbyPages(clampedCurrentPage, totalPages);
    var nearbyPageNrs = nearbyPages.map(function(page) {
        return page.pageNumber;
    });
    return [
        getPrevPageItem(clampedCurrentPage, alwaysShowStepButtons),
        getFirstPageItem(nearbyPageNrs),
        getMidrangePage("before", nearbyPageNrs, totalPages)
    ].concat(_toConsumableArray(nearbyPages), [
        getMidrangePage("after", nearbyPageNrs, totalPages),
        getLastPageItem(nearbyPageNrs, totalPages),
        getNextPageItem(clampedCurrentPage, totalPages, alwaysShowStepButtons)
    ]).filter(notNull);
}

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/number-pagination/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  list-style: none;\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: ",
        ";\n      margin-right: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n\n    ",
        "\n\n    @media screen and (max-width: 420px) {\n      ",
        "\n\n      @media screen and (max-width: 350px) {\n        margin: 0 ",
        " 0 0;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  border-radius: 8px;\n  display: flex;\n  font-weight: 600;\n  height: 30px;\n  justify-content: center;\n  min-width: 30px;\n  padding: ",
        ";\n  transition: all ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  color: ",
        ";\n\n  &:hover,\n  &.focus-visible {\n    background: ",
        ";\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  box-shadow: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n  cursor: default;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  background: ",
        ";\n  color: ",
        ";\n  cursor: default;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var measurements = base/* layout.measurements */.bK.measurements, animations = base/* layout.animations */.bK.animations;
var Pagination = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "Pagination",
    componentId: "sc-0-0"
})(_templateObject());
var PaginationListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "PaginationListItem",
    componentId: "sc-0-1"
})(function(param) {
    var indicateOmittedPages = param.indicateOmittedPages, omitOnSmallDevices = param.omitOnSmallDevices;
    return (0,styled_components_browser_esm.css)(_templateObject2(), indicateOmittedPages === "before" ? measurements.spacing150 : 0, indicateOmittedPages === "after" ? measurements.spacing150 : measurements.spacing025, base/* media.smallOnly */.BC.smallOnly(_templateObject1(), indicateOmittedPages === "before" ? measurements.spacing050 : 0, indicateOmittedPages === "after" ? measurements.spacing050 : measurements.spacing025), omitOnSmallDevices ? "display: none;" : "", measurements.spacing025);
});
var paginationLinkStyles = (0,styled_components_browser_esm.css)(_templateObject4(), measurements.spacing050, animations.buttonTransition, base/* media.smallOnly */.BC.smallOnly(_templateObject3(), measurements.spacing025));
var PaginationLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "PaginationLink",
    componentId: "sc-0-2"
})(_templateObject5(), paginationLinkStyles, function(props) {
    return props.theme.colors.base800;
}, function(props) {
    return props.theme.colors.base200;
}, function(props) {
    return "transparent 0px 0px ".concat(props.theme.colors.base800, " 0px 0px 0px 1px");
});
var DisabledPaginationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "DisabledPaginationLink",
    componentId: "sc-0-3"
})(_templateObject6(), paginationLinkStyles, function(props) {
    return "inset 0 0 0 1px ".concat(props.theme.lines.primary);
}, function(props) {
    return props.theme.text.quaternary;
}, function(props) {
    return props.theme.bg.secondary;
});
var CurrentPaginationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CurrentPaginationLink",
    componentId: "sc-0-4"
})(_templateObject7(), paginationLinkStyles, function(props) {
    return props.theme.colors.maybeBlue500;
}, function(props) {
    return props.theme.colors.base0;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(37456);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(93345);
;// CONCATENATED MODULE: ./src/components/number-pagination/pagination-item.tsx





var PaginationItem = function(param) {
    var item = param.item, linkToPage = param.linkToPage, onClick = param.onClick;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var label = (0,react.useMemo)(function() {
        switch(item.type){
            case "prev":
                return /*#__PURE__*/ react.createElement(chevron_left.IconChevronLeft, null);
            case "next":
                return /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null);
            default:
                return /*#__PURE__*/ react.createElement(react.Fragment, null, item.pageNumber);
        }
    }, [
        item.type,
        item.pageNumber
    ]);
    var ariaLabel = (0,react.useMemo)(function() {
        switch(item.type){
            case "prev":
                return t("symbols", "symbol.show-prev-page");
            case "next":
                return t("symbols", "symbol.show-next-page");
            default:
                return t("common", "pagination.page-number", {
                    number: item.pageNumber
                });
        }
    }, [
        item.type,
        item.pageNumber,
        t
    ]);
    var onClickHandler = (0,react.useCallback)(function() {
        return typeof onClick === "function" && onClick(item);
    }, [
        item,
        onClick
    ]);
    if (item.disabled) {
        return /*#__PURE__*/ react.createElement(DisabledPaginationLink, null, label);
    }
    if (item.isCurrent) {
        return /*#__PURE__*/ react.createElement(CurrentPaginationLink, {
            "data-test": "CurrentPaginationLink"
        }, label);
    }
    return /*#__PURE__*/ react.createElement(PaginationLink, {
        to: linkToPage(item.pageNumber),
        "data-test": "PaginationLink",
        "data-test-page": item.pageNumber,
        onClick: onClickHandler,
        "aria-label": ariaLabel
    }, label);
};
/* harmony default export */ var pagination_item = (PaginationItem);

;// CONCATENATED MODULE: ./src/components/number-pagination/index.tsx




var NumberPagination = function(param) {
    var currentPage = param.currentPage, totalPages = param.totalPages, linkToPage = param.linkToPage, onClick = param.onClick, alwaysShowStepButtons = param.alwaysShowStepButtons;
    var paginationItems = (0,react.useMemo)(function() {
        return getPaginationItems(currentPage, totalPages, {
            alwaysShowStepButtons: alwaysShowStepButtons
        });
    }, [
        currentPage,
        totalPages,
        alwaysShowStepButtons
    ]);
    return /*#__PURE__*/ react.createElement(Pagination, {
        "data-test": "Pagination"
    }, paginationItems.map(function(item) {
        return /*#__PURE__*/ react.createElement(PaginationListItem, {
            key: "".concat(item.type, ":").concat(item.pageNumber),
            indicateOmittedPages: item.indicateOmittedPages,
            omitOnSmallDevices: item.omitOnSmallDevices
        }, /*#__PURE__*/ react.createElement(pagination_item, {
            item: item,
            linkToPage: linkToPage,
            onClick: onClick
        }));
    }));
};


/***/ }),

/***/ 53692:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mr": () => (/* reexport */ SIZE),
  "WX": () => (/* binding */ ProductCheckbox),
  "lo": () => (/* reexport */ hoverStyle)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/check/index.js
var check = __webpack_require__(24300);
;// CONCATENATED MODULE: ./src/components/product-checkbox/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  box-shadow: inset 0 0 0 2px ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  align-self: center;\n  background: ",
        ";\n  box-shadow: inset 0 0 0 1px ",
        ";\n  color: ",
        ";\n  border-radius: 3px;\n  cursor: pointer;\n  height: ",
        "px;\n  width: ",
        "px;\n  flex: 0 0 auto;\n  transition:\n    0.05s box-shadow linear,\n    0.05s background-color linear;\n\n  &:hover {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  appearance: none;\n  outline: 0;\n  opacity: 0;\n  position: absolute;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SIZE = 20;
var hoverStyle = (0,styled_components_browser_esm.css)(_templateObject(), function(props) {
    return props.theme.bg.productCompare;
});
var Wrapper = styled_components_browser_esm["default"].label.attrs({
    "data-test": "ProductCheckbox"
}).withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.selected ? props.theme.bg.productCompare : "transparent";
}, function(props) {
    return props.theme.bg.productCompare;
}, function(props) {
    return props.theme.colors.base0;
}, SIZE, SIZE, hoverStyle);
var Input = styled_components_browser_esm["default"].input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "Input",
    componentId: "sc-0-1"
})(_templateObject2());
var Icon = (0,styled_components_browser_esm["default"])(check/* IconCheck */.N).attrs({
    size: SIZE
}).withConfig({
    displayName: "Icon",
    componentId: "sc-0-2"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/product-checkbox/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var ProductCheckbox = function(_param) {
    var selected = _param.selected, name = _param.name, onSelect = _param.onSelect, onDeselect = _param.onDeselect, wrapperProps = _objectWithoutProperties(_param, [
        "selected",
        "name",
        "onSelect",
        "onDeselect"
    ]);
    var onChange = (0,react.useCallback)(function(e) {
        return e.target.checked ? onSelect === null || onSelect === void 0 ? void 0 : onSelect() : onDeselect === null || onDeselect === void 0 ? void 0 : onDeselect();
    }, [
        onSelect,
        onDeselect
    ]);
    return /*#__PURE__*/ react.createElement(Wrapper, _extends({
        selected: selected
    }, wrapperProps), /*#__PURE__*/ react.createElement(Input, {
        id: name,
        name: name,
        type: "checkbox",
        checked: selected,
        onChange: onChange,
        tabIndex: 0,
        value: selected ? "1" : "0"
    }), selected && /*#__PURE__*/ react.createElement(Icon, null));
};


/***/ }),

/***/ 24562:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ product_row)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(75695);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(34990);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/product-checkbox/index.tsx + 1 modules
var product_checkbox = __webpack_require__(53692);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/components/product-row/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 5px 10px;\n  outline: none;\n\n  :hover::after,\n  :focus::after {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " {\n        padding-left: ",
        "px;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "::before {\n        ",
        "\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  line-height: 1.2em;\n  min-height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  ",
        "\n  ",
        "\n  ",
        "\n\n  .pj-ui-product-core-properties {\n    margin: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n  background: ",
        ";\n  border-radius: ",
        ";\n\n  .pj-ui-product-image {\n    display: block;\n    max-width: 40px;\n    max-height: 40px;\n    width: auto;\n    height: auto;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 100%;\n  margin-right: 3px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  :not(:last-child) {\n    margin-bottom: 1px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  margin-left: 10px;\n  white-space: nowrap;\n  text-align: right;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  font-size: 12px;\n  color: ",
        ";\n  fill: ",
        ";\n  align-items: center;\n\n  svg {\n    height: 16px !important;\n    width: 16px !important;\n    margin-left: 2px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: ",
        ";\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n\n  ",
        ":hover & {\n    ",
        "\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  min-width: 80px;\n  margin: ",
        ";\n  display: flex;\n  justify-content: end;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: -",
        ";\n  z-index: 2;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}




var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-0"
})(_templateObject(), base/* styledUtils.overlay */.au.overlay());
var Row = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ProductRow"
}).withConfig({
    displayName: "Row",
    componentId: "sc-0-1"
})(_templateObject4(), function(props) {
    return props.showDivider && (0,styled_components_browser_esm.css)(_templateObject1(), function(p) {
        return p.theme.lines.primary;
    });
}, function(props) {
    return props.selectable && (0,styled_components_browser_esm.css)(_templateObject2(), ProductLink, product_checkbox/* PRODUCT_CHECKBOX_SIZE */.mr + (0,base/* pixelCalc */.A)(base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
}, function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(_templateObject3(), ProductLink, base/* styledUtils.overlay */.au.overlay(props.theme.bg.productCompareLight));
});
var ProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-2"
})(_templateObject5(), function(p) {
    return p.theme.colors.base200;
}, base/* layout.borderRadius */.bK.borderRadius);
var BasicInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BasicInfo",
    componentId: "sc-0-3"
})(_templateObject6());
var ProductName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductName",
    componentId: "sc-0-4"
})(_templateObject7());
var Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-5"
})(_templateObject8(), function(p) {
    return p.theme.text.tertiary;
});
var PriceLabelWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "PriceLabelWrapper",
    componentId: "sc-0-6"
})(_templateObject9());
var StoreCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StoreCount",
    componentId: "sc-0-7"
})(_templateObject10(), function(p) {
    return p.theme.text.tertiary;
}, function(p) {
    return p.theme.icons.tertiary;
});
var Gutter = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Gutter",
    componentId: "sc-0-8"
})(_templateObject11());
var SelectBox = (0,styled_components_browser_esm["default"])(product_checkbox/* ProductCheckbox */.WX).withConfig({
    displayName: "SelectBox",
    componentId: "sc-0-9"
})(_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Row, product_checkbox/* productCheckboxHoverStyle */.lo);
var CampaignBadgeWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CampaignBadgeWrapper",
    componentId: "sc-0-10"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CampaignBadge = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CampaignBadge",
    componentId: "sc-0-11"
})(_templateObject14(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/shopping-cart/index.js
var shopping_cart = __webpack_require__(54497);
;// CONCATENATED MODULE: ./src/components/product-row/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}





var ProductRow = function(param) {
    var onClick = param.onClick, linkAttributes = param.linkAttributes, _link = param.link, link = _link === void 0 ? "" : _link, image = param.image, name = param.name, rating = param.rating, subtitle = param.subtitle, campaignBadge = param.campaignBadge, ratingCount = param.ratingCount, _ratingCountTranslation = param.ratingCountTranslation, ratingCountTranslation = _ratingCountTranslation === void 0 ? {
        domain: "product",
        key: "product-card.n-ratings"
    } : _ratingCountTranslation, price = param.price, storesCount = param.storesCount, storesCountText = param.storesCountText, children = param.children, className = param.className, showDivider = param.showDivider, selectable = param.selectable, selected = param.selected, onSelect = param.onSelect, onDeselect = param.onDeselect;
    var onToggle = selected ? onDeselect : onSelect;
    var clickHandler = (0,react.useCallback)(function(e) {
        if (selectable) {
            e.preventDefault();
            onToggle === null || onToggle === void 0 ? void 0 : onToggle();
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [
        selectable,
        onToggle,
        onClick
    ]);
    return /*#__PURE__*/ react.createElement(Row, {
        className: className,
        showDivider: showDivider,
        selectable: selectable,
        selected: selected
    }, /*#__PURE__*/ react.createElement(ProductLink, _extends({
        onClick: clickHandler
    }, linkAttributes || {}, {
        to: link,
        "aria-label": name
    }), image && /*#__PURE__*/ react.createElement(ProductImage, null, image), /*#__PURE__*/ react.createElement(BasicInfo, null, /*#__PURE__*/ react.createElement(ProductName, null, name), rating ? /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        hide: rating === null,
        rate: rating,
        showRate: true,
        size: "small",
        count: ratingCount,
        countTranslation: ratingCountTranslation,
        showCounter: true
    }) : null, subtitle && /*#__PURE__*/ react.createElement(Subtitle, null, subtitle)), campaignBadge && /*#__PURE__*/ react.createElement(CampaignBadgeWrapper, null, /*#__PURE__*/ react.createElement(CampaignBadge, null, campaignBadge)), price && /*#__PURE__*/ react.createElement(PriceLabelWrapper, null, /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: price
    }), storesCount !== null && /*#__PURE__*/ react.createElement(StoreCount, {
        title: storesCountText
    }, /*#__PURE__*/ react.createElement("span", null, storesCount), " ", /*#__PURE__*/ react.createElement(shopping_cart/* IconShoppingCart */.w, {
        color: "base500"
    })))), children && /*#__PURE__*/ react.createElement(Gutter, null, children), selectable && /*#__PURE__*/ react.createElement(SelectBox, {
        selected: selected,
        onSelect: onSelect,
        onDeselect: onDeselect,
        "aria-label": name
    }));
};
/* harmony default export */ var product_row = (ProductRow);


/***/ }),

/***/ 30634:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": () => (/* binding */ ShopLinkCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(84234);
// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var product = __webpack_require__(69140);
// EXTERNAL MODULE: ./src/components/rating/rating-helper.ts
var rating_helper = __webpack_require__(51362);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/rating-icon/index.tsx + 1 modules
var rating_icon = __webpack_require__(8354);
// EXTERNAL MODULE: ./src/components/stock-status/index.tsx + 1 modules
var stock_status = __webpack_require__(73209);
// EXTERNAL MODULE: ./src/components/product-card-old/components/price.tsx
var components_price = __webpack_require__(45443);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(46256);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
;// CONCATENATED MODULE: ./src/components/shop-link-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: inherit;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n  padding: ",
        ";\n  min-height: 47px;\n\n  &::after {\n    ",
        "\n    border-radius: 5px;\n    pointer-events: none;\n    transition: background-color 150ms ease;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n\n  &:hover {\n    &::after {\n      background-color: rgba(0, 0, 0, 0.07);\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  min-width: 90px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    margin-right: ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  margin-left: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(59, 163, 212, 1);\n  box-shadow: 0px 2px 4px rgba(5, 37, 46, 0.24);\n  border-radius: ",
        ";\n  margin-left: ",
        ";\n  margin-top: -",
        ";\n  margin-bottom: -",
        ";\n  width: 36px;\n  height: 36px;\n\n  :hover {\n    cursor: pointer;\n  }\n\n  svg {\n    fill: rgba(255, 255, 255, 1);\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var BUTTON_MARGIN_UNFEATURED = 52;
var BUTTON_MARGIN_UNFEATURED_MOBILE = 44;
var sharedStyles = (0,styled_components_browser_esm.css)(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* styledUtils.overlay */.au.overlay());
var StoreLink = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "StoreLink",
    componentId: "sc-0-0"
})(_templateObject1(), sharedStyles);
var UnfeaturedStore = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UnfeaturedStore",
    componentId: "sc-0-1"
})(_templateObject2(), sharedStyles);
var Logo = (0,styled_components_browser_esm["default"])(store_logo/* StoreLogo */.Xv).withConfig({
    displayName: "Logo",
    componentId: "sc-0-2"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Count = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Count",
    componentId: "sc-0-3"
})(_templateObject4(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(p) {
    return p.theme.text.quaternary;
});
var PriceInformation = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceInformation",
    componentId: "sc-0-4"
})(_templateObject5());
var PriceWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceWrapper",
    componentId: "sc-0-5"
})(_templateObject7(), function(p) {
    return !p.$featured ? "".concat(BUTTON_MARGIN_UNFEATURED, "px") : "0";
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* media.smallOnly */.BC.smallOnly(_templateObject6(), function(p) {
    return !p.$featured ? "".concat(BUTTON_MARGIN_UNFEATURED_MOBILE, "px") : "-".concat(base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
}));
var OfferButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "OfferButton",
    componentId: "sc-0-6"
})(_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var RatingText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "RatingText",
    componentId: "sc-0-7"
})(_templateObject9(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(93345);
;// CONCATENATED MODULE: ./src/components/shop-link-card/components/price-information/index.tsx





var price_information_PriceInformation = function(props) {
    var price = props.price, stockStatus = props.stockStatus, isDeal = props.isDeal, featured = props.featured;
    return /*#__PURE__*/ react.createElement(PriceInformation, null, /*#__PURE__*/ react.createElement(stock_status/* StockStatus */.B, {
        status: stockStatus || undefined
    }), /*#__PURE__*/ react.createElement(PriceWrapper, {
        $featured: featured
    }, /*#__PURE__*/ react.createElement(components_price/* Price */.t, {
        price: price,
        isDeal: isDeal
    })), featured && /*#__PURE__*/ react.createElement(OfferButton, null, /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, {
        color: "base0"
    })));
};

// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts + 1 modules
var conversion = __webpack_require__(23513);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/utils.ts
var utils = __webpack_require__(53751);
;// CONCATENATED MODULE: ./src/components/shop-link-card/index.tsx











var ShopLinkCard = function(props) {
    var id = props.id, dataTest = props["data-test"], featured = props.featured, hasLogo = props.hasLogo, _isDeal = props.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, logoUrl = props.logoUrl, logoWidth = props.logoWidth, name = props.name, _numericRating = props.numericRating, numericRating = _numericRating === void 0 ? false : _numericRating, pathname = props.pathname, shopOfferId = props.shopOfferId, productId = props.productId, rating = props.rating, price = props.price, renderMode = props.renderMode, reviewCount = props.reviewCount, stockStatus = props.stockStatus, trackingScope = props.trackingScope;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var count = reviewCount && reviewCount > 500 ? "500+" : reviewCount;
    var featuredStore = Boolean(featured);
    var rate = rating_helper/* default.convert */.Z.convert(rating || 0);
    var smileyRating = (0,utils/* getSmileyRating */.P)(rate.real);
    var ratingType = numericRating ? rate.rounded : t("reviews", smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.text);
    var trackClickOut = function() {
        if (!shopOfferId || !productId) {
            return;
        }
        dispatch((0,product/* productPriceClick */.Po)(productId, price, featuredStore, "", false, "StoreCard"));
        if (trackingScope) {
            (0,conversion/* trackOfferClickWithRevenue */.Rx)({
                scope: trackingScope,
                offerId: "".concat(id, "-").concat(shopOfferId),
                isRawOffer: false,
                isPjDeal: isDeal ? true : undefined,
                priceType: "regular",
                hasShippingInfo: true
            });
        }
    };
    var renderContent = function() {
        /*#__PURE__*/ return react.createElement(react.Fragment, null, id && name && /*#__PURE__*/ react.createElement(Logo, {
            storeId: id,
            name: name,
            hasImage: Boolean(hasLogo),
            featured: featuredStore,
            logoUrl: logoUrl,
            width: logoWidth,
            showHighResolutionLogo: Boolean(logoUrl)
        }), rating && rating !== 0 && (smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.iconType) && (smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.text) ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(rating_icon/* default */.Z, {
            type: smileyRating.iconType,
            disabled: !featuredStore,
            ariaLabel: ratingType.toString()
        }), numericRating ? /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(RatingText, null, ratingType)) : /*#__PURE__*/ react.createElement(RatingText, null, ratingType), price ? /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(Count, null, "(", count, ")")) : /*#__PURE__*/ react.createElement(Count, null, "(", count, ")")) : null, price && /*#__PURE__*/ react.createElement(price_information_PriceInformation, {
            price: price,
            stockStatus: stockStatus,
            isDeal: isDeal,
            featured: featuredStore
        }));
    };
    if (!pathname) {
        return /*#__PURE__*/ react.createElement(UnfeaturedStore, null, renderContent());
    }
    return /*#__PURE__*/ react.createElement(StoreLink, {
        "data-test": dataTest,
        onClick: trackClickOut,
        to: pathname,
        isExternal: renderMode === "native",
        target: "_blank"
    }, renderContent());
};


/***/ }),

/***/ 61915:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ review_text)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/areas/reviews/review-context.tsx
var review_context = __webpack_require__(60039);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(37702);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/user-review-card-v2/components/review-text/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n\n  img {\n    margin-top: 2px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  button {\n    cursor: pointer;\n    text-decoration: underline;\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  margin: ",
        " 0;\n  border-radius: 5px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  padding-bottom: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  float: right;\n\n  &::first-letter {\n    text-transform: capitalize;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: pre-line;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      max-height: none;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    white-space: pre-line;\n    word-break: break-word;\n    font-weight: 400;\n    color: ",
        ";\n    max-height: 5.7ex;\n    overflow: hidden;\n\n    ",
        "\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 80ch;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: none;\n  margin-top: ",
        ";\n  font-size: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var TranslationOptions = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TranslationOptions",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.text.tertiary;
});
var TranslationOptionsService = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TranslationOptionsService",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var TranslationOptionsToggle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TranslationOptionsToggle",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var Reply = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Reply",
    componentId: "sc-0-3"
})(_templateObject3(), function(p) {
    return p.theme.bg.secondary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ReplyName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReplyName",
    componentId: "sc-0-4"
})(_templateObject4(), function(p) {
    return p.theme.text.secondary;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var ReplyDate = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ReplyDate",
    componentId: "sc-0-5"
})(_templateObject5());
var ReplyText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReplyText",
    componentId: "sc-0-6"
})(_templateObject6());
var TextLabel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextLabel",
    componentId: "sc-0-7"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject8(), function(p) {
        return p.theme.text.primary;
    }, props.fullText && (0,styled_components_browser_esm.css)(_templateObject7()));
});
var Text = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Text",
    componentId: "sc-0-8"
})(_templateObject9());
var ReadMore = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ReadMore",
    componentId: "sc-0-9"
})(_templateObject10(), function(p) {
    return p.theme.text.linkExternal;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, function(p) {
    return p.theme.text.linkExternalHover;
});
var ReviewContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReviewContentWrapper",
    componentId: "sc-0-10"
})(_templateObject11());

;// CONCATENATED MODULE: ./src/components/user-review-card-v2/components/review-text/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var ReviewText = function(param) {
    var id = param.id, translation = param.translation, text = param.text, reply = param.reply;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var onReviewExpansion = (0,review_context/* useReviewContext */.A)().onReviewExpansion;
    var ref = _slicedToArray((0,react.useState)(false), 2), showMore = ref[0], setShowMore = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), isExpanded = ref1[0], setIsExpanded = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(false), 2), showOriginal = ref2[0], setShowOriginal = ref2[1];
    var textNode = (0,react.useCallback)(function(node) {
        if (node && node.parentElement) {
            var textHeight = node.getBoundingClientRect().height;
            var wrapperHeight = node.parentElement.getBoundingClientRect().height;
            setShowMore(textHeight > wrapperHeight);
        }
    }, []);
    var collapseOrExpand = isExpanded ? "symbol.collapse" : "symbol.expand";
    var reviewTextIdentifier = "review-text-".concat(id);
    var expansionText = isExpanded ? t("common", "button.show-less") : t("common", "button.show-more");
    var reviewText = showOriginal && translation ? translation.text : text;
    var toggleExpansion = function() {
        setIsExpanded(!isExpanded);
        if (onReviewExpansion) onReviewExpansion();
    };
    var toggleTranslation = function() {
        setShowOriginal(!showOriginal);
    };
    var renderTranslation = function() {
        if (!translation || !translation.text) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(TranslationOptions, null, /*#__PURE__*/ react.createElement(TranslationOptionsService, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
            domain: "reviews"
        }, translation.service && translation.service.name ? "translation.translated-by-".concat(translation.service.name.toLowerCase(), ".md") : "translation.translated")), /*#__PURE__*/ react.createElement(TranslationOptionsToggle, null, /*#__PURE__*/ react.createElement("button", {
            type: "button",
            onClick: toggleTranslation
        }, showOriginal ? t("reviews", "translation.show-translation") : t("reviews", "translation.show-original"))));
    };
    var renderReply = function() {
        if (!reply || !reply.text) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(Reply, null, /*#__PURE__*/ react.createElement(ReplyName, null, t("reviews", "store.reply-by", {
            name: reply.name
        }), reply.date && /*#__PURE__*/ react.createElement(ReplyDate, null, reply.date)), /*#__PURE__*/ react.createElement(ReplyText, null, reply.text.trim()));
    };
    return /*#__PURE__*/ react.createElement(ReviewContentWrapper, null, /*#__PURE__*/ react.createElement(TextLabel, {
        id: reviewTextIdentifier,
        fullText: isExpanded
    }, /*#__PURE__*/ react.createElement(Text, {
        ref: textNode
    }, reviewText && reviewText.trim())), showMore && /*#__PURE__*/ react.createElement(ReadMore, {
        onClick: toggleExpansion,
        "aria-label": t("symbols", collapseOrExpand),
        "aria-expanded": isExpanded,
        "aria-controls": reviewTextIdentifier
    }, expansionText), translation && renderTranslation(), reply && renderReply());
};
/* harmony default export */ var review_text = (ReviewText);


/***/ }),

/***/ 80489:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": () => (/* binding */ UserAvatarClickableStyle),
/* harmony export */   "SD": () => (/* binding */ UserAvatarStyle),
/* harmony export */   "ZT": () => (/* binding */ USER_AVATAR_SIZE),
/* harmony export */   "jP": () => (/* binding */ ReviewUserAvatar)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25349);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89218);
/* harmony import */ var src_components_user_avatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60738);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96742);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var USER_AVATAR_SIZE = 32;
var UserAvatarStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(src_components_user_avatar__WEBPACK_IMPORTED_MODULE_3__/* .UserAvatar */ .Y).withConfig({
    displayName: "UserAvatarStyle",
    componentId: "sc-0-0"
})(_templateObject());
var UserAvatarClickableStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_2__/* .Clickable */ .P).withConfig({
    displayName: "UserAvatarClickableStyle",
    componentId: "sc-0-1"
})(_templateObject1());
var ReviewUserAvatar = function(param) {
    var userId = param.userId, userDisplayName = param.userDisplayName;
    var renderMode = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il).renderMode;
    var isRegisteredUser = Boolean(userId);
    var avatarProps = {
        displayName: userDisplayName,
        size: USER_AVATAR_SIZE,
        isLinked: isRegisteredUser
    };
    if (isRegisteredUser) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserAvatarClickableStyle, {
            to: "/user/".concat(userId),
            isExternal: renderMode === "native",
            onClick: function() {
                return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .trackInternalNavigationClick */ .p)({
                    scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.REVIEW_USER_CARD */ .U.REVIEW_USER_CARD,
                    nextPage: "/user/".concat(userId)
                });
            }
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserAvatarStyle, _extends({}, avatarProps)));
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserAvatarStyle, _extends({}, avatarProps));
};


/***/ }),

/***/ 97376:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": () => (/* binding */ ReviewUsername)
/* harmony export */ });
/* unused harmony export UsernameStyle */
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21541);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89218);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96742);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 156px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function getGuestUserForMarket(originMarket) {
    switch(originMarket){
        case "se":
        case "gb":
        case "fi":
        case "fr":
        case "no":
        case "nz":
        case "dk":
            return "user.guest-".concat(originMarket);
        default:
            return "user.guest";
    }
}
var UsernameStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_0__.BodySmallText).withConfig({
    displayName: "UsernameStyle",
    componentId: "sc-0-0"
})(_templateObject());
var ReviewUsername = function(param) {
    var userId = param.userId, userDisplayName = param.userDisplayName, originMarket = param.originMarket;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il), t = ref.t, renderMode = ref.renderMode;
    var usernameText = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(UsernameStyle, {
        container: "div",
        weight: _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_0__.FontWeight.HEAVIER,
        flex: false
    }, userDisplayName || t("reviews", getGuestUserForMarket(originMarket)));
    if (userId) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(src_components_clickable__WEBPACK_IMPORTED_MODULE_3__/* .Clickable */ .P, {
            to: "/user/".concat(userId),
            isExternal: renderMode === "native",
            onClick: function() {
                return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .trackInternalNavigationClick */ .p)({
                    scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.REVIEW_USER_CARD */ .U.REVIEW_USER_CARD,
                    nextPage: "/user/".concat(userId)
                });
            }
        }, usernameText);
    }
    return usernameText;
};


/***/ }),

/***/ 73498:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": () => (/* binding */ useReviewLikeHandler)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24828);
/* harmony import */ var src_areas_reviews_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1067);
/* harmony import */ var src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73426);




var selectLikedReviews = function(state) {
    var ref, ref1;
    return (ref = state.areas.account.me) === null || ref === void 0 ? void 0 : (ref1 = ref.likes) === null || ref1 === void 0 ? void 0 : ref1.reviews;
};
var useReviewLikeHandler = function(param) {
    var id = param.id, type = param.type;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var likedReviews = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(selectLikedReviews);
    var isAuthenticated = (0,src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_3__/* .useIsAuthenticated */ .k)();
    var liked = Boolean(likedReviews === null || likedReviews === void 0 ? void 0 : likedReviews.includes(id));
    var onLike = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (isAuthenticated) {
            dispatch((0,src_areas_reviews_actions__WEBPACK_IMPORTED_MODULE_2__/* .likeReviewToggle */ .eX)(id, type));
        }
    }, [
        dispatch,
        isAuthenticated,
        type,
        id
    ]);
    return {
        liked: liked,
        onLike: onLike
    };
};


/***/ }),

/***/ 28959:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ useReviewReportHandler)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var useReviewReportHandler = function(param) {
    var id = param.id;
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), 2), reportingReviewId = ref[0], setReportingReviewId = ref[1];
    var onReportIntent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setReportingReviewId(id);
    }, [
        id
    ]);
    var onReportCompleted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setReportingReviewId(null);
    }, []);
    return {
        reportingReviewId: reportingReviewId,
        onReportIntent: onReportIntent,
        onReportCompleted: onReportCompleted
    };
};


/***/ }),

/***/ 30979:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ product)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/edit/index.js
var edit = __webpack_require__(95370);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/flag-outlined/index.js
var flag_outlined = __webpack_require__(40173);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(71551);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/reviews/components/prompt/index.js
var components_prompt = __webpack_require__(32311);
// EXTERNAL MODULE: ./src/areas/reviews/components/report/index.js + 2 modules
var report = __webpack_require__(47239);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/like-button/index.tsx + 1 modules
var like_button = __webpack_require__(64873);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(34990);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(73426);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/components/user-review-card-v2/components/product-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 40px;\n  width: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 40px 1fr;\n  grid-template-rows: 1fr 1fr;\n  grid-gap: ",
        " ",
        ";\n  padding: ",
        ";\n  position: relative;\n  align-items: center;\n\n  ",
        " {\n    grid-area: 1 / 1 / 3 / 2;\n  }\n\n  ",
        " {\n    grid-area: 2 / 2 / 3 / 3;\n  }\n\n  ",
        " {\n    grid-area: 2 / 3 / 3 / 4;\n  }\n\n  &::after {\n    ",
        "\n    border-radius: 5px;\n    pointer-events: none;\n    transition: background-color 150ms ease;\n  }\n\n  &:hover {\n    &::after {\n      background-color: rgba(0, 0, 0, 0.07);\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var ProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-0"
})(_templateObject());
var Currency = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Currency",
    componentId: "sc-0-1"
})(_templateObject1());
var ProductRating = (0,styled_components_browser_esm["default"])(components_rating/* default */.Z).withConfig({
    displayName: "ProductRating",
    componentId: "sc-0-2"
})(_templateObject2());
var Product = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "Product",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, ProductImage, ProductRating, Currency, base/* styledUtils.overlay */.au.overlay());

;// CONCATENATED MODULE: ./src/components/user-review-card-v2/components/product-card/index.tsx



var UserReviewProductCard = function(param) {
    var name = param.name, image = param.image, rating = param.rating, ratingCount = param.ratingCount, price = param.price, pathName = param.pathName;
    return /*#__PURE__*/ react.createElement(Product, {
        to: pathName
    }, image && /*#__PURE__*/ react.createElement(ProductImage, null, /*#__PURE__*/ react.createElement("img", {
        width: 40,
        src: image,
        alt: ""
    })), /*#__PURE__*/ react.createElement("div", null, name), /*#__PURE__*/ react.createElement(ProductRating, {
        rate: rating,
        singleStar: true,
        showRate: true,
        showCounter: true,
        count: ratingCount,
        countTranslation: {
            domain: "product",
            key: "product-card.n-ratings"
        }
    }), price ? /*#__PURE__*/ react.createElement(Currency, null, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: price
    })) : null);
};

// EXTERNAL MODULE: ./src/components/user-review-card-v2/components/review-text/index.tsx + 1 modules
var review_text = __webpack_require__(61915);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/components/user/user-avatar.tsx
var user_avatar = __webpack_require__(80489);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/components/user/username.tsx
var username = __webpack_require__(97376);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/hooks/use-like-handler.ts
var use_like_handler = __webpack_require__(73498);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/hooks/use-report-handler.ts
var use_report_handler = __webpack_require__(28959);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/styles.ts
var styles = __webpack_require__(18082);
;// CONCATENATED MODULE: ./src/components/user-review-card-v2/product.tsx



















var ProductUserReviewCard = function(param) {
    var className = param.className, id = param.id, text = param.text, rating = param.rating, purchaseDate = param.purchaseDate, translation = param.translation, createdAt = param.createdAt, updatedAt = param.updatedAt, createdAtFromNow = param.createdAtFromNow, updatedAtFromNow = param.updatedAtFromNow, userId = param.userId, userDisplayName = param.userDisplayName, userReviewCount = param.userReviewCount, userAvatar = param.userAvatar, likes = param.likes, belongsTo = param.belongsTo, isMyReview = param.isMyReview, originMarket = param.originMarket, _product = param.product, product = _product === void 0 ? null : _product, _showProduct = param.showProduct, showProduct = _showProduct === void 0 ? false : _showProduct, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,use_report_handler/* useReviewReportHandler */.Q)({
        id: id
    }), reportingReviewId = ref5.reportingReviewId, onReportIntent = ref5.onReportIntent, onReportCompleted = ref5.onReportCompleted;
    var ref6 = (0,use_like_handler/* useReviewLikeHandler */.q)({
        id: id,
        type: "product"
    }), liked = ref6.liked, onLike = ref6.onLike;
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var ref7 = (0,react.useContext)(app_context/* AppContext */.Il), t = ref7.t, market = ref7.market;
    var isMine = isMyReview && isAuthenticated;
    var currentReview = (0,react.useMemo)(function() {
        return {
            id: id,
            rating: rating,
            reviewText: text,
            purchaseDate: purchaseDate
        };
    }, [
        id,
        rating,
        text,
        purchaseDate
    ]);
    // NOTE: Hides the purchase date on markets where this is not a requirement
    // because it does not accurately represent the actual date of purchase.
    // Should be fixed and enabled when the new review service is in place.
    var showPurchaseDate = Boolean((ref = market.modules) === null || ref === void 0 ? void 0 : (ref1 = ref.userReviewPurchaseDate) === null || ref1 === void 0 ? void 0 : ref1.enabled);
    var canLike = !isMine && (originMarket == null || originMarket === market.code);
    if (!id) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, reportingReviewId ? /*#__PURE__*/ react.createElement(report/* default */.Z, {
        review: reportingReviewId,
        onComplete: onReportCompleted
    }) : null, /*#__PURE__*/ react.createElement(styles/* UserReviewCard */.IR, {
        $expanded: expanded,
        className: className,
        containerProps: {
            "data-test": "UserReviewCard"
        }
    }, product && showProduct && /*#__PURE__*/ react.createElement(UserReviewProductCard, {
        name: product.name,
        image: (ref2 = product.media) === null || ref2 === void 0 ? void 0 : ref2.first,
        rating: ((ref3 = product.aggregatedRating) === null || ref3 === void 0 ? void 0 : ref3.score) || product.userReviewSummary.rating,
        ratingCount: ((ref4 = product.aggregatedRating) === null || ref4 === void 0 ? void 0 : ref4.count) || product.userReviewSummary.count,
        price: product.priceSummary.regular,
        pathName: product.pathName
    }), /*#__PURE__*/ react.createElement(styles/* UserInfo */.ao, null, /*#__PURE__*/ react.createElement(user_avatar/* ReviewUserAvatar */.jP, {
        userId: userId,
        userDisplayName: userDisplayName
    }), /*#__PURE__*/ react.createElement(styles/* UserInfoRow */.f9, null, /*#__PURE__*/ react.createElement(username/* ReviewUsername */.n, {
        userId: userId,
        userDisplayName: userDisplayName,
        originMarket: originMarket
    }), userReviewCount && userReviewCount > 0 ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles/* Divider */.iz, null), /*#__PURE__*/ react.createElement(styles/* UserInfoText */.Wn, {
        $bold: true
    }, t("reviews", "user.total-reviews", {
        n: userReviewCount
    }))) : null), /*#__PURE__*/ react.createElement(styles/* UserInfoRow */.f9, null, rating ? /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating
    }) : null, createdAt || updatedAt ? /*#__PURE__*/ react.createElement(styles/* UserInfoText */.Wn, {
        containerProps: {
            title: createdAt
        }
    }, updatedAt && t("reviews", "info.edited", {
        date: updatedAtFromNow || updatedAt
    }), !updatedAt && createdAt && t("reviews", "info.created", {
        date: createdAtFromNow || createdAt
    })) : null, showPurchaseDate && purchaseDate ? /*#__PURE__*/ react.createElement(react.Fragment, null, createdAt || updatedAt ? /*#__PURE__*/ react.createElement(styles/* Divider */.iz, null) : null, /*#__PURE__*/ react.createElement(styles/* UserInfoText */.Wn, null, t("reviews", "info.purchased", {
        date: purchaseDate
    }))) : null)), /*#__PURE__*/ react.createElement(styles/* Review */.Cq, null, Boolean(text) && /*#__PURE__*/ react.createElement(review_text/* default */.Z, {
        id: id,
        text: text,
        translation: translation
    })), showFooter ? /*#__PURE__*/ react.createElement(styles/* Footer */.$_, null, /*#__PURE__*/ react.createElement(styles/* FooterContent */.Bp, null, likes && isMine ? /*#__PURE__*/ react.createElement(styles/* Statistic */.$k, null, /*#__PURE__*/ react.createElement(styles/* ThumbsUpIcon */.lb, {
        size: 16
    }), " ", likes) : null, isMine ? /*#__PURE__*/ react.createElement(styles/* Edit */.I8, null, /*#__PURE__*/ react.createElement(components_prompt/* default */.Z, {
        belongsTo: belongsTo,
        currentReview: currentReview,
        control: /*#__PURE__*/ react.createElement(variants.TextButton, {
            size: variants.ButtonSize.SMALL
        }, /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(edit/* IconEdit */.y, null)), /*#__PURE__*/ react.createElement(variants.ButtonText, null, t("common", "button.edit")))
    })) : /*#__PURE__*/ react.createElement(react.Fragment, null, canLike && /*#__PURE__*/ react.createElement(like_button/* default */.Z, {
        onClick: onLike,
        liked: liked,
        likes: likes,
        size: styles/* ICON_SIZE */.ZG
    }), /*#__PURE__*/ react.createElement(styles/* ReportButton */.f4, {
        onClick: onReportIntent
    }, /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Left */.Nm.Left,
        title: t("feedback", "report-review.title")
    }, /*#__PURE__*/ react.createElement(flag_outlined/* IconFlagOutlined */.b, {
        size: 20
    })))))) : null));
};
/* harmony default export */ var product = (/*#__PURE__*/(0,react.memo)(ProductUserReviewCard));


/***/ }),

/***/ 86370:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25670);
/* harmony import */ var _prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1747);
/* harmony import */ var _prisjakt_ui_icon_edit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95370);
/* harmony import */ var _prisjakt_ui_icon_flag_outlined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40173);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21541);
/* harmony import */ var _prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71551);
/* harmony import */ var _prisjakt_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49452);
/* harmony import */ var src_areas_reviews_components_prompt__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32311);
/* harmony import */ var src_areas_reviews_components_report__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47239);
/* harmony import */ var src_areas_store_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67595);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25349);
/* harmony import */ var src_components_like_button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64873);
/* harmony import */ var src_components_rating_rating_helper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(51362);
/* harmony import */ var src_components_rating_smiley_rating_rating_icon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8354);
/* harmony import */ var src_components_rating_smiley_rating_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(53751);
/* harmony import */ var src_components_shop_link_card__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(30634);
/* harmony import */ var src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(73426);
/* harmony import */ var _components_review_text__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(61915);
/* harmony import */ var _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(80489);
/* harmony import */ var _components_user_username__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(97376);
/* harmony import */ var src_globals_tracking_conversion__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(23513);
/* harmony import */ var _hooks_use_like_handler__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(73498);
/* harmony import */ var _hooks_use_report_handler__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(28959);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(18082);

























var ShopUserReviewCard = function(param) {
    var className = param.className, id = param.id, text = param.text, rating = param.rating, reply = param.reply, replyDate = param.replyDate, createdAt = param.createdAt, updatedAt = param.updatedAt, createdAtFromNow = param.createdAtFromNow, updatedAtFromNow = param.updatedAtFromNow, userId = param.userId, userDisplayName = param.userDisplayName, userReviewCount = param.userReviewCount, userAvatar = param.userAvatar, likes = param.likes, belongsTo = param.belongsTo, store = param.store, _showStore = param.showStore, showStore = _showStore === void 0 ? false : _showStore, isMyReview = param.isMyReview, originMarket = param.originMarket, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, viaShop = param.viaShop;
    var ref = (0,_hooks_use_report_handler__WEBPACK_IMPORTED_MODULE_23__/* .useReviewReportHandler */ .Q)({
        id: id
    }), reportingReviewId = ref.reportingReviewId, onReportIntent = ref.onReportIntent, onReportCompleted = ref.onReportCompleted;
    var ref1 = (0,_hooks_use_like_handler__WEBPACK_IMPORTED_MODULE_22__/* .useReviewLikeHandler */ .q)({
        id: id,
        type: "store"
    }), liked = ref1.liked, onLike = ref1.onLike;
    var isAuthenticated = (0,src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_17__/* .useIsAuthenticated */ .k)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_11__/* .AppContext */ .Il), t = ref2.t, renderMode = ref2.renderMode;
    var isMine = isMyReview && isAuthenticated;
    var currentReview = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            id: id,
            rating: rating,
            reviewText: text
        };
    }, [
        id,
        rating,
        text
    ]);
    var reviewReply = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            name: belongsTo.name,
            text: reply,
            date: replyDate
        };
    }, [
        belongsTo.name,
        reply,
        replyDate
    ]);
    var ratingObject = src_components_rating_rating_helper__WEBPACK_IMPORTED_MODULE_13__/* ["default"].convert */ .Z.convert(rating || 0);
    var smileyRating = (0,src_components_rating_smiley_rating_utils__WEBPACK_IMPORTED_MODULE_15__/* .getSmileyRating */ .P)(ratingObject.rounded);
    var ratingText = t("reviews", smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.text);
    if (!id) return null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, reportingReviewId ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_areas_reviews_components_report__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        review: reportingReviewId,
        onComplete: onReportCompleted
    }) : null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .UserReviewCard */ .IR, {
        className: className,
        containerProps: {
            "data-test": "UserReviewCard",
            "data-test-rating": rating
        }
    }, store && showStore && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_shop_link_card__WEBPACK_IMPORTED_MODULE_16__/* .ShopLinkCard */ .E, {
        id: store.id,
        name: store.name,
        hasLogo: store.hasLogo,
        featured: store.featured,
        pathname: store.pathName,
        rating: store.userReviewSummary.rating,
        reviewCount: store.userReviewSummary.countTotal,
        renderMode: renderMode,
        logoUrl: store.logo,
        logoWidth: src_areas_store_constants__WEBPACK_IMPORTED_MODULE_10__/* .SHOP_LOGO_WIDTH */ .L9,
        trackingScope: src_globals_tracking_conversion__WEBPACK_IMPORTED_MODULE_21__/* .TrackClickScope.USER_REVIEW_CARD */ .b8.USER_REVIEW_CARD
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .UserInfo */ .ao, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_user_user_avatar__WEBPACK_IMPORTED_MODULE_19__/* .ReviewUserAvatar */ .jP, {
        userId: userId,
        userDisplayName: userDisplayName
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .UserInfoRow */ .f9, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_user_username__WEBPACK_IMPORTED_MODULE_20__/* .ReviewUsername */ .n, {
        userId: userId,
        userDisplayName: userDisplayName,
        originMarket: originMarket
    }), userReviewCount && userReviewCount > 0 ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .Divider */ .iz, null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .UserInfoText */ .Wn, {
        $bold: true
    }, t("reviews", "user.total-reviews", {
        n: userReviewCount
    }))) : null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .UserInfoRow */ .f9, null, rating && smileyRating ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_rating_smiley_rating_rating_icon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        type: smileyRating.iconType,
        ariaLabel: ratingText,
        disabled: false
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.BodySmallText, {
        flex: false
    }, ratingText)) : null, createdAt || updatedAt ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .UserInfoText */ .Wn, {
        containerProps: {
            title: createdAt
        }
    }, updatedAt && t("reviews", "info.edited", {
        date: updatedAtFromNow || updatedAt
    }), !updatedAt && createdAt && t("reviews", "info.created", {
        date: createdAtFromNow || createdAt
    })) : null, viaShop && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .ViaShop */ .zH, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .ViaShopTooltip */ .iK, {
        placement: _prisjakt_ui__WEBPACK_IMPORTED_MODULE_7__/* .Direction.Up */ .Nm.Up,
        title: t("reviews", "store.via-shop-tooltip")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_2__/* .IconInfoFilled */ .h, {
        size: 16,
        color: "maybeBlue700"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .ViaShopText */ .g0, null, t("reviews", "store.via-shop")))))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .Review */ .Cq, null, Boolean(text) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_review_text__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
        id: id,
        text: text,
        reply: reviewReply
    })), showFooter ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .Footer */ .$_, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .FooterContent */ .Bp, null, likes && isMine ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .Statistic */ .$k, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .ThumbsUpIcon */ .lb, {
        size: 16
    }), " ", likes) : null, isMine ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .Edit */ .I8, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_areas_reviews_components_prompt__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        belongsTo: belongsTo,
        currentReview: currentReview,
        store: store,
        control: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_1__.TextButton, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_1__.ButtonIcon, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_edit__WEBPACK_IMPORTED_MODULE_3__/* .IconEdit */ .y, null)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_1__.ButtonText, null, t("common", "button.edit")))
    })) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_like_button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        onClick: onLike,
        liked: liked,
        likes: likes,
        size: _styles__WEBPACK_IMPORTED_MODULE_24__/* .ICON_SIZE */ .ZG
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_24__/* .ReportButton */ .f4, {
        onClick: onReportIntent
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .Tooltip */ .u, {
        placement: _prisjakt_ui__WEBPACK_IMPORTED_MODULE_7__/* .Direction.Left */ .Nm.Left,
        title: t("feedback", "report-review.title")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_flag_outlined__WEBPACK_IMPORTED_MODULE_4__/* .IconFlagOutlined */ .b, {
        size: 20
    })))))) : null));
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(ShopUserReviewCard));


/***/ }),

/***/ 18082:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": () => (/* binding */ Footer),
/* harmony export */   "$k": () => (/* binding */ Statistic),
/* harmony export */   "Bp": () => (/* binding */ FooterContent),
/* harmony export */   "Cq": () => (/* binding */ Review),
/* harmony export */   "I8": () => (/* binding */ Edit),
/* harmony export */   "IR": () => (/* binding */ UserReviewCard),
/* harmony export */   "Wn": () => (/* binding */ UserInfoText),
/* harmony export */   "ZG": () => (/* binding */ ICON_SIZE),
/* harmony export */   "ao": () => (/* binding */ UserInfo),
/* harmony export */   "f4": () => (/* binding */ ReportButton),
/* harmony export */   "f9": () => (/* binding */ UserInfoRow),
/* harmony export */   "g0": () => (/* binding */ ViaShopText),
/* harmony export */   "iK": () => (/* binding */ ViaShopTooltip),
/* harmony export */   "iz": () => (/* binding */ Divider),
/* harmony export */   "lb": () => (/* binding */ ThumbsUpIcon),
/* harmony export */   "zH": () => (/* binding */ ViaShop)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29261);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21541);
/* harmony import */ var _prisjakt_ui_icon_like_filled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46304);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94141);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89218);
/* harmony import */ var src_components_rating_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80951);
/* harmony import */ var _prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71551);
/* harmony import */ var _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80489);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  align-items: flex-end;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  gap: ",
        ";\n  padding: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        " {\n      > div {\n        width: unset !important;\n        > img {\n          width: 12px !important;\n          height: 12px !important;\n        }\n      }\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0.4rem;\n  align-items: center;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  &::after {\n    color: ",
        ";\n    content: '|';\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n    line-height: 1.33333;\n    opacity: 1;\n    flex-grow: 0;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: ",
        "px 1fr;\n  grid-template-rows: auto auto;\n  column-gap: ",
        ";\n\n  p {\n    margin: 0;\n  }\n\n  a {\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  ",
        ", ",
        " {\n    grid-area: 1 / 1 / 3 / 2;\n    align-self: center;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: flex-start;\n  gap: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  fill: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n  position: relative;\n  font-weight: 600;\n\n  &:not(:last-of-type) {\n    margin-right: ",
        ";\n  }\n\n  ",
        " {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-left: auto;\n\n  path {\n    fill: ",
        ";\n  }\n\n  &:hover {\n    cursor: pointer;\n    path {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}









var ICON_SIZE = 20;
var Footer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Footer",
    componentId: "sc-0-0"
})(_templateObject());
var FooterContent = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FooterContent",
    componentId: "sc-0-1"
})(_templateObject1());
var Edit = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Edit",
    componentId: "sc-0-2"
})(_templateObject2());
var UserReviewCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_1__.Column).withConfig({
    displayName: "UserReviewCard",
    componentId: "sc-0-3"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, function(p) {
    return p.theme.colors.base200;
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var UserInfoRow = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "UserInfoRow",
    componentId: "sc-0-4"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .media.smallOnly */ .BC.smallOnly(_templateObject4(), src_components_rating_styles__WEBPACK_IMPORTED_MODULE_6__/* .StarsWrapper */ .gL));
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "Divider",
    componentId: "sc-0-5"
})(_templateObject6(), function(p) {
    return p.theme.text.quaternary;
});
var UserInfoText = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.CaptionText).withConfig({
    displayName: "UserInfoText",
    componentId: "sc-0-6"
})(_templateObject7(), function(p) {
    return p.$bold ? p.theme.colors.base500 : p.theme.colors.base400;
});
var UserInfo = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "UserInfo",
    componentId: "sc-0-7"
})(_templateObject8(), _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_8__/* .USER_AVATAR_SIZE */ .ZT, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.text.callToActionHover;
}, _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_8__/* .UserAvatarStyle */ .SD, _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_8__/* .UserAvatarClickableStyle */ .$t);
var Review = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_1__.Column).withConfig({
    displayName: "Review",
    componentId: "sc-0-8"
})(_templateObject9(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var ViaShop = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ViaShop",
    componentId: "sc-0-9"
})(_templateObject10(), function(p) {
    return p.theme.colors.maybeBlue700;
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall);
var ViaShopTooltip = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_7__/* .Tooltip */ .u).withConfig({
    displayName: "ViaShopTooltip",
    componentId: "sc-0-10"
})(_templateObject11());
var ViaShopText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "ViaShopText",
    componentId: "sc-0-11"
})(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var ThumbsUpIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_like_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconLikeFilled */ .G).withConfig({
    displayName: "ThumbsUpIcon",
    componentId: "sc-0-12"
})(_templateObject13(), function(p) {
    return p.theme.text.primary;
});
var Statistic = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Statistic",
    componentId: "sc-0-13"
})(_templateObject14(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, ThumbsUpIcon, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var ReportButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_5__/* .Clickable */ .P).withConfig({
    displayName: "ReportButton",
    componentId: "sc-0-14"
})(_templateObject15(), function(p) {
    return p.theme.buttons.link.text;
}, function(p) {
    return p.theme.buttons.link.textHover;
});


/***/ }),

/***/ 47252:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": () => (/* binding */ ListMobileColumnElseRow),
/* harmony export */   "U": () => (/* binding */ ColumnWithGutter)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_ui_list__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63226);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29261);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94141);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: row;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var ColumnWithGutter = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__.Column).withConfig({
    displayName: "ColumnWithGutter",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var ListMobileColumnElseRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list__WEBPACK_IMPORTED_MODULE_1__.List).withConfig({
    displayName: "ListMobileColumnElseRow",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .media.mediumUp */ .BC.mediumUp(_templateObject1()));


/***/ }),

/***/ 50132:
/***/ ((module) => {

module.exports = "query userLikeDislikeShops($shopIds: [Int!]) {\n  stores(ids: $shopIds, allowMissing: true) {\n    id\n    name\n    logo\n    pathName\n  }\n}"

/***/ }),

/***/ 66627:
/***/ ((module) => {

module.exports = "query userLists($isListsTab: Boolean = true, $userId: Int!, $limit: Int, $offset: Int, $sort: String) {\n  user(id: $userId) {\n    ...userLists\n  }\n}\n\nfragment userLists on UserProfile {\n  lists(offset: $offset, limit: $limit, sort: $sort) @include(if: $isListsTab) {\n    pageInfo {\n      limit\n      offset\n      hasNext\n      hasPrevious\n    }\n    nodes {\n      ...listItem\n    }\n  }\n}\n\nfragment listItem on ListItem {\n  id\n  ... on AlertProduct {\n    __typename\n    priceThreshold\n    alertType\n    priceStep\n    storePreference\n    storeGradeThreshold\n    product {\n      preloaded: __typename\n      id\n      name\n      stockStatus\n      category {\n        id\n        name\n      }\n      latestPriceChange {\n        time(fromNow: true)\n        amount\n      }\n      priceSummary {\n        regular\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      media {\n        first(width: _280)\n      }\n      pathName\n    }\n  }\n  ... on AlertSearch {\n    __typename\n    search {\n      id\n      name\n      filterId\n      pathName\n      productsCount\n    }\n  }\n  ...listProduct\n  ... on ListSearch {\n    __typename\n    quantity\n    search {\n      id\n      name\n      filterId\n      pathName\n      productsCount\n    }\n  }\n  ... on ListCategory {\n    __typename\n    name\n    created(fromNow: true)\n    icon\n    pathName\n    itemsCount\n    priceSummary\n    inventory\n    visibility\n  }\n}\n\nfragment listProduct on ListProduct {\n  __typename\n  quantity\n  product {\n    preloaded: __typename\n    id\n    name\n    description\n    category {\n      id\n      name\n    }\n    priceSummary {\n      regular\n      alternative\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _280)\n    }\n    pathName\n  }\n}"

/***/ }),

/***/ 12155:
/***/ ((module) => {

module.exports = "query subscriptionSettings {\n  me {\n    subscriptionSettings {\n      title\n      description\n      channels {\n        mail {\n          id\n          subscribed\n        }\n        push {\n          id\n          subscribed\n        }\n      }\n    }\n  }\n}"

/***/ }),

/***/ 68386:
/***/ ((module) => {

module.exports = "mutation unsubscribeLandingPage($id: ID!, $subscribed: Boolean!, $userID: ID!, $hash: String!) {\n  updateSubscriptionSetting(\n    id: $id\n    subscribed: $subscribed\n    userID: $userID\n    hash: $hash\n  ) {\n    title\n  }\n}"

/***/ }),

/***/ 40877:
/***/ ((module) => {

module.exports = "query EntitySearchComponent($query: String!, $stores: Boolean!, $products: Boolean!) {\n  newSearch(query: $query) {\n    query\n    results {\n      products(limit: 5) @skip(if: $stores) {\n        nodes {\n          ... on Product {\n            __typename\n            id\n            name\n            pathName\n            userReviewSummary {\n              rating\n              count\n            }\n            aggregatedRating {\n              score\n              count\n            }\n            priceSummary {\n              regular\n              alternative\n              count\n            }\n            media {\n              first(width: _280)\n            }\n            category {\n              name\n            }\n          }\n        }\n      }\n      shops(limit: 5) @skip(if: $products) {\n        nodes {\n          __typename\n          id\n          name\n          pathName\n          hasLogo\n          logo(width: _88)\n        }\n      }\n    }\n  }\n}"

/***/ })

}]);